webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _ticker = __webpack_require__(19);

var _ticker2 = _interopRequireDefault(_ticker);

var _scroller = __webpack_require__(18);

var _scroller2 = _interopRequireDefault(_scroller);

var _Globals = __webpack_require__(16);

var _Globals2 = _interopRequireDefault(_Globals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Scrollable = function () {
	function Scrollable() {
		(0, _classCallCheck3.default)(this, Scrollable);
	}

	(0, _createClass3.default)(Scrollable, [{
		key: 'mounted',
		value: function mounted() {

			this.offset = 0;
			this.bounds = {
				top: 0,
				height: 0,
				bottom: 0
			};
			this.active = false;
			this.perc = 0;
			this.progress = 0;
			this.isResized = false;

			if (_Globals2.default.isLoaded) {
				this.init();
			}

			this._bind();
			this.$events.on('app.loaded', this.init);
		}
	}, {
		key: 'beforeDestroy',
		value: function beforeDestroy() {
			this._off();
		}
	}, {
		key: 'init',
		value: function init() {

			this.scroller = new _scroller2.default();
			this.ticker = new _ticker2.default();

			this._on();

			this._resize();
		}
	}, {
		key: 'initTimeline',
		value: function initTimeline() {

			this.fakeAnim = { value: 0 };

			this.tl = new TimelineMax({ paused: true });
			this.tl.time(this.progress);

			this.tlAppear = new TimelineMax({ paused: true });
		}
	}, {
		key: '_bind',
		value: function _bind() {
			this.init = this.init.bind(this);
			this.resize = this._resize.bind(this);
		}
	}, {
		key: '_on',
		value: function _on() {
			this.scroller.register(this);
			this.$events.on('app.resize', this._resize);
		}
	}, {
		key: 'raf',
		value: function raf(y) {
			this.isInViewport = this.scroller.isInViewport(this.bounds.top, this.bounds.height);
			if (!this.isInViewport && (this.perc >= 1 || this.perc <= 0)) return;
			this.perc = this.boundsAnim ? this.scroller.getPerc(this.boundsAnim, y) : 0;
			this.tl && this.tl.progress(this.perc);
		}
	}, {
		key: '_off',
		value: function _off() {
			console.log('off');
			this.$events.off('app.loaded');
			this.$events.off('app.resize');
			this.scroller.unRegister(this);
		}
	}, {
		key: '_resize',
		value: function _resize() {

			this.bounds.top = Math.floor((0, _jquery2.default)(this.$el).offset().top - this.scroller.scroll.lerped);
			this.bounds.height = this.$el.getBoundingClientRect().height;
			this.bounds.bottom = this.bounds.top + this.bounds.height;

			if (this.tl) {
				this.progress = this.tl.time();
				this.tl.kill();
			}

			if (this.tlAppear) {
				this.tlAppear.kill();
			}

			this.isResized = false;
		}
	}]);
	return Scrollable;
}();

exports.default = Scrollable;

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Globals = function () {
    function Globals() {
        (0, _classCallCheck3.default)(this, Globals);
        Object.defineProperty(this, "breakpoints", {
            enumerable: true,
            writable: true,
            value: {
                tablet: 992,
                mobile: 640
            }
        });
        Object.defineProperty(this, "baseSizes", {
            enumerable: true,
            writable: true,
            value: {
                height: 900,
                width: 1440
            }
        });
        Object.defineProperty(this, "isLoaded", {
            enumerable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isScrolling", {
            enumerable: true,
            writable: true,
            value: false
        });


        this.state = {
            isMobile: false,
            isTablet: false,
            window: {
                width: 0,
                height: 0
            },
            isLoaded: false
        };

        this.resize();
    }

    (0, _createClass3.default)(Globals, [{
        key: "resize",
        value: function resize() {

            var w = window.innerWidth;
            var h = window.innerHeight;

            this.isMobile = w;
            this.isTablet = w;
            this.width = w;
            this.height = h;
        }
    }, {
        key: "responsiveHeight",
        value: function responsiveHeight(h) {
            return Math.floor(h * window.innerHeight / this.baseSizes.height);
        }
    }, {
        key: "responsiveWidth",
        value: function responsiveWidth(w) {
            return Math.floor(w * window.innerWidth / this.baseSizes.width);
        }
    }, {
        key: "width",
        get: function get() {
            return this.state.window.width;
        },
        set: function set(val) {
            this.state.window.width = val;
        }
    }, {
        key: "height",
        get: function get() {
            return this.state.window.height;
        },
        set: function set(val) {
            this.state.window.height = val;
        }
    }, {
        key: "isMobile",
        get: function get() {
            return this.state.isMobile;
        },
        set: function set(val) {
            this.state.isMobile = val < this.breakpoints.mobile ? true : false;
        }
    }, {
        key: "isTablet",
        get: function get() {
            return this.state.isTablet;
        },
        set: function set(val) {
            this.state.isTablet = val < this.breakpoints.tablet ? true : false;
        }
    }]);
    return Globals;
}();

exports.default = new Globals();

/***/ }),
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _ticker = __webpack_require__(19);

var _ticker2 = _interopRequireDefault(_ticker);

var _quarkRaf = __webpack_require__(122);

var _quarkRaf2 = _interopRequireDefault(_quarkRaf);

var _virtualScroll = __webpack_require__(249);

var _virtualScroll2 = _interopRequireDefault(_virtualScroll);

var _Globals = __webpack_require__(16);

var _Globals2 = _interopRequireDefault(_Globals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONFIG = {
	min: 0,
	max: 1000,
	ease: 0.2
};

var Scroller = function () {

	/**
  * Create scroll instance
  * @name constructor
  * @param {Object} config The configuration object
  * @return {Scroll} the scroller instance
  */

	function Scroller(config) {
		(0, _classCallCheck3.default)(this, Scroller);


		// Instance
		if (Scroller.instance) {
			return Scroller.instance;
		} else {
			Scroller.instance = this;
		}

		// Config
		this.config = {};
		_lodash2.default.extend(this.config, CONFIG, config);

		// Properties
		this.is = {
			active: false,
			waiting: false,
			animating: false,
			scrolling: true
		};

		this.timer = null;

		this.components = [];

		this.last = Date.now();

		this.intervals = [];
		this.points = [];

		this.scroll = { position: 0, previous: 0, direction: 1, delta: 0, lerped: 0 };

		// Prevent natural mobile scroll behavior
		document.addEventListener('touchmove', function (e) {
			e.preventDefault();
		});

		this.height = Math.abs(this.config.el.getBoundingClientRect().height - this.config.el.getBoundingClientRect().top) - window.innerHeight;

		this.virtualScroll = new _virtualScroll2.default({
			mouseMultiplier: .45,
			firefoxMultiplier: 50
		});

		this.virtualScroll.on(this._onScroll.bind(this));

		this.ticker = new _ticker2.default();

		this.raf = this.raf.bind(this);
		_quarkRaf2.default.add(this.raf);

		// Launch
		this.play();

		return this;
	}

	/**
 * Reload the Scroller instance
 * @name reload
 * @params {Object} config The new configuration object
 * @return {Scroll} The Scroller instance
 */

	(0, _createClass3.default)(Scroller, [{
		key: 'reload',
		value: function reload(config) {

			this.config = {};
			_lodash2.default.extend(this.config, CONFIG, config);
			(0, _jquery2.default)(document.body).height(Math.abs(this.config.max - this.config.min));

			return this;
		}

		/**
   * Active the Scroller instance
   * @name play
   * @return {Scroller} The created Scroller instance
   */

	}, {
		key: 'play',
		value: function play() {
			var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;


			this.is.active = true;
			if (position != null) {
				this.scroll.position = position;
			}

			return this;
		}
	}, {
		key: 'raf',
		value: function raf() {
			var _this = this;

			this.scroll.previousLerped = this.scroll.lerped;
			this.direction = this.scroll.position - this.scroll.lerped < 0 ? 1 : -1;
			this.direction = this.scroll.position == this.scroll.lerped ? 0 : this.direction;
			// this.scroll.lerped += (this.scroll.position - this.scroll.lerped);
			this.scroll.lerped += (this.scroll.position - this.scroll.lerped) * this.config.ease;
			this.scroll.delta = Math.abs(this.scroll.position - this.scroll.lerped);

			_Globals2.default.scroll = this.scroll.lerped;

			// if (Math.floor(this.scroll.lerped) === Math.floor(this.scroll.position)) {
			// 	Globals.isScrolling = false
			// 	return
			// }

			// if (!Globals.isScrolling) Globals.isScrolling = true

			if (!this.is.scrolling && !this.is.animating) return;

			for (var key in this.intervals) {
				this.checkInterval(this.intervals[key]);
			}

			this.components.forEach(function (w) {
				w.raf && w.raf(_this.scroll.lerped);
			});
		}
	}, {
		key: 'getPerc',
		value: function getPerc(bounds, y) {
			var h = bounds.bottom - bounds.top;
			var pct = _lodash2.default.clamp((-y - bounds.top) / h, 0, 1);

			return pct;
		}
	}, {
		key: 'register',
		value: function register(component) {
			if (this.components.indexOf(component) === -1) {
				this.components.push(component);
			}
		}
	}, {
		key: 'unRegister',
		value: function unRegister(component) {
			if (this.components.indexOf(component) >= 0) {
				this.components.filter(function (item) {
					return item != component;
				});
			}
		}
	}, {
		key: 'isInViewport',
		value: function isInViewport(elOffset, height) {
			var start = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window.innerHeight;

			return this.scroll.lerped + elOffset < start && this.scroll.lerped + elOffset + height > 0;
		}

		/**
   * Pause the Scroller instance
   * @name pause
   * @return {Scroller} The created Scroller instance 
   */

	}, {
		key: 'pause',
		value: function pause() {

			this.is.active = false;

			return this;
		}

		/**
   * Make the Scroller instance wait for next user action
   * @name wait
   * @return {Scroller} The Scroller instance
   */

	}, {
		key: 'wait',
		value: function wait() {

			this.is.waiting = true;

			return this;
		}

		/**
   * Go to a specific position
   * @name to
   * @param {Int} target The position to go on
   * @param {Int} duration The duration of the animation (in milliseconds)
   * @return {Scroller} The Scroller instance
   */

	}, {
		key: 'to',
		value: function to(target) {
			var _this2 = this;

			var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;


			// Animation
			this.is.animating = true;
			var scroll = { position: Math.abs(this.scroll.position) };
			_gsap.TweenMax.to(scroll, duration / 1000, {
				position: target, ease: Strong.easeOut, onUpdate: function onUpdate() {

					_this2.scroll.delta = scroll.position + _this2.scroll.position;
					_this2.scroll.direction = _this2.scroll.delta > 0 ? 1 : -1;
					_this2.scroll.previous = _this2.scroll.position;
					_this2.scroll.position = -scroll.position;

					for (var key in _this2.points) {
						_this2.checkPoint(_this2.points[key]);
					}
				}
			});

			return this;
		}

		/**
   * OnScroll behavior
   * @name [name]
   */

	}, {
		key: '_onScroll',
		value: function _onScroll(e) {
			var _this3 = this;

			if (!this.is.active) {
				return false;
			}

			this.scroll.previous = this.scroll.position;

			this.scroll.position += e.deltaY;
			this.scroll.position = Math.max(this.height * -1, this.scroll.position);
			this.scroll.position = Math.min(0, this.scroll.position);
			// this.scroll.delta = e.deltaY

			this.scroll.direction = -e.deltaY > 0 ? 1 : -1;

			if (this.is.waiting) {
				if (e.delta == 0) {
					this.is.waiting = false;
				}return false;
			}

			// Statics
			Scroller.position = this.scroll.position;
			Scroller.delta = e.deltaY;

			this.timer && clearInterval(this.timer);
			this.timer = window.setInterval(function () {

				if (Math.round(_this3.scroll.position * 100) / 100 === Math.round(_this3.scroll.lerped * 100) / 100) {
					_this3.is.scrolling = false;
					_this3.timer && clearInterval(_this3.timer);
				}
			}, 500);

			if (!this.is.scrolling) this.is.scrolling = true;

			// Points
			for (var key in this.points) {
				this.checkPoint(this.points[key]);
			}
		}
	}, {
		key: 'resize',
		value: function resize() {

			if (!this.is.scrolling) this.is.scrolling = true;
			this.height = Math.abs(this.config.el.getBoundingClientRect().height - (this.config.el.getBoundingClientRect().top - this.scroll.position)) - window.innerHeight;
			for (var key in this.points) {
				this.checkPoint(this.points[key]);
			}
		}

		/**
   * Register interval event
   * @name interval
   * @param {String} name The name of the event handler
   * @param {Object} config The config of the point event
   * @return {Boolean} The result of the registering
   */

	}, {
		key: 'interval',
		value: function interval(name, config) {

			if (this.intervals[name]) delete this.intervals[name];

			config.distance = Math.abs(config.end - config.start);
			config.position = this.scroll.position;
			this.intervals[name] = config;

			return true;
		}

		/**
   * Register point event
   * @name point
   * @param {Object} params The params of the point event
   * @return {Boolean} The result of the registering
   */

	}, {
		key: 'point',
		value: function point(name, config) {

			if (this.points[name]) delete this.points[name];

			var point = {
				position: 0,
				direction: false,
				onAnimation: true
			};
			_lodash2.default.extend(point, config);

			this.points[name] = point;

			return true;
		}

		/**
   * Check if interval should be executed
   * @name checkInterval
   * @param {Object} event The event object to check
   */

	}, {
		key: 'checkInterval',
		value: function checkInterval(i) {

			if (!this.is.active) {
				return false;
			}

			var scrollStart = -this.scroll.lerped - i.start;
			var perc = Math.min(Math.max(0, scrollStart / Math.abs(i.distance)), 1);

			// Data
			var event = {
				scroll: this.scroll.lerped,
				offset: _lodash2.default.clamp(scrollStart, 0, i.distance),
				direction: this.direction,
				base: i,
				delta: this.scroll.delta
			};

			event.ratio = perc;
			event.isInside = _lodash2.default.inRange(-event.scroll, i.start - window.innerHeight, i.end + window.innerHeight);

			if (event.isInside) {
				i.exec(event);
			}
		}

		/**
   * Check if point callback should be executed
   * @name checkPoint
   * @param {Object} point The point object to check
   */

	}, {
		key: 'checkPoint',
		value: function checkPoint(p) {

			// Data
			if (this.is.animating && !p.onAnimation) {
				return false;
			}
			if (!_lodash2.default.inRange(p.position, -this.scroll.previousLerped, -this.scroll.lerped)) {
				return false;
			}
			if (_lodash2.default.isFinite(p.direction) && p.direction != this.scroll.direction) {
				return false;
			}

			// Execute callback
			p.exec({
				scroll: this.scroll.lerped,
				direction: this.direction,
				delta: this.scroll.delta
			});
		}
	}, {
		key: 'removePoint',
		value: function removePoint(name) {

			delete this.points[name];

			return true;
		}
	}]);
	return Scroller;
}();

Object.defineProperty(Scroller, 'instance', {
	enumerable: true,
	writable: true,
	value: undefined
});
Object.defineProperty(Scroller, 'position', {
	enumerable: true,
	writable: true,
	value: 0
});
Object.defineProperty(Scroller, 'delta', {
	enumerable: true,
	writable: true,
	value: 0
});
exports.default = Scroller;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Ticker = function () {

	/**
  * Constructor
  * @return {Ticker} the ticker instance
  */

	function Ticker() {
		(0, _classCallCheck3.default)(this, Ticker);


		// Singleton
		if (!Ticker.instance) {
			Ticker.instance = this;
		} else {
			return Ticker.instance;
		}

		// Properties
		this.ticks = [];
		this.ticksLength = 0;
		this.frame = null;
		this.is = { framing: false };

		return this;
	}

	/**
  * Frame event function
  * @return {Ticker} the ticker instance
  */

	(0, _createClass3.default)(Ticker, [{
		key: 'framer',
		value: function framer() {
			var _this = this;

			// Browse callbacks
			_lodash2.default.forIn(this.ticks, function (tick) {
				if (tick.pause) {
					return false;
				}
				tick.func();
			});

			// Animation loop
			this.frame = window.requestAnimationFrame(function () {
				return _this.framer();
			});
		}

		/**
   * Tick a new function
   * @param {String} name the function name
   * @param {Function} func the function to execute at each frame
   * @param {Int} duration the optional duration of the tick
   * @return {Ticker} the ticker instance
   */

	}, {
		key: 'tick',
		value: function tick(name, func) {
			var _this2 = this;

			var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;


			// Register
			if (!this.ticks[name]) {
				this.ticksLength++;
			}
			this.ticks[name] = { name: name, func: func, duration: duration, pause: false };

			// Animation looop
			if (!this.is.framing) {
				this.frame = window.requestAnimationFrame(function () {
					return _this2.framer();
				});
				this.is.framing = true;
			}

			return this;
		}

		/**
   * Remove a function
   * @param {String} name the name of the function to remove
   * @return {Ticker} the ticker instance
   */

	}, {
		key: 'remove',
		value: function remove(name) {

			// Unregister
			if (this.ticks[name]) {
				delete this.ticks[name];this.ticksLength--;
			}

			// Animation loop
			if (this.ticksLength < 1) {
				window.cancelAnimationFrame(this.frame);
				this.is.framing = false;
			}

			return this;
		}

		/**
   * Pause a function
   * @param {String} name the name of the function to pause
   * @return {Ticker} the ticker instance
   */

	}, {
		key: 'pause',
		value: function pause(name) {

			if (!this.ticks[name]) {
				return this;
			}
			this.ticks[name].pause = true;

			return this;
		}

		/**
   * Play a function
   * @param {String} name the name of the function to play
   * @return {Ticker} the ticker instance
   */

	}, {
		key: 'play',
		value: function play(name) {

			if (!this.ticks[name]) {
				return this;
			}
			this.ticks[name].pause = false;

			return this;
		}
	}, {
		key: 'hasTick',
		value: function hasTick(name) {

			if (!this.ticks[name]) {
				return false;
			} else {
				return true;
			}
		}
	}]);
	return Ticker;
}();

Object.defineProperty(Ticker, 'instance', {
	enumerable: true,
	writable: true,
	value: undefined
});
exports.default = Ticker;

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_background_vue__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_background_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_background_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_295e15e6_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_background_vue__ = __webpack_require__(410);
function injectStyle (ssrContext) {
  __webpack_require__(407)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_background_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_295e15e6_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_background_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Section = function (_Scrollable) {
	(0, _inherits3.default)(Section, _Scrollable);

	function Section() {
		(0, _classCallCheck3.default)(this, Section);
		return (0, _possibleConstructorReturn3.default)(this, (Section.__proto__ || (0, _getPrototypeOf2.default)(Section)).apply(this, arguments));
	}

	(0, _createClass3.default)(Section, [{
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(Section.prototype.__proto__ || (0, _getPrototypeOf2.default)(Section.prototype), 'mounted', this).call(this);
		}
	}, {
		key: 'init',
		value: function init() {

			(0, _get3.default)(Section.prototype.__proto__ || (0, _getPrototypeOf2.default)(Section.prototype), 'init', this).call(this);
		}
	}, {
		key: '_resize',
		value: function _resize() {}
	}]);
	return Section;
}(_scrollable2.default);

exports.default = Section;

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_splited_text_vue__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_splited_text_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_splited_text_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7171e1e0_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_splited_text_vue__ = __webpack_require__(428);
function injectStyle (ssrContext) {
  __webpack_require__(424)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_splited_text_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7171e1e0_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_splited_text_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _promise = __webpack_require__(101);

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _pixi = __webpack_require__(25);

var PIXI = _interopRequireWildcard(_pixi);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssetsLoader = function () {
	function AssetsLoader() {
		(0, _classCallCheck3.default)(this, AssetsLoader);
		Object.defineProperty(this, 'loaded', {
			enumerable: true,
			writable: true,
			value: []
		});


		this.baseUrl = '/';
		// this.baseUrl = process.env.NODE_ENV === "production" ? '/story/joey-bada$$-political-mc/' : '/'
	}

	(0, _createClass3.default)(AssetsLoader, [{
		key: 'loadAll',
		value: function loadAll(array, callback, progress) {
			var _this = this;

			this.progress = progress || null;
			this.amount = 0;
			this.length = array.length;

			var promises = [];

			_lodash2.default.forIn(array, function (asset) {
				if (asset.type === "image") promises.push(_this.load(asset));
				// else if (assets.type === "pixi") promo
			});

			_promise2.default.all(promises).then(function () {
				callback();
			});
		}
	}, {
		key: 'load',
		value: function load(asset) {
			var _this2 = this;

			return new _promise2.default(function (resolve) {

				var img = new Image();

				img.addEventListener('load', function (e) {

					var path = e.path ? e.path[0] : e.target;

					_this2.loaded[asset.name] = {
						img: img,
						src: asset.src,
						width: path.width,
						height: path.height
					};

					_this2.amount++;
					_this2.progress && _this2.progress({
						amount: _this2.amount,
						length: _this2.length
					});

					resolve();
				}, false);

				img.src = _this2.baseUrl + asset.url;
			});
		}
	}, {
		key: 'getLoadedAsset',
		value: function getLoadedAsset(name) {
			return this.loaded[name];
		}
	}]);
	return AssetsLoader;
}();

exports.default = new AssetsLoader();

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_intro_vue__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_intro_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_intro_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c014716_hasScoped_true_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_section_intro_vue__ = __webpack_require__(423);
function injectStyle (ssrContext) {
  __webpack_require__(420)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c014716"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_intro_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c014716_hasScoped_true_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_section_intro_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_flags_overlay_vue__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_flags_overlay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_flags_overlay_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2355620a_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_flags_overlay_vue__ = __webpack_require__(458);
function injectStyle (ssrContext) {
  __webpack_require__(449)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_flags_overlay_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2355620a_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_flags_overlay_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quote_vue__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quote_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quote_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f1a1f97_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_quote_vue__ = __webpack_require__(474);
function injectStyle (ssrContext) {
  __webpack_require__(471)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quote_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f1a1f97_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_quote_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_responsive_image_vue__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_responsive_image_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_responsive_image_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a535ebe_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_responsive_image_vue__ = __webpack_require__(478);
function injectStyle (ssrContext) {
  __webpack_require__(475)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_responsive_image_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a535ebe_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_responsive_image_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_image_cover_vue__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_image_cover_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_image_cover_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6145cfda_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_image_cover_vue__ = __webpack_require__(437);
function injectStyle (ssrContext) {
  __webpack_require__(434)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_image_cover_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6145cfda_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_image_cover_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_youth_presentation_vue__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_youth_presentation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_youth_presentation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6997169e_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_youth_presentation_vue__ = __webpack_require__(484);
function injectStyle (ssrContext) {
  __webpack_require__(468)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_youth_presentation_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6997169e_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_youth_presentation_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackgroundTools = function () {
	function BackgroundTools() {
		(0, _classCallCheck3.default)(this, BackgroundTools);
	}

	(0, _createClass3.default)(BackgroundTools, null, [{
		key: "Cover",
		value: function Cover(iw, ih, cw, ch) {

			var over = iw / ih;
			var under = ih / iw;
			var cRatio = cw / ch;

			var w = void 0,
			    h = void 0,
			    pos = { x: 0, y: 0 };

			if (cRatio >= over) {
				w = cw;
				h = Math.ceil(under * cw);
				pos.y = Math.abs(under * cw - ch) / -2;
			} else {
				w = Math.ceil(over * ch);
				h = ch;
				pos.x = Math.abs(over * ch - cw) / -2;
			}

			return { w: w, h: h, pos: pos };
		}
	}]);
	return BackgroundTools;
}();

exports.default = BackgroundTools;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GlobalMixin = undefined;

var _Globals = __webpack_require__(16);

var _Globals2 = _interopRequireDefault(_Globals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GlobalMixin = exports.GlobalMixin = {
    data: function data() {
        return {
            state: _Globals2.default.state
        };
    },
    computed: {
        isMobile: function isMobile() {
            return this.state.isMobile;
        },
        isTablet: function isTablet() {
            return this.state.isTablet;
        }
    }
};

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_story_text_vue__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_story_text_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_story_text_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5eb3f47a_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_story_text_vue__ = __webpack_require__(584);
function injectStyle (ssrContext) {
  __webpack_require__(581)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_story_text_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5eb3f47a_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_story_text_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_video_element_vue__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_video_element_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_video_element_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2471cb9b_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_video_element_vue__ = __webpack_require__(593);
function injectStyle (ssrContext) {
  __webpack_require__(590)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_video_element_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2471cb9b_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_video_element_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_close_button_vue__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_close_button_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_close_button_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f831626_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_close_button_vue__ = __webpack_require__(624);
function injectStyle (ssrContext) {
  __webpack_require__(621)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_close_button_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f831626_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_close_button_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(186);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _vueEvents = __webpack_require__(187);

var _vueEvents2 = _interopRequireDefault(_vueEvents);

var _vueTouch = __webpack_require__(188);

var _vueTouch2 = _interopRequireDefault(_vueTouch);

var _vueMultilanguage = __webpack_require__(190);

var _vueMultilanguage2 = _interopRequireDefault(_vueMultilanguage);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _app = __webpack_require__(191);

var _app2 = _interopRequireDefault(_app);

var _routes = __webpack_require__(638);

var _routes2 = _interopRequireDefault(_routes);

var _vueMq = __webpack_require__(639);

var _vueMq2 = _interopRequireDefault(_vueMq);

var _french = __webpack_require__(642);

var _french2 = _interopRequireDefault(_french);

var _english = __webpack_require__(643);

var _english2 = _interopRequireDefault(_english);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vueTouch2.default, { name: 'v-touch' });
var routing = new _vueRouter2.default({
	mode: 'history',
	root: '/',
	routes: _routes2.default
});

_vueTouch2.default.config.swipe = {
	direction: 'horizontal'
};

_vue2.default.use(_vueEvents2.default);

_vue2.default.use(_vueMultilanguage2.default, {
	default: 'fr',
	fr: _french2.default,
	en: _english2.default
});

_vue2.default.use(_vueMq2.default, {
	breakpoints: {
		mobile: 450,
		tablet: 900,
		desktop: Infinity
	}
});

new _vue2.default({
	el: '#app',
	router: routing,
	render: function render(h) {
		return h(_app2.default);
	}
});

if ('scrollRestoration' in history) {
	history.scrollRestoration = 'manual';
}

/***/ }),
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_417bf032_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__(637);
function injectStyle (ssrContext) {
  __webpack_require__(192)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_417bf032_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(193);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("31688132", content, true, {});

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Saira+Extra+Condensed:300,700);", ""]);
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Poppins:400,600,700,900);", ""]);
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Abhaya+Libre:400,500,700);", ""]);

// module
exports.push([module.i, "a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0}border 0{font-size:100%;font:inherit;vertical-align:baseline;outline:none}*{box-sizing:border-box;-webkit-tap-highlight-color:rgba(0,0,0,0)}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block}body{line-height:1}ol,ul{list-style:none}blockquote,q{quotes:none}blockquoteafter,blockquotebefore,qafter,qbefore{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}body,html{display:block;width:100%;height:100%;overflow:hidden;font-family:Poppins,sans-serif;font-size:16px;font-weight:600;color:#000}@media screen and (min-width:1700px){body,html{font-size:1vw}}@media screen and (max-width:992px){body,html{font-size:12px}}@media screen and (max-width:640px){body,html{font-size:16px}}body{background-color:#232323}.section{z-index:20}#container,.section{width:100%;position:relative}#container{height:100%;top:0;left:0;overflow:hidden}#container .section{position:relative;width:100%}@media screen and (max-width:640px){#container .section{padding-left:30px;padding-right:30px}}.story-page:after,.story-page:before{display:none!important}.landing{position:absolute;top:0;left:0;width:100vw;height:100%;overflow:hidden}.landing .loader{height:100%;width:100%;top:-100vh;left:0;position:fixed;z-index:100}.landing .mask-wrapper{position:absolute;top:0;left:0;right:0;bottom:0;z-index:70;pointer-events:none}.landing .mask-wrapper img{object-fit:cover;height:100%;width:100%}.landing-container{position:absolute;top:0;left:0;width:100%;will-change:transform;min-height:100vh;z-index:60;transform-origin:top center}.landing-container .desktop-version{position:relative;width:100%}", ""]);

// exports


/***/ }),
/* 194 */,
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _promise = __webpack_require__(101);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scroller = __webpack_require__(18);

var _scroller2 = _interopRequireDefault(_scroller);

var _Globals = __webpack_require__(16);

var _Globals2 = _interopRequireDefault(_Globals);

var _loader = __webpack_require__(255);

var _loader2 = _interopRequireDefault(_loader);

__webpack_require__(363);

var _fontfaceobserver = __webpack_require__(367);

var _fontfaceobserver2 = _interopRequireDefault(_fontfaceobserver);

var _header = __webpack_require__(368);

var _header2 = _interopRequireDefault(_header);

var _scrollIndicator = __webpack_require__(383);

var _scrollIndicator2 = _interopRequireDefault(_scrollIndicator);

var _intro = __webpack_require__(388);

var _intro2 = _interopRequireDefault(_intro);

var _presentation = __webpack_require__(403);

var _presentation2 = _interopRequireDefault(_presentation);

var _political = __webpack_require__(412);

var _political2 = _interopRequireDefault(_political);

var _youth = __webpack_require__(460);

var _youth2 = _interopRequireDefault(_youth);

var _proEra = __webpack_require__(488);

var _proEra2 = _interopRequireDefault(_proEra);

var _badassOrigins = __webpack_require__(506);

var _badassOrigins2 = _interopRequireDefault(_badassOrigins);

var _amerikkkan = __webpack_require__(551);

var _amerikkkan2 = _interopRequireDefault(_amerikkkan);

var _landOfFree = __webpack_require__(567);

var _landOfFree2 = _interopRequireDefault(_landOfFree);

var _racism = __webpack_require__(572);

var _racism2 = _interopRequireDefault(_racism);

var _engagement = __webpack_require__(597);

var _engagement2 = _interopRequireDefault(_engagement);

var _program = __webpack_require__(612);

var _program2 = _interopRequireDefault(_program);

var _background = __webpack_require__(30);

var _background2 = _interopRequireDefault(_background);

var _menu = __webpack_require__(617);

var _menu2 = _interopRequireDefault(_menu);

var _credits = __webpack_require__(626);

var _credits2 = _interopRequireDefault(_credits);

var _flagsOverlay = __webpack_require__(68);

var _flagsOverlay2 = _interopRequireDefault(_flagsOverlay);

var _mobileVersion = __webpack_require__(631);

var _mobileVersion2 = _interopRequireDefault(_mobileVersion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = (_dec = (0, _vueClassComponent2.default)({
	name: 'App',
	components: { MobileVersion: _mobileVersion2.default, FlagsOverlay: _flagsOverlay2.default, Loader: _loader2.default, MenuElement: _menu2.default, Credits: _credits2.default, HeaderElement: _header2.default, Intro: _intro2.default, Presentation: _presentation2.default, Political: _political2.default, Youth: _youth2.default, ProEra: _proEra2.default, BadassOrigins: _badassOrigins2.default, Amerikkkan: _amerikkkan2.default, LandOfFree: _landOfFree2.default, Racism: _racism2.default, Engagement: _engagement2.default, Program: _program2.default, Background: _background2.default, ScrollIndicator: _scrollIndicator2.default },
	data: function data() {
		return {
			globals: _Globals2.default.state
		};
	},
	computed: {
		isMobile: function isMobile() {
			return this.globals.isMobile;
		},
		isTablet: function isTablet() {
			return this.globals.isTablet;
		}
	}
}), _dec(_class = function (_Vue) {
	(0, _inherits3.default)(App, _Vue);

	function App() {
		(0, _classCallCheck3.default)(this, App);
		return (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).apply(this, arguments));
	}

	(0, _createClass3.default)(App, [{
		key: 'mounted',
		value: function mounted() {

			if (!this.isTablet) {
				_gsap.TweenMax.set(this.$refs.container, { y: window.innerHeight });
			}
			(0, _jquery2.default)(window).on('load', this.init);
			(0, _jquery2.default)(window).on('resize', _.throttle(this._resize.bind(this), 100));
			this.goTo = this.goTo.bind(this);
		}
	}, {
		key: 'init',
		value: function init() {
			var _this2 = this;

			var scrollHeight = this.$refs.container.getBoundingClientRect().height;

			if (!this.isTablet) {
				this.$container = this.$el.querySelector('.landing-container');

				this.scroller = new _scroller2.default({
					el: this.$refs.container,
					ease: window.innerWidth < 641 ? .2 : .1
				});

				this.scroller.pause();
				this.$events.on('app.loaded', this.loaded.bind(this));
				this.$events.on('app.anchor', this.goTo);

				var fontA = new _fontfaceobserver2.default('Saira Extra Condensed');
				var fontB = new _fontfaceobserver2.default('Poppins');
				var fontC = new _fontfaceobserver2.default('Abhaya Libre');

				_promise2.default.all([fontA.load(), fontB.load(), fontC.load()]).then(function (fonts) {

					_this2.$refs.bg.animateIn();
					// this.$events.emit('app.loaded')
					_this2.$refs.loader.load();
				}).catch(function () {
					this.$refs.bg.animateIn();
					this.$events.emit('app.loaded');
					this.$refs.loader.load();
					// console.log('Fonts didnt load.');
				});
			} else {
				this.$container = this.$el.querySelector('.landing-container');

				this.scroller = new _scroller2.default({
					el: this.$refs.container,
					ease: window.innerWidth < 641 ? .2 : .1
				});
				this.$events.emit('app.loaded');
				this.scroller.pause();
			}
		}
	}, {
		key: 'goTo',
		value: function goTo(target) {
			var to = this.$refs[target];
			if (to) {
				var h = this.scroller.height;
				var top = to.bounds.top;
				var ratio = top / h;
				this.scroller.to(top, ratio * 1000);
			}
		}
	}, {
		key: 'loaded',
		value: function loaded() {
			var _this3 = this;

			this.tl = new TimelineMax({ onComplete: function onComplete() {
					_this3.scroller.play();
					_Globals2.default.isLoaded = true;
					_this3._resize();
					_this3.$events.emit('scroll.in');
				} });
			this.tl.to(this.$refs.container, 2, { y: 0, ease: Strong.easeInOut, delay: .6 }, .1);
			// this.tl.to(this.$refs.container,.1,{y:0, ease: Strong.easeInOut, delay:.6},.1)
		}
	}, {
		key: '_resize',
		value: function _resize() {
			var _this4 = this;

			_Globals2.default.resize();
			this.$events.emit('app.resize');
			this.scroller.resize();
			this.$refs.bg._resize();

			var scrollHeight = this.$refs.container.getBoundingClientRect().height;

			this.tlBlock = new TimelineMax({ paused: true });
			if (_Globals2.default.isLoaded) {

				this.tlBlock.fromTo(this.$container, 1, { y: 0 }, { y: -scrollHeight, ease: Power0.easeNone }, 0);
			} else {
				// 	TweenMax.to(this.$refs.container,.1,{y:-window.innerHeight})
			}

			this.scroller.interval('landing', {
				start: 0,
				end: scrollHeight,
				exec: function exec(e) {
					_this4.tlBlock.progress(e.ratio);
				}
			});

			// console.log(this.$events._events['app.loaded'].length)
		}
	}]);
	return App;
}(_vue2.default)) || _class);
exports.default = App;

/***/ }),
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loader_vue__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c4710f2_hasScoped_true_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_loader_vue__ = __webpack_require__(362);
function injectStyle (ssrContext) {
  __webpack_require__(256)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c4710f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loader_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c4710f2_hasScoped_true_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_loader_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(257);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("1c516ca4", content, true, {});

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".loader[data-v-2c4710f2]{position:fixed;background-color:transparent;height:100vh;width:100vw;z-index:100;display:flex;justify-content:center;align-items:center;overflow:hidden}.loader .letters[data-v-2c4710f2]{display:flex;height:190px;align-items:center;overflow:hidden}.loader .letters .letter[data-v-2c4710f2]{height:190px;width:150px;text-align:center;opacity:0}.loader .letters .letter span[data-v-2c4710f2]{font-size:230px;font-family:Saira Extra Condensed,sans-serif;color:#fff;display:block;line-height:190px;will-change:transform}.loader .pct[data-v-2c4710f2]{position:absolute;bottom:10vh;left:50%;transform:translate(-50%);color:#fff;text-align:center;opacity:.6}.loader .pct p[data-v-2c4710f2]{font-size:14px;letter-spacing:.15em;font-family:Saira Extra Condensed,sans-serif;text-transform:uppercase}.loader .loader-wrapper[data-v-2c4710f2]{height:80px;overflow:hidden;position:relative;display:flex;width:122px}.loader .loader-wrapper .background-letters[data-v-2c4710f2]{position:relative;height:80px;width:100%;bottom:0;left:0;overflow:hidden}.loader .loader-wrapper .background-letters p[data-v-2c4710f2]{opacity:.3}.loader .loader-wrapper .background-letters .list[data-v-2c4710f2]{position:absolute;bottom:0;left:0}.loader .loader-wrapper .loading-letters[data-v-2c4710f2]{height:0;width:100%;overflow:hidden;position:absolute;bottom:0;left:0}.loader .loader-wrapper .loading-letters .list[data-v-2c4710f2]{position:absolute;bottom:0;left:0}", ""]);

// exports


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _assetsLoader = __webpack_require__(50);

var _assetsLoader2 = _interopRequireDefault(_assetsLoader);

var _assets = __webpack_require__(361);

var _assets2 = _interopRequireDefault(_assets);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loader = (_dec = (0, _vueClassComponent2.default)({
	name: 'Loader',
	props: [],
	components: {},
	data: function data() {
		return {
			perc: 0,
			letters: 'B4DA$$'
		};
	}
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(Loader, _Scrollable);

	function Loader() {
		(0, _classCallCheck3.default)(this, Loader);
		return (0, _possibleConstructorReturn3.default)(this, (Loader.__proto__ || (0, _getPrototypeOf2.default)(Loader)).apply(this, arguments));
	}

	(0, _createClass3.default)(Loader, [{
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(Loader.prototype.__proto__ || (0, _getPrototypeOf2.default)(Loader.prototype), 'mounted', this).call(this);

			this.progressValue = { value: 0 };
			this.progressTween = null;
			this.loaded = false;
			this.ready = false;

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(Loader.prototype.__proto__ || (0, _getPrototypeOf2.default)(Loader.prototype), 'init', this).call(this);
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(Loader.prototype.__proto__ || (0, _getPrototypeOf2.default)(Loader.prototype), '_bind', this).call(this);

			this.onLoaded = this._loaded.bind(this);
			this.progress = this._progress.bind(this);
		}
	}, {
		key: 'load',
		value: function load() {
			var _this2 = this;

			var $letters = this.$el.querySelectorAll('.letter');
			var final = "B4DA$$";
			var DURATION = 300;

			var MAX = 2500;

			var letters = [];

			$letters.forEach(function (l, i) {
				var letter = {
					type: l.dataset.type,
					delay: Math.random() * (1.8 - .8) + .8,
					el: l,
					totalTime: 0,
					curr: l.querySelector('.curr'),
					next: l.querySelector('.next'),
					timeline: null,
					readyToStop: false
				};

				letters.push(letter);
			});

			_gsap.TweenMax.to($letters, .6, { opacity: 1, ease: Power3.easeIn, delay: .4, onComplete: function onComplete() {
					_assetsLoader2.default.loadAll(_assets2.default.assets, _this2.onLoaded, _this2.progress);
				} });

			letters.forEach(function (l, i) {

				l.next.innerText = _this2.getRandomLetter(l.type);

				_gsap.TweenMax.to([l.curr, l.next], DURATION / 1000, { y: '-100%', ease: Power4.easeInOut, delay: l.delay, onComplete: function onComplete() {

						_this2.resetLetter(l.curr, l.next, l.type);

						l.timeline = new TimelineMax({ delay: .1, repeat: -1, onRepeat: function onRepeat() {

								_this2.resetLetter(l.curr, l.next, l.type);
								l.totalTime += DURATION + 100;

								if (l.readyToStop) {
									l.timeline.stop();

									if (i === letters.length - 1) {
										window.setTimeout(function () {
											_this2.$events.emit('app.loaded');
										}, DURATION);
										_gsap.TweenMax.to(_this2.$pct, 1.2, { autoAlpha: 0, delay: .5 });
										_gsap.TweenMax.to(_this2.$el.querySelector('.letters'), 2, { scaleY: 1.6, delay: .7, ease: Strong.easeInOut, onComplete: function onComplete() {
												_this2.$el.style.display = 'none';
											} });
									}
								}
								if (l.totalTime >= MAX && _this2.loaded && !l.readyToStop && _this2.ready) {
									l.readyToStop = true;
									l.next.innerText = final[i];
								}
							}
						});
						l.timeline.to([l.curr, l.next], DURATION / 1000, { y: '-100%', ease: Power4.easeInOut });
					} });
			});
		}
	}, {
		key: 'resetLetter',
		value: function resetLetter(curr, next, type) {
			curr.innerText = next.innerText;
			_gsap.TweenMax.set([curr, next], { y: '0%' });
			next.innerText = this.getRandomLetter(type);
		}
	}, {
		key: 'getRandomLetter',
		value: function getRandomLetter(type) {
			var CHARS = {
				ALPHA: 'ABCDEFGHIJKLMNOPRSTUVWXYZ',
				NUM: '0123456789',
				SPE: '&$!?£€æê®î∂‹©ß'
			};

			return CHARS[type].charAt(Math.floor(Math.random() * CHARS[type].length));
		}
	}, {
		key: '_loaded',
		value: function _loaded() {
			this.loaded = true;
		}
	}, {
		key: '_progress',
		value: function _progress(e) {
			var _this3 = this;

			var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789&$+-*';
			var alphaArray = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
			var numberArray = '0123456789';
			var specialArray = '&$+-*!?¥';

			_gsap.TweenMax.to(this.progressValue, 4, { value: e.amount, onUpdate: function onUpdate() {
					var ratio = _this3.progressValue.value * 100 / e.length;
					_this3.perc = Math.round(ratio);
				}, onComplete: function onComplete() {
					_this3.ready = true;
				} });
		}
	}, {
		key: '_dom',
		value: function _dom() {
			this.$bgLetterList = this.$el.querySelectorAll('.background-letters .list');
			this.$loadingLetterList = this.$el.querySelectorAll('.loading-letters .list');
			this.$loadingLetter = this.$el.querySelectorAll('.loading-letters');
			this.$pct = this.$el.querySelector('.pct');
		}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(Loader.prototype.__proto__ || (0, _getPrototypeOf2.default)(Loader.prototype), '_resize', this).call(this);
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(Loader.prototype.__proto__ || (0, _getPrototypeOf2.default)(Loader.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(Loader.prototype.__proto__ || (0, _getPrototypeOf2.default)(Loader.prototype), '_off', this).call(this);
		}
	}]);
	return Loader;
}(_scrollable2.default)) || _class);
exports.default = Loader;

/***/ }),
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */
/***/ (function(module, exports) {

module.exports = {"assets":[{"name":"bill","url":"assets/sprites/sprite.png","type":"image"},{"name":"trump-bill","url":"assets/images/trump-bill.png","type":"image"},{"name":"political-joey","url":"assets/images/political-joey.jpg","type":"image"},{"name":"spray","url":"assets/sprites/spray-bw.png","type":"image"}]}

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_vm._m(0),_c('div',{staticClass:"pct"},[_c('p',[_vm._v(_vm._s(_vm.perc)+" %")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"letters"},[_c('div',{staticClass:"letter",attrs:{"data-type":"ALPHA"}},[_c('span',{staticClass:"curr"},[_vm._v("Z")]),_c('span',{staticClass:"next"},[_vm._v("Z")])]),_c('div',{staticClass:"letter",attrs:{"data-type":"NUM"}},[_c('span',{staticClass:"curr"},[_vm._v("6")]),_c('span',{staticClass:"next"},[_vm._v("6")])]),_c('div',{staticClass:"letter",attrs:{"data-type":"ALPHA"}},[_c('span',{staticClass:"curr"},[_vm._v("I")]),_c('span',{staticClass:"next"},[_vm._v("I")])]),_c('div',{staticClass:"letter",attrs:{"data-type":"ALPHA"}},[_c('span',{staticClass:"curr"},[_vm._v("M")]),_c('span',{staticClass:"next"},[_vm._v("M")])]),_c('div',{staticClass:"letter",attrs:{"data-type":"SPE"}},[_c('span',{staticClass:"curr"},[_vm._v("G")]),_c('span',{staticClass:"next"},[_vm._v("G")])]),_c('div',{staticClass:"letter",attrs:{"data-type":"SPE"}},[_c('span',{staticClass:"curr"},[_vm._v("S")]),_c('span',{staticClass:"next"},[_vm._v("S")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4204f070_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__(382);
function injectStyle (ssrContext) {
  __webpack_require__(369)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4204f070_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(370);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("74a817b9", content, true, {});

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".header{position:fixed;top:0;left:0;width:100vw;z-index:80;overflow:hidden;transform:translateY(-100%)}.header-wrapper{padding:40px 5vw;display:flex;justify-content:flex-end;position:relative}.header-wrapper .su-logo{position:absolute;top:0;left:0;width:80px}.header-wrapper .su-logo img{width:100%}.header-wrapper .burger-button{position:absolute;top:42px;left:calc(50% - 10px)}.header-wrapper .nav{display:flex;align-items:center}.header-wrapper .nav a,.header-wrapper .nav p{color:#fff;font-size:14px;letter-spacing:.15em;font-family:Saira Extra Condensed,sans-serif;font-weight:300;text-transform:uppercase}.header-wrapper .nav .credits-link{margin:0 20px;border:1px solid #fff;padding:.2em .4em;cursor:pointer}", ""]);

// exports


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _langSwitch = __webpack_require__(372);

var _langSwitch2 = _interopRequireDefault(_langSwitch);

var _burgerButton = __webpack_require__(377);

var _burgerButton2 = _interopRequireDefault(_burgerButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = (_dec = (0, _vueClassComponent2.default)({
	name: 'Header',
	components: { LangSwitcher: _langSwitch2.default, BurgerButton: _burgerButton2.default }
}), _dec(_class = function (_Vue) {
	(0, _inherits3.default)(Header, _Vue);

	function Header() {
		(0, _classCallCheck3.default)(this, Header);
		return (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).apply(this, arguments));
	}

	(0, _createClass3.default)(Header, [{
		key: 'mounted',
		value: function mounted() {

			this._dom();
			this._on();
		}
	}, {
		key: 'init',
		value: function init() {}
	}, {
		key: '_on',
		value: function _on() {
			this.$events.on('header.in', this.show.bind(this));
			this.$events.on('header.out', this.hide.bind(this));
			this.$events.on('menu.out', this.menuOut.bind(this));
		}
	}, {
		key: '_dom',
		value: function _dom() {
			this.$burger = this.$el.querySelector('.burger-button');
			this.$navItem = this.$el.querySelectorAll('.nav-item');
		}
	}, {
		key: 'menuIn',
		value: function menuIn() {

			var tl = new TimelineMax();
			tl.to(this.$burger, .6, { autoAlpha: 0, ease: Power0.easeNone }, 0);
			tl.staggerTo(this.$navItem, .6, { y: -40, autoAlpha: 0, ease: Expo.easeIn }, .05, 0);

			this.$events.emit('menu.in');
		}
	}, {
		key: 'creditsIn',
		value: function creditsIn() {

			var tl = new TimelineMax();
			tl.to(this.$burger, .6, { autoAlpha: 0, ease: Power0.easeNone }, 0);
			tl.staggerTo(this.$navItem, .6, { y: -40, autoAlpha: 0, ease: Expo.easeIn }, .05, 0);

			this.$events.emit('credits.in');
		}
	}, {
		key: 'menuOut',
		value: function menuOut() {

			var tl = new TimelineMax();
			tl.to(this.$burger, .6, { autoAlpha: 1, ease: Power0.easeNone }, 0);
			tl.set(this.$navItem, { y: 0 }, 0);
			tl.staggerTo(this.$navItem, .6, { autoAlpha: 1, ease: Expo.easeIn }, .1, 0);
		}
	}, {
		key: 'show',
		value: function show() {
			_gsap.TweenMax.to(this.$el, .6, { y: '0%' });
		}
	}, {
		key: 'hide',
		value: function hide() {
			_gsap.TweenMax.to(this.$el, .6, { y: '-100%' });
		}
	}, {
		key: '_resize',
		value: function _resize() {}
	}]);
	return Header;
}(_vue2.default)) || _class);
exports.default = Header;

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lang_switch_vue__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lang_switch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lang_switch_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bc6bdc4_hasScoped_true_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_lang_switch_vue__ = __webpack_require__(376);
function injectStyle (ssrContext) {
  __webpack_require__(373)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7bc6bdc4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lang_switch_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bc6bdc4_hasScoped_true_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_lang_switch_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(374);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("4cec4c70", content, true, {});

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".control.lang-switch[data-v-7bc6bdc4]{position:relative;display:flex;align-items:center;justify-content:center;color:#fff}.control.lang-switch .separator[data-v-7bc6bdc4]{height:14px;width:1px;background:#fff;display:block;margin:0 10px 0 8px}.control.lang-switch .lang[data-v-7bc6bdc4]{cursor:pointer;opacity:.7}.control.lang-switch .lang.active[data-v-7bc6bdc4],.control.lang-switch .lang[data-v-7bc6bdc4]:hover{opacity:1}", ""]);

// exports


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scroller = __webpack_require__(18);

var _scroller2 = _interopRequireDefault(_scroller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LangSwitch = (_dec = (0, _vueClassComponent2.default)({
	name: 'LangSwitch',
	props: ["src"],
	components: {}
}), _dec(_class = function (_Vue) {
	(0, _inherits3.default)(LangSwitch, _Vue);

	function LangSwitch() {
		(0, _classCallCheck3.default)(this, LangSwitch);
		return (0, _possibleConstructorReturn3.default)(this, (LangSwitch.__proto__ || (0, _getPrototypeOf2.default)(LangSwitch)).apply(this, arguments));
	}

	(0, _createClass3.default)(LangSwitch, [{
		key: 'mounted',
		value: function mounted() {

			this.$events.on('app.loaded', this.init);
		}
	}, {
		key: 'init',
		value: function init() {

			this.scroller = new _scroller2.default();
		}
	}, {
		key: '_resize',
		value: function _resize() {}
	}, {
		key: 'change',
		value: function change() {
			var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'fr';


			this.language = lang;

			window.location.reload();
		}
	}]);
	return LangSwitch;
}(_vue2.default)) || _class);
exports.default = LangSwitch;

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control lang-switch"},[_c('a',{staticClass:"lang fr",class:{active: _vm.language == 'fr'},on:{"click":function($event){_vm.change('fr')}}},[_vm._v("Fr")]),_c('div',{staticClass:"separator"}),_c('a',{staticClass:"lang en",class:{active: _vm.language == 'en'},on:{"click":function($event){_vm.change('en')}}},[_vm._v("En")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_burger_button_vue__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_burger_button_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_burger_button_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55762f9b_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_burger_button_vue__ = __webpack_require__(381);
function injectStyle (ssrContext) {
  __webpack_require__(378)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_burger_button_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55762f9b_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_burger_button_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(379);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("22a3d5bc", content, true, {});

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".burger-button{width:20px;height:16px;display:flex;flex-direction:column;justify-content:space-between;align-items:center;cursor:pointer}.burger-button span.bar{width:20px;height:2px;display:block;background-color:#fff;transition:all .3s}.burger-button span.bar:nth-child(2){width:16px}.burger-button .text{color:#fff;position:absolute;text-transform:uppercase;font-weight:300;font-family:Saira Extra Condensed,sans-serif;font-size:12px;letter-spacing:.15em;top:2px;opacity:0;transition:opacity .3s}.burger-button:hover .bar:first-child{transform:translateY(-4px)}.burger-button:hover .bar:nth-child(2){opacity:0}.burger-button:hover .bar:nth-child(3){transform:translateY(4px)}.burger-button:hover .text{opacity:1}", ""]);

// exports


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scroller = __webpack_require__(18);

var _scroller2 = _interopRequireDefault(_scroller);

var _ticker = __webpack_require__(19);

var _ticker2 = _interopRequireDefault(_ticker);

var _section = __webpack_require__(41);

var _section2 = _interopRequireDefault(_section);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BurgerButton = (_dec = (0, _vueClassComponent2.default)({
	name: 'BurgerButton',
	components: {},
	props: ["action"]
}), _dec(_class = function (_Vue) {
	(0, _inherits3.default)(BurgerButton, _Vue);

	function BurgerButton() {
		(0, _classCallCheck3.default)(this, BurgerButton);
		return (0, _possibleConstructorReturn3.default)(this, (BurgerButton.__proto__ || (0, _getPrototypeOf2.default)(BurgerButton)).apply(this, arguments));
	}

	(0, _createClass3.default)(BurgerButton, [{
		key: 'mounted',
		value: function mounted() {}
	}, {
		key: 'init',
		value: function init() {}
	}, {
		key: '_resize',
		value: function _resize() {}
	}]);
	return BurgerButton;
}(_vue2.default)) || _class);
exports.default = BurgerButton;

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-touch',{staticClass:"burger-button",on:{"tap":_vm.action}},[_vm._l((3),function(n){return _c('span',{staticClass:"bar"})}),_c('span',{staticClass:"text"},[_vm._v("Menu")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('div',{staticClass:"header-wrapper"},[_vm._m(0),_c('burger-button',{attrs:{"action":_vm.menuIn}}),_c('nav',{staticClass:"nav"},[_c('p',{staticClass:"electors-amount nav-item"}),_c('p',{staticClass:"credits-link nav-item",on:{"click":_vm.creditsIn}},[_vm._v("credits")]),_c('LangSwitcher',{staticClass:"nav-item"})],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"su-logo"},[_c('a',{attrs:{"href":"http://shoes-up.com","target":"blank"}},[_c('img',{attrs:{"src":"assets/images/SU-logo.svg"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_scroll_indicator_vue__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_scroll_indicator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_scroll_indicator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_444eb39c_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_scroll_indicator_vue__ = __webpack_require__(387);
function injectStyle (ssrContext) {
  __webpack_require__(384)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_scroll_indicator_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_444eb39c_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_scroll_indicator_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(385);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("7da1d014", content, true, {});

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".scroll-indicator{position:fixed;bottom:0;left:0;width:100vw;z-index:90;overflow:hidden;display:flex;justify-content:center;opacity:0}.scroll-indicator .indicator{text-align:center;margin-bottom:60px;opacity:.5}.scroll-indicator .indicator p{font-size:12px;font-family:Saira Extra Condensed,sans-serif;font-weight:300;color:#fff;text-transform:uppercase;margin-bottom:24px;letter-spacing:.15em}", ""]);

// exports


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scroller = __webpack_require__(18);

var _scroller2 = _interopRequireDefault(_scroller);

var _ticker = __webpack_require__(19);

var _ticker2 = _interopRequireDefault(_ticker);

var _section = __webpack_require__(41);

var _section2 = _interopRequireDefault(_section);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = (_dec = (0, _vueClassComponent2.default)({
	name: 'Header',
	components: {}
}), _dec(_class = function (_Vue) {
	(0, _inherits3.default)(Header, _Vue);

	function Header() {
		(0, _classCallCheck3.default)(this, Header);
		return (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).apply(this, arguments));
	}

	(0, _createClass3.default)(Header, [{
		key: 'mounted',
		value: function mounted() {

			this.$events.on('scroll.in', this.show.bind(this));
			this.$events.on('scroll.out', this.hide.bind(this));
			this.hide(0.1);
		}
	}, {
		key: 'init',
		value: function init() {}
	}, {
		key: 'show',
		value: function show() {
			_gsap.TweenMax.to(this.$el, 1, { opacity: 1 });
		}
	}, {
		key: 'hide',
		value: function hide() {
			var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : .6;

			_gsap.TweenMax.to(this.$el, duration, { opacity: 0 });
		}
	}, {
		key: '_resize',
		value: function _resize() {}
	}]);
	return Header;
}(_vue2.default)) || _class);
exports.default = Header;

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-indicator"},[_c('div',{staticClass:"indicator"},[_c('p',[_vm._v(_vm._s(_vm.translate('globals.scroll')))]),_c('img',{attrs:{"src":"assets/images/scroll-icon.png"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_intro_vue__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_intro_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_intro_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62431016_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_intro_vue__ = __webpack_require__(402);
function injectStyle (ssrContext) {
  __webpack_require__(389)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_intro_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62431016_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_intro_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(390);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("382a71de", content, true, {});

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".intro{width:100%;position:relative;backface-visibility:hidden}@media screen and (max-width:640px){.intro{padding:0 30px}}.intro .intro-content{width:100%;height:100vh;display:flex;align-items:center;justify-content:center;position:relative;background:#232323;will-change:transform}.intro .intro-content .intro-text{max-width:800px;text-align:center;position:relative}.intro .intro-content .intro-text p{color:#fff;line-height:1em}.intro .intro-content .intro-text .quote{font-size:60px;font-family:Poppins;font-weight:600}@media screen and (max-width:640px){.intro .intro-content .intro-text .quote{font-size:30px}}.intro .intro-content .intro-text .author{width:100%;position:absolute;left:0;bottom:-72px}.intro .intro-content .intro-text .author .text{position:relative;display:inline-block;color:#fff}.intro .intro-content .intro-text .author .text .mask{position:absolute;top:-4px;right:0;height:calc(100% + 4px);width:calc(100% + 15vw);background:linear-gradient(270deg,#232323 40%,rgba(35,35,35,0))}.intro .intro-content .wrap-canvas{width:1200px;height:675px;position:absolute;top:50%;left:calc(50% - 30px);transform:translate3d(-50%,-50%,0)}@media screen and (max-width:640px){.intro .intro-content .wrap-canvas{width:960px;height:540px;left:50%}}.intro .intro-content .wrap-canvas canvas{width:100%!important;height:100%!important}", ""]);

// exports


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _values = __webpack_require__(177);

var _values2 = _interopRequireDefault(_values);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scroller = __webpack_require__(18);

var _scroller2 = _interopRequireDefault(_scroller);

var _ticker = __webpack_require__(19);

var _ticker2 = _interopRequireDefault(_ticker);

var _pixi = __webpack_require__(25);

var PIXI = _interopRequireWildcard(_pixi);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _spriteHandler = __webpack_require__(395);

var _spriteHandler2 = _interopRequireDefault(_spriteHandler);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _Globals = __webpack_require__(16);

var _Globals2 = _interopRequireDefault(_Globals);

var _assetsLoader = __webpack_require__(50);

var _assetsLoader2 = _interopRequireDefault(_assetsLoader);

var _sprite = __webpack_require__(400);

var _sprite2 = _interopRequireDefault(_sprite);

var _sprite3 = __webpack_require__(401);

var _sprite4 = _interopRequireDefault(_sprite3);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Intro = (_dec = (0, _vueClassComponent2.default)({
	name: 'Intro',
	components: {}
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(Intro, _Scrollable);

	function Intro() {
		(0, _classCallCheck3.default)(this, Intro);
		return (0, _possibleConstructorReturn3.default)(this, (Intro.__proto__ || (0, _getPrototypeOf2.default)(Intro)).apply(this, arguments));
	}

	(0, _createClass3.default)(Intro, [{
		key: 'mounted',
		value: function mounted() {

			(0, _get3.default)(Intro.prototype.__proto__ || (0, _getPrototypeOf2.default)(Intro.prototype), 'mounted', this).call(this);

			this.baseUri =  true ? '/story/joey-bada$$-political-mc/' : '../../';

			this.animOffset = _Globals2.default.responsiveHeight(550);
			this.$movable = this.$el.querySelector('.movable');
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(Intro.prototype.__proto__ || (0, _getPrototypeOf2.default)(Intro.prototype), 'init', this).call(this);

			this.initSprite();
		}
	}, {
		key: 'initSprite',
		value: function initSprite() {

			var wrapRect = this.$refs.canvas.getBoundingClientRect();
			this.app = new PIXI.Application(wrapRect.width, wrapRect.height, {
				transparent: true,
				antialias: false,
				resolution: 1
			});
			this.app.renderer.autoResize = true;
			this.$refs.canvas.appendChild(this.app.view);

			var loader = new PIXI.loaders.Loader();

			this.spriteLoaded();
		}
	}, {
		key: 'spriteLoaded',
		value: function spriteLoaded(loader, resources) {
			var _this2 = this;

			// var spritesheet = new PIXI.Spritesheet(resources['bill'].texture.baseTexture, billData)
			var spritesheet = new PIXI.Spritesheet(new PIXI.BaseTexture(_assetsLoader2.default.getLoadedAsset('bill').img), _sprite4.default);

			spritesheet.parse(function (w) {
				_this2.anim = new PIXI.extras.AnimatedSprite((0, _values2.default)(spritesheet.textures));
				_this2.anim.width = _this2.app.view.width;
				_this2.anim.height = _this2.app.view.height;
				_this2.app.stage.addChild(_this2.anim);
			});
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(Intro.prototype.__proto__ || (0, _getPrototypeOf2.default)(Intro.prototype), '_bind', this).call(this);
		}
	}, {
		key: 'raf',
		value: function raf(y) {
			(0, _get3.default)(Intro.prototype.__proto__ || (0, _getPrototypeOf2.default)(Intro.prototype), 'raf', this).call(this, y);
		}
	}, {
		key: 'initTimeline',
		value: function initTimeline() {
			var _this3 = this;

			(0, _get3.default)(Intro.prototype.__proto__ || (0, _getPrototypeOf2.default)(Intro.prototype), 'initTimeline', this).call(this);

			var frame = { value: 0 };

			var triggerOffset = _Globals2.default.responsiveHeight(450) / this.animOffset;
			var billDuration = _Globals2.default.responsiveHeight(400) / this.animOffset;

			this.tl.fromTo(this.$movable, 1, { y: 0 }, { y: this.animOffset, ease: Power0.easeNone }, 0);
			this.tl.fromTo(frame, billDuration, { value: 0 }, { value: 43,
				ease: Power0.easeNone,
				onUpdate: function onUpdate() {
					if (!_this3.anim) return;
					var i = Math.floor(frame.value);
					_this3.anim.gotoAndStop(i);
				} }, 0);
			this.tl.add(function () {
				if (_this3.scroller.direction === 1) {
					_gsap.TweenMax.to((0, _jquery2.default)(_this3.$el).find('.author .mask'), 1.2, { x: '100%' });
				} else if (_this3.scroller.direction === -1) {
					_gsap.TweenMax.to((0, _jquery2.default)(_this3.$el).find('.author .mask'), 1.2, { x: '0%' });
				}
			}, triggerOffset);
		}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(Intro.prototype.__proto__ || (0, _getPrototypeOf2.default)(Intro.prototype), '_resize', this).call(this);

			this.animOffset = _Globals2.default.responsiveHeight(550);
			this.bounds.height = window.innerHeight + this.animOffset;
			this.$el.style.height = this.bounds.height + "px";

			this.boundsAnim = {
				top: this.bounds.top,
				bottom: this.bounds.top + this.animOffset
			};

			this.initTimeline();
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(Intro.prototype.__proto__ || (0, _getPrototypeOf2.default)(Intro.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(Intro.prototype.__proto__ || (0, _getPrototypeOf2.default)(Intro.prototype), '_off', this).call(this);
		}
	}]);
	return Intro;
}(_scrollable2.default)) || _class);
exports.default = Intro;

/***/ }),
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(396);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _pixi = __webpack_require__(25);

var PIXI = _interopRequireWildcard(_pixi);

var _ticker = __webpack_require__(19);

var _ticker2 = _interopRequireDefault(_ticker);

var _quarkRaf = __webpack_require__(122);

var _quarkRaf2 = _interopRequireDefault(_quarkRaf);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SpriteHandler = function () {

	// Settings
	function SpriteHandler(params) {
		(0, _classCallCheck3.default)(this, SpriteHandler);
		Object.defineProperty(this, 'transparent', {
			enumerable: true,
			writable: true,
			value: false
		});
		Object.defineProperty(this, 'autoResize', {
			enumerable: true,
			writable: true,
			value: true
		});
		Object.defineProperty(this, 'antialias', {
			enumerable: true,
			writable: true,
			value: false
		});
		Object.defineProperty(this, 'size', {
			enumerable: true,
			writable: true,
			value: { w: 1440, h: 900 }
		});
		Object.defineProperty(this, 'ticker', {
			enumerable: true,
			writable: true,
			value: new _ticker2.default()
		});
		Object.defineProperty(this, 'loaded', {
			enumerable: true,
			writable: true,
			value: false
		});


		(0, _assign2.default)(this, params);

		this._animate = this._animate.bind(this);

		this._initStage();
		this._initLoader();

		return this;
	}

	(0, _createClass3.default)(SpriteHandler, [{
		key: '_initStage',
		value: function _initStage() {

			// PIXI Renderer
			this.renderer = PIXI.autoDetectRenderer(this.size.w, this.size.h, {
				antialias: this.antialias,
				transparent: this.transparent,
				resolution: window.devicePixelRatio,
				autoResize: this.autoResize
			});

			// PIXI Stage
			this.stage = new PIXI.Container();
			this.dom.appendChild(this.renderer.view);
		}
	}, {
		key: '_initLoader',
		value: function _initLoader() {

			this.loader = new PIXI.loaders.Loader();
			this.loader.reset();
			this.loader.add(this.url);
			this.loader.load(this._spriteLoaded.bind(this));
		}
	}, {
		key: '_spriteLoaded',
		value: function _spriteLoaded() {

			var frames = [],
			    i = 0,
			    l = this.frame.amount;

			for (i; i < l; i++) {
				var f = PIXI.Texture.fromFrame(this.frame.baseName + i + this.frame.extension);
				frames.push(f);
			}

			this.anim = new PIXI.extras.AnimatedSprite(frames);
			this.stage.addChild(this.anim);
			_quarkRaf2.default.add(this._animate);
			// this.ticker.tick(`sprite_${this.name}`,this._animate.bind(this))

			this.loaded = true;
		}
	}, {
		key: '_animate',
		value: function _animate() {
			this.renderer.render(this.stage);
		}
	}, {
		key: 'play',
		value: function play() {
			this.ticker.play('sprite_' + this.name);
		}
	}, {
		key: 'pause',
		value: function pause() {
			this.ticker.pause('sprite_' + this.name);
		}
	}]);
	return SpriteHandler;
}();

exports.default = SpriteHandler;

/***/ }),
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "46dd3d1f35dfb8e0eaad42623213d4b4.png";

/***/ }),
/* 401 */
/***/ (function(module, exports) {

module.exports = {"frames":{"bill-0.png":{"frame":{"x":1261,"y":1,"w":657,"h":283},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":183,"y":133,"w":657,"h":283},"sourceSize":{"w":960,"h":540}},"bill-1.png":{"frame":{"x":1920,"y":1,"w":650,"h":283},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":184,"y":132,"w":650,"h":283},"sourceSize":{"w":960,"h":540}},"bill-2.png":{"frame":{"x":1261,"y":286,"w":645,"h":283},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":182,"y":132,"w":645,"h":283},"sourceSize":{"w":960,"h":540}},"bill-3.png":{"frame":{"x":1908,"y":286,"w":636,"h":284},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":183,"y":135,"w":636,"h":284},"sourceSize":{"w":960,"h":540}},"bill-4.png":{"frame":{"x":624,"y":1,"w":635,"h":285},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":181,"y":132,"w":635,"h":285},"sourceSize":{"w":960,"h":540}},"bill-5.png":{"frame":{"x":1,"y":290,"w":629,"h":286},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":182,"y":131,"w":629,"h":286},"sourceSize":{"w":960,"h":540}},"bill-6.png":{"frame":{"x":1,"y":1,"w":621,"h":287},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":184,"y":129,"w":621,"h":287},"sourceSize":{"w":960,"h":540}},"bill-7.png":{"frame":{"x":632,"y":288,"w":607,"h":280},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":183,"y":139,"w":607,"h":280},"sourceSize":{"w":960,"h":540}},"bill-8.png":{"frame":{"x":1809,"y":572,"w":583,"h":276},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":183,"y":141,"w":583,"h":276},"sourceSize":{"w":960,"h":540}},"bill-9.png":{"frame":{"x":1805,"y":850,"w":579,"h":277},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":183,"y":139,"w":579,"h":277},"sourceSize":{"w":960,"h":540}},"bill-10.png":{"frame":{"x":632,"y":570,"w":587,"h":275},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":185,"y":143,"w":587,"h":275},"sourceSize":{"w":960,"h":540}},"bill-11.png":{"frame":{"x":1,"y":578,"w":586,"h":274},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":182,"y":139,"w":586,"h":274},"sourceSize":{"w":960,"h":540}},"bill-12.png":{"frame":{"x":1221,"y":845,"w":582,"h":273},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":181,"y":140,"w":582,"h":273},"sourceSize":{"w":960,"h":540}},"bill-13.png":{"frame":{"x":1221,"y":571,"w":586,"h":272},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":182,"y":141,"w":586,"h":272},"sourceSize":{"w":960,"h":540}},"bill-14.png":{"frame":{"x":589,"y":847,"w":576,"h":273},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":183,"y":140,"w":576,"h":273},"sourceSize":{"w":960,"h":540}},"bill-15.png":{"frame":{"x":1,"y":854,"w":551,"h":271},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":183,"y":141,"w":551,"h":271},"sourceSize":{"w":960,"h":540}},"bill-16.png":{"frame":{"x":1167,"y":1120,"w":539,"h":268},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":184,"y":144,"w":539,"h":268},"sourceSize":{"w":960,"h":540}},"bill-17.png":{"frame":{"x":554,"y":1122,"w":525,"h":269},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":182,"y":141,"w":525,"h":269},"sourceSize":{"w":960,"h":540}},"bill-18.png":{"frame":{"x":1,"y":1661,"w":516,"h":268},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":183,"y":143,"w":516,"h":268},"sourceSize":{"w":960,"h":540}},"bill-19.png":{"frame":{"x":1040,"y":1659,"w":518,"h":269},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":182,"y":144,"w":518,"h":269},"sourceSize":{"w":960,"h":540}},"bill-20.png":{"frame":{"x":1,"y":1391,"w":519,"h":268},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":181,"y":146,"w":519,"h":268},"sourceSize":{"w":960,"h":540}},"bill-21.png":{"frame":{"x":519,"y":1661,"w":519,"h":266},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":181,"y":146,"w":519,"h":266},"sourceSize":{"w":960,"h":540}},"bill-22.png":{"frame":{"x":750,"y":1393,"w":519,"h":264},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":181,"y":148,"w":519,"h":264},"sourceSize":{"w":960,"h":540}},"bill-23.png":{"frame":{"x":1271,"y":1390,"w":519,"h":263},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":181,"y":147,"w":519,"h":263},"sourceSize":{"w":960,"h":540}},"bill-24.png":{"frame":{"x":1,"y":1127,"w":521,"h":262},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":181,"y":146,"w":521,"h":262},"sourceSize":{"w":960,"h":540}},"bill-25.png":{"frame":{"x":2394,"y":781,"w":498,"h":262},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":180,"y":146,"w":498,"h":262},"sourceSize":{"w":960,"h":540}},"bill-26.png":{"frame":{"x":1792,"y":1387,"w":494,"h":260},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":181,"y":146,"w":494,"h":260},"sourceSize":{"w":960,"h":540}},"bill-27.png":{"frame":{"x":2011,"y":1649,"w":485,"h":260},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":180,"y":147,"w":485,"h":260},"sourceSize":{"w":960,"h":540}},"bill-28.png":{"frame":{"x":2386,"y":1045,"w":497,"h":259},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":181,"y":147,"w":497,"h":259},"sourceSize":{"w":960,"h":540}},"bill-29.png":{"frame":{"x":2572,"y":1,"w":275,"h":259},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":183,"y":147,"w":275,"h":259},"sourceSize":{"w":960,"h":540}},"bill-30.png":{"frame":{"x":2572,"y":262,"w":273,"h":256},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":182,"y":149,"w":273,"h":256},"sourceSize":{"w":960,"h":540}},"bill-31.png":{"frame":{"x":1708,"y":1129,"w":271,"h":256},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":183,"y":148,"w":271,"h":256},"sourceSize":{"w":960,"h":540}},"bill-32.png":{"frame":{"x":2546,"y":520,"w":271,"h":259},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":182,"y":148,"w":271,"h":259},"sourceSize":{"w":960,"h":540}},"bill-33.png":{"frame":{"x":1777,"y":1655,"w":232,"h":261},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":182,"y":148,"w":232,"h":261},"sourceSize":{"w":960,"h":540}},"bill-34.png":{"frame":{"x":522,"y":1393,"w":226,"h":266},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":184,"y":145,"w":226,"h":266},"sourceSize":{"w":960,"h":540}},"bill-35.png":{"frame":{"x":1560,"y":1655,"w":215,"h":263},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":183,"y":147,"w":215,"h":263},"sourceSize":{"w":960,"h":540}},"bill-36.png":{"frame":{"x":1981,"y":1129,"w":215,"h":248},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":185,"y":154,"w":215,"h":248},"sourceSize":{"w":960,"h":540}},"bill-37.png":{"frame":{"x":2288,"y":1354,"w":220,"h":240},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":182,"y":158,"w":220,"h":240},"sourceSize":{"w":960,"h":540}},"bill-38.png":{"frame":{"x":2498,"y":1596,"w":216,"h":231},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":183,"y":163,"w":216,"h":231},"sourceSize":{"w":960,"h":540}},"bill-39.png":{"frame":{"x":2510,"y":1306,"w":194,"h":223},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":182,"y":167,"w":194,"h":223},"sourceSize":{"w":960,"h":540}},"bill-40.png":{"frame":{"x":2198,"y":1129,"w":147,"h":223},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":184,"y":167,"w":147,"h":223},"sourceSize":{"w":960,"h":540}},"bill-41.png":{"frame":{"x":2716,"y":1306,"w":147,"h":218},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":184,"y":170,"w":147,"h":218},"sourceSize":{"w":960,"h":540}},"bill-42.png":{"frame":{"x":2716,"y":1526,"w":141,"h":214},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":185,"y":173,"w":141,"h":214},"sourceSize":{"w":960,"h":540}},"bill-44.png":{"frame":{"x":2849,"y":1,"w":1,"h":1},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":1,"h":1},"sourceSize":{"w":1,"h":1}},"bill-43.png":{"frame":{"x":2394,"y":572,"w":137,"h":78},"rotated":false,"trimmed":true,"spriteSourceSize":{"x":186,"y":307,"w":137,"h":78},"sourceSize":{"w":960,"h":540}}},"meta":{"app":"http://www.codeandweb.com/texturepacker","version":"1.0","image":"sprite.png","format":"RGBA8888","size":{"w":2893,"h":1930},"scale":"1","smartupdate":"$TexturePacker:SmartUpdate:baa501de09ca45758274c666093d8d22:0e318986c4a95d5003855f9abb97c855:68d88b3cf7eafc9b5accfffdfb2fda91$"}}

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro"},[_c('div',{staticClass:"intro-content movable"},[_c('div',{staticClass:"intro-text"},[_c('p',{staticClass:"quote"},[_vm._v(_vm._s(_vm.translate('intro.bill_text'))+"\t")]),_vm._m(0)]),_c('div',{ref:"canvas",staticClass:"wrap-canvas"})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"author"},[_c('div',{staticClass:"text"},[_c('span',{staticClass:"mask"}),_vm._v("- JOEY B4DA$$ -\t\t\t")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_presentation_vue__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_presentation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_presentation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9da842be_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_presentation_vue__ = __webpack_require__(411);
function injectStyle (ssrContext) {
  __webpack_require__(404)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_presentation_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9da842be_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_presentation_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(405);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("643dad4e", content, true, {});

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".intro-presentation{width:100%;height:100vh;background:#232323}.intro-presentation .background{z-index:100}@media screen and (max-width:640px){.intro-presentation{padding-left:30px;padding-right:30px}}.intro-presentation .gradient-layer{height:100vh;width:100%;position:absolute;top:0;left:0;background:linear-gradient(180deg,#232323,#05006c)}.intro-presentation-wrapper{height:100vh;width:100%;display:flex;justify-content:center;align-items:center;position:relative}.intro-presentation-wrapper .intro-presentation-text{max-width:640px;text-align:center;top:0;will-change:transform;position:relative;z-index:50}@media screen and (min-width:1700px){.intro-presentation-wrapper .intro-presentation-text{max-width:40vw}}@media screen and (max-width:640px){.intro-presentation-wrapper .intro-presentation-text{padding:0 20px}}.intro-presentation-wrapper .intro-presentation-text .separator{margin:20px 0;width:100%;height:1px}.intro-presentation-wrapper .intro-presentation-text p{color:#fff;text-transform:uppercase;font-weight:700;font-size:1.125em;line-height:1.4em;letter-spacing:.15em;position:relative;will-change:transform}.intro-presentation-wrapper .intro-presentation-text p .mask-left,.intro-presentation-wrapper .intro-presentation-text p .mask-right{position:absolute;top:0;height:100%;width:calc(100% + 15vw)}.intro-presentation-wrapper .intro-presentation-text p .mask-right{right:0;background-image:linear-gradient(270deg,#232323 75%,rgba(35,35,35,0))}.intro-presentation-wrapper .intro-presentation-text p .mask-left{left:0;background-image:linear-gradient(90deg,#232323 75%,rgba(35,35,35,0))}@media screen and (max-width:640px){.intro-presentation-wrapper .intro-presentation-text p{font-size:12px}}.intro-presentation-wrapper .logo{max-width:290px;width:100%;position:absolute;top:50%;left:50%;transform:translate3d(-50%,-50%,0);opacity:0;z-index:60}@media screen and (min-width:1700px){.intro-presentation-wrapper .logo{max-width:400px}}@media screen and (max-width:640px){.intro-presentation-wrapper .logo{max-width:250px}}.intro-presentation-wrapper .logo img{width:100%}", ""]);

// exports


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _background = __webpack_require__(30);

var _background2 = _interopRequireDefault(_background);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _Globals = __webpack_require__(16);

var _Globals2 = _interopRequireDefault(_Globals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Presentation = (_dec = (0, _vueClassComponent2.default)({
	name: 'Presentation',
	components: { Background: _background2.default }
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(Presentation, _Scrollable);

	function Presentation() {
		(0, _classCallCheck3.default)(this, Presentation);
		return (0, _possibleConstructorReturn3.default)(this, (Presentation.__proto__ || (0, _getPrototypeOf2.default)(Presentation)).apply(this, arguments));
	}

	(0, _createClass3.default)(Presentation, [{
		key: 'mounted',
		value: function mounted() {

			(0, _get3.default)(Presentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(Presentation.prototype), 'mounted', this).call(this);

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(Presentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(Presentation.prototype), 'init', this).call(this);
		}
	}, {
		key: '_dom',
		value: function _dom() {
			var $masksLeft = this.$el.querySelectorAll('.mask-left');
			var $masksRight = this.$el.querySelectorAll('.mask-right');
			var $movable = this.$el.querySelector('.movable');
			var $sentence = this.$el.querySelectorAll('.sentence');
		}
	}, {
		key: 'initTimeline',
		value: function initTimeline() {
			var _this2 = this;

			(0, _get3.default)(Presentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(Presentation.prototype), 'initTimeline', this).call(this);

			// DOMS
			var $masksLeft = this.$el.querySelectorAll('.mask-left');
			var $masksRight = this.$el.querySelectorAll('.mask-right');
			var $movable = this.$el.querySelector('.movable');
			var $sentence = this.$el.querySelectorAll('.sentence');
			var $logo = this.$el.querySelector('.logo');
			var $text = this.$el.querySelector('.intro-presentation-text');

			// RATIOS
			var ratioHalf = window.innerHeight * .5 / (this.OFFSET + window.innerHeight * .5);
			var ratioHalfOffset = this.OFFSET * .5 / (this.OFFSET + window.innerHeight * .5);

			this.tl.fromTo($text, ratioHalf, { y: -window.innerHeight * .2 }, { y: 0, ease: Power0.easeNone }, 0);
			this.tl.fromTo($movable, 1 - ratioHalf, { y: 0 }, { y: this.OFFSET, ease: Power0.easeNone }, ratioHalf);
			this.tl.fromTo($sentence[0], ratioHalf, { y: -60 }, { y: 0, ease: Power0.easeNone }, 0);
			this.tl.fromTo($sentence[1], ratioHalf, { y: -40 }, { y: 0, ease: Power0.easeNone }, 0);
			this.tl.fromTo($sentence[2], ratioHalf, { y: -20 }, { y: 0, ease: Power0.easeNone }, 0);
			this.tl.fromTo($sentence[3], ratioHalf, { y: 20 }, { y: 0, ease: Power0.easeNone }, 0);
			this.tl.fromTo($sentence[4], ratioHalf, { y: 40 }, { y: 0, ease: Power0.easeNone }, 0);
			this.tl.fromTo($sentence[5], ratioHalf, { y: 60 }, { y: 0, ease: Power0.easeNone }, 0);

			for (var i = 0; i < 6; i++) {

				var maskLeft = $sentence[i].querySelector('.mask-left');
				var maskRight = $sentence[i].querySelector('.mask-right');

				if (i % 2 === 0) {
					this.tl.set(maskLeft, { autoAlpha: 0 }, 0);
					this.tl.set(maskRight, { autoAlpha: 1 }, 0);
					this.tl.fromTo(maskRight, ratioHalf, { x: '0%' }, { x: '100%', ease: Power3.easeOut }, 0);

					this.tl.set(maskRight, { autoAlpha: 0 }, ratioHalf * .9);
					this.tl.set(maskLeft, { autoAlpha: 1 }, ratioHalf * .9);

					this.tl.fromTo(maskLeft, ratioHalf, { x: '-100%' }, { x: '0%' }, ratioHalf * .9);
				} else {
					this.tl.set(maskRight, { autoAlpha: 0 }, 0);
					this.tl.set(maskLeft, { autoAlpha: 1 }, 0);
					this.tl.fromTo(maskLeft, ratioHalf, { x: '0%' }, { x: '-100%', ease: Power3.easeOut }, 0);

					this.tl.set(maskLeft, { autoAlpha: 0 }, ratioHalf * (.8 + i * .2 / 6));
					this.tl.set(maskRight, { autoAlpha: 1 }, ratioHalf * (.8 + i * .2 / 6));

					this.tl.fromTo(maskRight, ratioHalf, { x: '100%' }, { x: '0%' }, ratioHalf * (.8 + i * .2 / 6));
				}
			}

			this.tl.fromTo($sentence, ratioHalf * .8, { opacity: 1 }, { opacity: 0, ease: Power0.easeNone }, ratioHalf);
			this.tl.fromTo(this.$el, ratioHalfOffset, { backgroundColor: '#232323' }, { backgroundColor: '#05006c' }, ratioHalfOffset + ratioHalf);

			this.tl.fromTo([$masksRight], ratioHalfOffset, { backgroundImage: 'linear-gradient(to left, #232323 75%, rgba(35,35,35,0)' }, { backgroundImage: 'linear-gradient(to left, #05006c 75%, rgba(0,0,0,0)' }, ratioHalfOffset + ratioHalf);
			this.tl.fromTo([$masksLeft], ratioHalfOffset, { backgroundImage: 'linear-gradient(to right, #232323 75%, rgba(35,35,35,0)' }, { backgroundImage: 'linear-gradient(to right, #05006c 75%, rgba(0,0,0,0)' }, ratioHalfOffset + ratioHalf);

			this.tl.fromTo($logo, ratioHalfOffset * .5, { opacity: 0 }, { opacity: 1, ease: Power0.easeNone }, ratioHalfOffset * .5 + ratioHalf);
			this.tl.add(function () {
				if (_this2.scroller && _this2.scroller.scroll.direction === 1) {
					_this2.$events.emit('header.in');
				}
			}, this.OFFSET * .5 / this.total);
		}
	}, {
		key: 'raf',
		value: function raf(y) {
			(0, _get3.default)(Presentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(Presentation.prototype), 'raf', this).call(this, y);
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(Presentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(Presentation.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(Presentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(Presentation.prototype), '_resize', this).call(this);

			this.OFFSET = window.innerHeight * .8;
			this.bounds.height = window.innerHeight + this.OFFSET;
			this.$el.style.height = this.bounds.height + "px";

			this.boundsAnim = {
				top: this.bounds.top - window.innerHeight * .5,
				bottom: this.bounds.top + this.OFFSET
			};
			this.total = this.boundsAnim.bottom - this.boundsAnim.top;

			this.initTimeline();
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(Presentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(Presentation.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(Presentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(Presentation.prototype), '_off', this).call(this);
		}
	}]);
	return Presentation;
}(_scrollable2.default)) || _class);
exports.default = Presentation;

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(408);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("04f95f60", content, true, {});

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".background{width:100%;height:100%;position:absolute;top:0;left:0;pointer-events:none;z-index:100}.background img{height:100%;width:100%;opacity:.5;object-fit:cover}", ""]);

// exports


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scroller = __webpack_require__(18);

var _scroller2 = _interopRequireDefault(_scroller);

var _ticker = __webpack_require__(19);

var _ticker2 = _interopRequireDefault(_ticker);

var _pixi = __webpack_require__(25);

var PIXI = _interopRequireWildcard(_pixi);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Background = (_dec = (0, _vueClassComponent2.default)({
	name: 'Background',
	components: {}
}), _dec(_class = function (_Vue) {
	(0, _inherits3.default)(Background, _Vue);

	function Background() {
		(0, _classCallCheck3.default)(this, Background);
		return (0, _possibleConstructorReturn3.default)(this, (Background.__proto__ || (0, _getPrototypeOf2.default)(Background)).apply(this, arguments));
	}

	(0, _createClass3.default)(Background, [{
		key: 'mounted',
		value: function mounted() {

			this.init();
		}
	}, {
		key: 'init',
		value: function init() {

			this.app = new PIXI.Application(window.innerWidth, window.innerHeight, {
				transparent: true,
				antialias: false,
				resolution: 1
			});

			this.then = Date.now();

			this.$refs.bg.appendChild(this.app.view);

			this.bgContainer = new PIXI.Container();
			var bg = new PIXI.Graphics();
			bg.beginFill(0xF5F5F5, 1);
			bg.moveTo(0, 0);
			bg.lineTo(0, 0);
			bg.lineTo(window.innerWidth, 0);
			bg.lineTo(window.innerWidth, window.innerHeight);
			bg.lineTo(0, window.innerHeight);
			bg.endFill();
			this.bgContainer.addChild(bg);

			var shader = '\n\t\t\t\tuniform float time;\n\t\t\t\tuniform float fade;\n\t\t\t\tvarying vec2 vTextureCoord;\n\n\t\t\t\tfloat nrand( vec2 n )\n\t\t\t\t{\n\t\t\t\t\treturn fract(sin(dot(n.xy, vec2(12.9898, 204.233)))* 43758.5453);\n\t\t\t\t}\n\n\t\t\t\tfloat n1rand( vec2 n )\n\t\t\t\t{\n\t\t\t\t\tfloat t = fract( time * 1001.0 );\n\t\t\t\t\tfloat nrnd0 = nrand( n + 0.07 * t );\n\t\t\t\t\treturn nrnd0 / fade;\n\t\t\t\t}\n\n\t\t\t\tvoid main()\n\t\t\t\t{\n\t\t\t\t\tfloat o;\n\n\t\t\t\t\to = n1rand( vTextureCoord.xy );\n\n\t\t\t\t\tgl_FragColor = vec4(vec3(o), 0.2);\n\t\t\t\t}\n\n\t\t\t';

			var uniforms = {
				time: {
					type: 'f',
					value: 0.0
				},
				resolution: {
					type: 'v2',
					value: [window.innerWidth, window.innerHeight]
				},
				fade: {
					type: 'f',
					value: 15.0
				}
			};

			this.noiseFilter = new PIXI.Filter('', shader, uniforms);

			this.bgContainer.filters = [this.noiseFilter];
			this.bgContainer.alpha = 1;

			this.app.stage.addChild(this.bgContainer);
			this.app.ticker.add(this.update, this);
		}
	}, {
		key: 'update',
		value: function update() {

			this.now = Date.now();
			this.elapsed = this.now - this.then;

			if (this.elapsed > 1000 / 20) {
				this.then = this.now - this.elapsed % 1000 / 20;
				this.noiseFilter.uniforms.time += .01;
			}
		}
	}, {
		key: 'animateIn',
		value: function animateIn() {
			_gsap.TweenMax.to(this.bgContainer, .5, { alpha: 1, ease: Power0.easeNone });
		}
	}, {
		key: '_resize',
		value: function _resize() {
			if (this.app) {
				this.app.renderer.view.style.width = window.innerWidth + 'px';
				this.app.renderer.view.style.height = window.innerHeight + 'px';
			}
		}
	}]);
	return Background;
}(_vue2.default)) || _class);
exports.default = Background;

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"bg",staticClass:"background"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro-presentation"},[_c('div',{staticClass:"intro-presentation-wrapper movable"},[_c('div',{ref:"presentaiont_text",staticClass:"intro-presentation-text"},[_vm._m(0),_vm._m(1),_vm._m(2),_c('div',{staticClass:"separator"}),_vm._m(3),_vm._m(4),_vm._m(5)]),_vm._m(6)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"sentence"},[_c('span',{staticClass:"mask-right"}),_vm._v(" "),_c('span',{staticClass:"mask-left"}),_vm._v("«JE SUIS POUR QUE TOUT UN TAS DE PRÉSIDENTS ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"sentence"},[_c('span',{staticClass:"mask-right"}),_vm._v(" "),_c('span',{staticClass:"mask-left"}),_vm._v("MORTS* ME REPRÉSENTENT... PARCE QUE JE N'AI JAMAIS ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"sentence"},[_c('span',{staticClass:"mask-right"}),_vm._v(" "),_c('span',{staticClass:"mask-left"}),_vm._v("VU UN PRÉSIDENT LE FAIRE DE SON VIVANT.»")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"sentence"},[_c('span',{staticClass:"mask-right"}),_vm._v(" "),_c('span',{staticClass:"mask-left"}),_vm._v("*dead presidents fait références aux billets de")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"sentence"},[_c('span',{staticClass:"mask-right"}),_vm._v(" "),_c('span',{staticClass:"mask-left"}),_vm._v("banque américains, sur lequel on retrouve les ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"sentence"},[_c('span',{staticClass:"mask-right"}),_vm._v(" "),_c('span',{staticClass:"mask-left"}),_vm._v("visages d'anciens présidents, aujourd'hui décédés.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":"assets/images/logo-joey.png"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_political_vue__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_political_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_political_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98892a98_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_political_vue__ = __webpack_require__(459);
function injectStyle (ssrContext) {
  __webpack_require__(413)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_political_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98892a98_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_political_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(414);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("5ea98c90", content, true, {});

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".political{width:100%;background:#05006c;position:relative}.political .political-section{position:relative;z-index:30}.political .flags-overlay{position:absolute;top:0;left:0;z-index:50}", ""]);

// exports


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _politicalIntro = __webpack_require__(416);

var _politicalIntro2 = _interopRequireDefault(_politicalIntro);

var _politicalSlider = __webpack_require__(430);

var _politicalSlider2 = _interopRequireDefault(_politicalSlider);

var _politicalPresentation = __webpack_require__(439);

var _politicalPresentation2 = _interopRequireDefault(_politicalPresentation);

var _politicalCar = __webpack_require__(444);

var _politicalCar2 = _interopRequireDefault(_politicalCar);

var _background = __webpack_require__(30);

var _background2 = _interopRequireDefault(_background);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _flagsOverlay = __webpack_require__(68);

var _flagsOverlay2 = _interopRequireDefault(_flagsOverlay);

var _Globals = __webpack_require__(16);

var _Globals2 = _interopRequireDefault(_Globals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Political = (_dec = (0, _vueClassComponent2.default)({
	name: 'Political',
	components: { FlagsOverlay: _flagsOverlay2.default, Background: _background2.default, PoliticalIntro: _politicalIntro2.default, PoliticalSlider: _politicalSlider2.default, PoliticalPresentation: _politicalPresentation2.default, PoliticalCar: _politicalCar2.default }
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(Political, _Scrollable);

	function Political() {
		(0, _classCallCheck3.default)(this, Political);
		return (0, _possibleConstructorReturn3.default)(this, (Political.__proto__ || (0, _getPrototypeOf2.default)(Political)).apply(this, arguments));
	}

	(0, _createClass3.default)(Political, [{
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(Political.prototype.__proto__ || (0, _getPrototypeOf2.default)(Political.prototype), 'mounted', this).call(this);

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(Political.prototype.__proto__ || (0, _getPrototypeOf2.default)(Political.prototype), 'init', this).call(this);

			this.scroller.register(this);
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(Political.prototype.__proto__ || (0, _getPrototypeOf2.default)(Political.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_dom',
		value: function _dom() {
			this.$flagsOverlay = this.$el.querySelector('.flags-overlay');
		}
	}, {
		key: 'initTimeline',
		value: function initTimeline() {
			(0, _get3.default)(Political.prototype.__proto__ || (0, _getPrototypeOf2.default)(Political.prototype), 'initTimeline', this).call(this);
		}
	}, {
		key: 'raf',
		value: function raf(y) {
			(0, _get3.default)(Political.prototype.__proto__ || (0, _getPrototypeOf2.default)(Political.prototype), 'raf', this).call(this, y);
		}
	}, {
		key: 'initIntervals',
		value: function initIntervals() {

			var w = _Globals2.default.width;
			var h = _Globals2.default.height;

			this.tl = new TimelineMax({ paused: true });
			this.tl.fromTo(this.$flagsOverlay, 1, { y: 0 }, { y: this.bounds.height - h, ease: Power0.easeNone }, 0);
		}
	}, {
		key: 'raf',
		value: function raf(y) {
			if (!this.scroller.isInViewport(this.bounds.top, this.bounds.height)) return;
			this.perc = this.scroller.getPerc(this.boundsAnim, y);
			this.tl && this.tl.progress(this.perc);

			this.$refs.flags && this.$refs.flags.update(Math.abs(y));
		}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(Political.prototype.__proto__ || (0, _getPrototypeOf2.default)(Political.prototype), '_resize', this).call(this);

			this.boundsAnim = {
				top: this.bounds.top,
				bottom: this.bounds.top + this.bounds.height - _Globals2.default.height
			};

			this.tl && this.tl.progress(this.scroller.getPerc(this.boundsAnim, _Globals2.default.scroll));

			this.initIntervals();
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(Political.prototype.__proto__ || (0, _getPrototypeOf2.default)(Political.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(Political.prototype.__proto__ || (0, _getPrototypeOf2.default)(Political.prototype), '_off', this).call(this);
		}
	}]);
	return Political;
}(_scrollable2.default)) || _class);
exports.default = Political;

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_political_intro_vue__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_political_intro_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_political_intro_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_117349b9_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_political_intro_vue__ = __webpack_require__(429);
function injectStyle (ssrContext) {
  __webpack_require__(417)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_political_intro_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_117349b9_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_political_intro_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(418);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("7671746c", content, true, {});

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".political-intro{width:100%;position:relative}@media screen and (max-width:640px){.political-intro{padding-left:30px;padding-right:30px}}.political-intro .title{width:100%;padding:0 10vw;text-align:center;position:relative;z-index:80}.political-intro .title h2{color:#fff;font-size:100px;font-weight:700}.political-intro .title h2 span{display:inline-block}.political-intro .title h2 span.space{width:20px}.political-intro .fixed-image-wrapper{position:absolute;height:100vh;width:100vw;top:0;left:0}.political-intro .fixed-image-wrapper .image-mask{width:980px;height:550px;z-index:60;overflow:hidden}.political-intro .fixed-image-wrapper .image-mask,.political-intro .fixed-image-wrapper .image-mask .wrap-image{position:absolute;top:50%;left:50%;transform:translate3d(-50%,-50%,0)}.political-intro .fixed-image-wrapper .image-mask img{width:100%;height:100%;object-fit:cover;transform:scale(1.1)}.political-intro .splited-text{width:50vw;margin:auto;text-align:center;margin-top:30px;max-width:720px;position:relative;z-index:80}@media screen and (min-width:1700px){.political-intro .splited-text{max-width:1000px}}@media screen and (max-width:640px){.political-intro .splited-text{width:100%}}", ""]);

// exports


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _sectionIntro = __webpack_require__(57);

var _sectionIntro2 = _interopRequireDefault(_sectionIntro);

var _splitedText = __webpack_require__(42);

var _splitedText2 = _interopRequireDefault(_splitedText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PoliticalIntro = (_dec = (0, _vueClassComponent2.default)({
	name: 'PoliticalIntro',
	components: { SectionIntro: _sectionIntro2.default, SplitedText: _splitedText2.default },
	data: function data() {
		return {
			text: ""
		};
	}
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(PoliticalIntro, _Scrollable);

	function PoliticalIntro() {
		(0, _classCallCheck3.default)(this, PoliticalIntro);
		return (0, _possibleConstructorReturn3.default)(this, (PoliticalIntro.__proto__ || (0, _getPrototypeOf2.default)(PoliticalIntro)).apply(this, arguments));
	}

	(0, _createClass3.default)(PoliticalIntro, [{
		key: 'created',
		value: function created() {
			this.text = this.translate('political.meeting');
		}
	}, {
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(PoliticalIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalIntro.prototype), 'mounted', this).call(this);

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(PoliticalIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalIntro.prototype), 'init', this).call(this);
		}
	}, {
		key: 'initTimeline',
		value: function initTimeline() {
			var _this2 = this;

			(0, _get3.default)(PoliticalIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalIntro.prototype), 'initTimeline', this).call(this);

			var fakeAnim = { value: 0 };

			this.tl.fromTo(fakeAnim, 1, { value: 0 }, { value: 1, ease: Power0.easeNone }, 0);
			this.tl.add(function () {
				if (_this2.scroller.direction == 1 || _this2.isResized == false) {
					_this2.$refs.splitedText.animateIn();
				} else {
					_this2.$refs.splitedText.animateOut();
				}
				_this2.isResized = true;
			}, window.innerHeight * .7 / this.bounds.height);
		}
	}, {
		key: '_dom',
		value: function _dom() {

			this.$text = this.$el.querySelector('.text');
			this.$fakeText = this.$el.querySelector('.fake-text');
		}
	}, {
		key: '_intervals',
		value: function _intervals() {
			var _this3 = this;

			this.scroller.point('text.in' + this.uid, {
				position: this.bounds.top + window.innerHeight * .3,
				direction: 1,
				exec: function exec(e) {
					if (e.direction == 1) {
						_this3.$refs.splitedText.animateIn();
					} else {
						_this3.$refs.splitedText.animateOut();
					}
				}
			});
		}
	}, {
		key: 'raf',
		value: function raf(y) {
			(0, _get3.default)(PoliticalIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalIntro.prototype), 'raf', this).call(this, y);
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(PoliticalIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalIntro.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(PoliticalIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalIntro.prototype), '_resize', this).call(this);

			this.boundsAnim = {
				top: this.bounds.top - window.innerHeight,
				bottom: this.bounds.top + this.bounds.height
			};

			this.isResized = false;

			this.initTimeline();
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(PoliticalIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalIntro.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(PoliticalIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalIntro.prototype), '_off', this).call(this);
		}
	}]);
	return PoliticalIntro;
}(_scrollable2.default)) || _class);
exports.default = PoliticalIntro;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(421);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("1ecb4671", content, true, {});

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".section-intro[data-v-2c014716]{min-height:100vh;width:100%;position:relative;padding-top:calc(50vh + 225px)}@media screen and (max-width:640px){.section-intro[data-v-2c014716]{padding-top:150px!important;min-height:auto}}.section-intro .title[data-v-2c014716]{width:100%;text-align:center;position:relative;z-index:80}.section-intro .title h2[data-v-2c014716]{color:#fff;font-size:6.25em;font-weight:700}@media screen and (max-width:640px){.section-intro .title h2[data-v-2c014716]{font-size:50px}}.section-intro .fixed-image[data-v-2c014716]{position:absolute;height:100vh;width:100%;top:0;left:0;will-change:transform}.section-intro .fixed-image .image-mask[data-v-2c014716]{position:absolute;width:68vw;height:61vh;min-width:980px;min-height:550px;top:50%;left:50%;z-index:60;overflow:hidden;transform:translate3d(-50%,-50%,0)}@media screen and (max-width:640px){.section-intro .fixed-image .image-mask[data-v-2c014716]{width:100%}}.section-intro .fixed-image .image-mask .image-wrapper[data-v-2c014716]{position:absolute;top:50%;left:50%;transform:translate3d(-50%,-50%,0)}@media screen and (max-width:640px){.section-intro .fixed-image .image-mask .image-wrapper[data-v-2c014716]{top:0;left:0;transform:none}}.section-intro .fixed-image .image-mask img[data-v-2c014716]{width:100%;height:100%;object-fit:cover;transform:scale(1.1)}", ""]);

// exports


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _assetsLoader = __webpack_require__(50);

var _assetsLoader2 = _interopRequireDefault(_assetsLoader);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _Globals = __webpack_require__(16);

var _Globals2 = _interopRequireDefault(_Globals);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SectionIntro = (_dec = (0, _vueClassComponent2.default)({
	name: 'SectionIntro',
	props: ["img", "title", "fade", "onEnter", "onLeave"],
	components: {},
	data: function data() {
		return {
			src: undefined
		};
	}
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(SectionIntro, _Scrollable);

	function SectionIntro() {
		(0, _classCallCheck3.default)(this, SectionIntro);
		return (0, _possibleConstructorReturn3.default)(this, (SectionIntro.__proto__ || (0, _getPrototypeOf2.default)(SectionIntro)).apply(this, arguments));
	}

	(0, _createClass3.default)(SectionIntro, [{
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(SectionIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(SectionIntro.prototype), 'mounted', this).call(this);

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(SectionIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(SectionIntro.prototype), 'init', this).call(this);

			this.progress = 0;
			this.scroller.register(this);
			this.loadImg();
		}
	}, {
		key: '_dom',
		value: function _dom() {
			this.$fixedImg = this.$el.querySelector('.fixed-image');
			this.$wrapImg = this.$el.querySelector('.image-wrapper');
			this.$img = this.$wrapImg.querySelector('img');
			this.$maskImg = this.$el.querySelector('.image-mask');
			this.$title = this.$el.querySelector('.title h2');
		}
	}, {
		key: 'loadImg',
		value: function loadImg() {
			var _this2 = this;

			this.bufferImage = new Image();
			this.bufferImage.onload = function () {
				_this2.src = _this2.img;
			};

			this.bufferImage.src = this.img;
		}
	}, {
		key: 'raf',
		value: function raf(y) {
			(0, _get3.default)(SectionIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(SectionIntro.prototype), 'raf', this).call(this, y);
			// if(!this.scroller.isInViewport(this.bounds.top,this.bounds.height) ) return
			// const perc = this.scroller.getPerc(this.boundsAnim, y)		
			// this.tl && this.tl.progress(perc)
		}
	}, {
		key: 'initTimeline',
		value: function initTimeline() {
			var _this3 = this;

			(0, _get3.default)(SectionIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(SectionIntro.prototype), 'initTimeline', this).call(this);

			var totalHeight = _Globals2.default.height + this.bounds.height;
			var firstDuration = _Globals2.default.height / totalHeight;
			var secondDuration = this.bounds.height / totalHeight;
			var fade = this.fade || 0;

			var height = 550 * _Globals2.default.height / 900;
			var width = 980 * _Globals2.default.width / 1440;

			var ratioImg = 980 / 550;
			var ratioW = _Globals2.default.width / _Globals2.default.height;

			_gsap.TweenMax.set(this.$maskImg, { height: height, width: width });

			this.tl.add(function () {

				if (_this3.scroller.direction == 1 || _this3.isResized == false) {
					_gsap.TweenMax.to(_this3.$maskImg, .6, { height: _Globals2.default.height, width: _Globals2.default.width, ease: Expo.easeInOut, delay: .0 });
					_gsap.TweenMax.to(_this3.$img, .8, { scale: 1, delay: .2 });
					_this3.onEnter && _this3.onEnter();
				} else {
					_gsap.TweenMax.to(_this3.$maskImg, .8, { height: height, width: width, ease: Expo.easeOut });
					_gsap.TweenMax.to(_this3.$img, .4, { scale: 1.1 });
					_this3.onLeave && _this3.onLeave();
				}

				_this3.isResized = true;
			}, firstDuration);
			this.tl.fromTo(this.$img, firstDuration, { y: -100 }, { y: 0, ease: Power0.easeNone }, 0);
			this.tl.fromTo(this.$title, firstDuration, { y: 100 }, { y: 0, ease: Power0.easeNone }, 0);
			this.tl.fromTo(this.$fixedImg, secondDuration, { y: 0, opacity: 1 }, { y: this.bounds.height, ease: Power0.easeNone, opacity: fade }, 1 - secondDuration);
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(SectionIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(SectionIntro.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(SectionIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(SectionIntro.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(SectionIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(SectionIntro.prototype), '_off', this).call(this);
		}
	}, {
		key: 'raf',
		value: function raf(y) {
			(0, _get3.default)(SectionIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(SectionIntro.prototype), 'raf', this).call(this, y);
		}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(SectionIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(SectionIntro.prototype), '_resize', this).call(this);

			_gsap.TweenMax.set(this.$wrapImg, { width: _Globals2.default.width, height: _Globals2.default.height });

			this.boundsAnim = {
				top: this.bounds.top - _Globals2.default.height,
				bottom: this.bounds.top + this.bounds.height
			};

			this.initTimeline();
		}
	}]);
	return SectionIntro;
}(_scrollable2.default)) || _class);
exports.default = SectionIntro;

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-intro"},[_c('div',{staticClass:"title"},[_c('h2',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"fixed-image"},[_c('div',{staticClass:"image-mask"},[_c('div',{staticClass:"image-wrapper"},[_c('img',{attrs:{"src":_vm.src}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(425);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("70b6d6b7", content, true, {});

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".splited-text p.line{color:#fff;font-family:Abhaya Libre,serif;font-weight:700;font-size:1.25em;line-height:2.5em}.splited-text p.line span{opacity:0;display:inline-block;transform:translate3d(0,50px,0)}", ""]);

// exports


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _pixi = __webpack_require__(25);

var PIXI = _interopRequireWildcard(_pixi);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _textSpliter = __webpack_require__(427);

var _textSpliter2 = _interopRequireDefault(_textSpliter);

var _Globals = __webpack_require__(16);

var _Globals2 = _interopRequireDefault(_Globals);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SplitedText = (_dec = (0, _vueClassComponent2.default)({
	name: 'SplitedText',
	components: {},
	props: ["text"]
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(SplitedText, _Scrollable);

	function SplitedText() {
		(0, _classCallCheck3.default)(this, SplitedText);
		return (0, _possibleConstructorReturn3.default)(this, (SplitedText.__proto__ || (0, _getPrototypeOf2.default)(SplitedText)).apply(this, arguments));
	}

	(0, _createClass3.default)(SplitedText, [{
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(SplitedText.prototype.__proto__ || (0, _getPrototypeOf2.default)(SplitedText.prototype), 'mounted', this).call(this);

			this.splited = new _textSpliter2.default(".text", this.$el, this.text);

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(SplitedText.prototype.__proto__ || (0, _getPrototypeOf2.default)(SplitedText.prototype), 'init', this).call(this);
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(SplitedText.prototype.__proto__ || (0, _getPrototypeOf2.default)(SplitedText.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_dom',
		value: function _dom() {}
	}, {
		key: 'initTimeline',
		value: function initTimeline() {
			(0, _get3.default)(SplitedText.prototype.__proto__ || (0, _getPrototypeOf2.default)(SplitedText.prototype), 'initTimeline', this).call(this);
		}
	}, {
		key: 'raf',
		value: function raf(y) {
			(0, _get3.default)(SplitedText.prototype.__proto__ || (0, _getPrototypeOf2.default)(SplitedText.prototype), 'raf', this).call(this, y);
		}
	}, {
		key: '_intervals',
		value: function _intervals() {
			var l = this.splited.splited.length;
			this.tlAppear = new TimelineMax({ paused: true });

			for (var i = 0; i < l; i++) {
				var $words = this.splited.splited[i];
				this.tlAppear.staggerTo($words, 1, { y: 0, opacity: 1, delay: .1 * i, ease: Power3.easeOut }, .01, 0);
			}
		}
	}, {
		key: 'animateIn',
		value: function animateIn() {
			var p = this.tlAppear.progress();
			// this.tlAppear.updateTo({ease: Power3.easeOut})
			this.tlAppear.play(p);
		}
	}, {
		key: 'animateOut',
		value: function animateOut() {
			var p = this.tlAppear.progress();
			// this.tlAppear.updateTo({ease: Power3.easeIn})
			this.tlAppear.reverse(p);
		}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(SplitedText.prototype.__proto__ || (0, _getPrototypeOf2.default)(SplitedText.prototype), '_resize', this).call(this);

			this.splited.resize();
			this._intervals();
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(SplitedText.prototype.__proto__ || (0, _getPrototypeOf2.default)(SplitedText.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(SplitedText.prototype.__proto__ || (0, _getPrototypeOf2.default)(SplitedText.prototype), '_off', this).call(this);
		}
	}]);
	return SplitedText;
}(_scrollable2.default)) || _class);
exports.default = SplitedText;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LineThenWord = function () {
	function LineThenWord(tag, scope, text) {
		(0, _classCallCheck3.default)(this, LineThenWord);


		this.tag = tag;
		this.scope = scope || document;
		this.dom = this.scope.querySelector(this.tag);
		this.initialText = text;
		this.text = this.initialText;
		this.width = this.dom.getBoundingClientRect().width;

		this.splited = [];

		this._split();

		return this;
	}

	(0, _createClass3.default)(LineThenWord, [{
		key: "_split",
		value: function _split() {

			this.dom.innerHTML = "";
			var words = this.initialText.split(" ");

			var i = 0;
			var total = 0;

			while (total < words.length) {

				var stack = 0;
				var j = 0;
				var out = false;
				this.splited[i] = [];

				var line = document.createElement('p');
				line.classList.add('line');
				this.dom.appendChild(line);

				while (!out && total < words.length && stack < this.width) {

					var word = document.createElement('span');
					var space = document.createElement('span');

					space.innerHTML = "&nbsp;";
					word.classList.add('word');
					space.classList.add('space');

					word.innerText = words[total];
					line.appendChild(word);
					line.appendChild(space);
					stack += word.getBoundingClientRect().width;
					stack += space.getBoundingClientRect().width;

					if (stack > this.width) {
						word.remove();
						space.remove();
						out = true;
					} else {
						this.splited[i].push(word);

						j++;
						total++;
					}
				}

				i++;
			}
		}
	}, {
		key: "resize",
		value: function resize() {
			this.width = this.dom.getBoundingClientRect().width;
			this._split();
		}
	}]);
	return LineThenWord;
}();

exports.default = LineThenWord;

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"splited-text"},[_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"political-intro"},[_c('section-intro',{attrs:{"img":"assets/images/political-joey.jpg","title":_vm.translate('political.title')}}),_c('splited-text',{ref:"splitedText",attrs:{"text":_vm.text}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_political_slider_vue__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_political_slider_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_political_slider_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_169462e4_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_political_slider_vue__ = __webpack_require__(438);
function injectStyle (ssrContext) {
  __webpack_require__(431)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_political_slider_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_169462e4_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_political_slider_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(432);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("411a54ea", content, true, {});

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".political-slider{width:100%}.political-slider .horizontal-wrapper{width:100%;height:100vh;overflow:hidden;will-change:transform}.political-slider .horizontal-wrapper .slider{height:100vh;width:9999px;display:flex;align-items:center;padding-left:20vw}@media screen and (max-width:640px){.political-slider .horizontal-wrapper .slider{padding-left:2vw}}.political-slider .horizontal-wrapper .slider .wrap-elements{display:flex}.political-slider .horizontal-wrapper .slider .wrap-elements .element{height:60vh;width:60vw;overflow:hidden;position:relative}.political-slider .horizontal-wrapper .slider .wrap-elements .element .overlay{position:absolute;top:0;left:0;height:100%;width:100%;display:flex;align-items:center;justify-content:center;background-color:rgba(0,0,0,.6);z-index:80}.political-slider .horizontal-wrapper .slider .wrap-elements .element .overlay p{color:#fff;max-width:400px;text-align:center;text-transform:uppercase;font-size:1.875em;line-height:1.166666666666667em;letter-spacing:.15em;font-weight:600;font-family:Saira Extra Condensed,sans-serif}@media screen and (min-width:1700px){.political-slider .horizontal-wrapper .slider .wrap-elements .element .overlay p{max-width:550px}}@media screen and (min-width:2400px){.political-slider .horizontal-wrapper .slider .wrap-elements .element .overlay p{max-width:700px}}@media screen and (max-width:640px){.political-slider .horizontal-wrapper .slider .wrap-elements .element{width:94vw;height:80vh}}.political-slider .horizontal-wrapper .slider .wrap-elements .element:nth-child(2){margin:0 2vw}.political-slider .horizontal-wrapper .slider .wrap-elements .element img,.political-slider .horizontal-wrapper .slider .wrap-elements .element video{height:100%;width:100%;object-fit:cover;position:relative;z-index:60}", ""]);

// exports


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scroller = __webpack_require__(18);

var _scroller2 = _interopRequireDefault(_scroller);

var _ticker = __webpack_require__(19);

var _ticker2 = _interopRequireDefault(_ticker);

var _pixi = __webpack_require__(25);

var PIXI = _interopRequireWildcard(_pixi);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _imageCover = __webpack_require__(178);

var _imageCover2 = _interopRequireDefault(_imageCover);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PoliticalSlider = (_dec = (0, _vueClassComponent2.default)({
	name: 'PoliticalSlider',
	components: { CoverImage: _imageCover2.default }
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(PoliticalSlider, _Scrollable);

	function PoliticalSlider() {
		(0, _classCallCheck3.default)(this, PoliticalSlider);
		return (0, _possibleConstructorReturn3.default)(this, (PoliticalSlider.__proto__ || (0, _getPrototypeOf2.default)(PoliticalSlider)).apply(this, arguments));
	}

	(0, _createClass3.default)(PoliticalSlider, [{
		key: 'mounted',
		value: function mounted() {

			(0, _get3.default)(PoliticalSlider.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalSlider.prototype), 'mounted', this).call(this);

			this.$elements = (0, _jquery2.default)(this.$el).find('.element');
			this.$wrapSlider = this.$el.querySelector('.wrap-elements');

			this.$slider = this.$el.querySelector('.horizontal-wrapper');
			this.$images = this.$el.querySelectorAll('.element .images');
			this.$wrapTexts = this.$el.querySelectorAll('.element .wrap-text');
			this.$texts = this.$el.querySelectorAll('.element .text');
		}
	}, {
		key: 'init',
		value: function init() {

			(0, _get3.default)(PoliticalSlider.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalSlider.prototype), 'init', this).call(this);
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(PoliticalSlider.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalSlider.prototype), '_bind', this).call(this);
		}
	}, {
		key: 'initTimeline',
		value: function initTimeline() {
			(0, _get3.default)(PoliticalSlider.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalSlider.prototype), 'initTimeline', this).call(this);
			var moveY = window.innerHeight * .1 / this.newHeight;

			this.tl.fromTo(this.$slider, 1, { y: 0 }, { y: this.newHeight, ease: Power0.easeNone });
			this.tl.fromTo(this.$wrapSlider, 1, { x: 0 }, { x: -(this.newHeight + this.left), ease: Power0.easeNone }, 0);

			var firstTextLeft = this.$wrapTexts[0].getBoundingClientRect().left;
			var lastTextLeft = this.$wrapTexts[2].getBoundingClientRect().left;

			for (var i = 0; i < this.$elements.length; i++) {
				var left = this.$elements.get(i).getBoundingClientRect().left;
				var width = this.$elements.get(i).getBoundingClientRect().width;

				var textLeft = this.$wrapTexts[i].getBoundingClientRect().left;
				var textWidth = this.$wrapTexts[i].getBoundingClientRect().width;

				var toX = textLeft - firstTextLeft;
				var start = _.clamp((left - window.innerWidth) / (this.newHeight + this.left), 0, 1);
				var dur = _.clamp((width - (window.innerWidth - left)) / (this.newHeight + this.left), 0, width / (this.newHeight + this.left));

				var test1 = _.clamp((left - window.innerWidth) / this.newHeight, 0, 1);

				this.tl.fromTo(this.$texts[i], 1, { x: -toX }, { x: lastTextLeft - textLeft, ease: Power0.easeNone }, 0);
				this.tl.fromTo(this.$images[i], dur, { x: -_.clamp(left - width, 0, 10000000) * .4, scale: 1 }, { x: 0, ease: Power0.easeNone }, start);
			}

			var testLeft = this.$elements.get(0).getBoundingClientRect().left;
			var testWidth = this.$elements.get(0).getBoundingClientRect().width;

			var startLeft = _.clamp((testLeft - window.innerWidth) / this.newHeight, 0, 1);

			var outStart = testLeft / (this.newHeight + this.left);
			var outDur = testWidth / (this.newHeight + this.left);

			this.tl.to(this.$images[0], outDur, { x: _.clamp(300, 0, 10000000) * .4, ease: Power0.easeNone }, outStart);

			var testLeft1 = this.$elements.get(1).getBoundingClientRect().left;
			var testWidth1 = this.$elements.get(1).getBoundingClientRect().width;

			var outStart1 = testLeft1 / (this.newHeight + this.left);
			var outDur1 = (testWidth1 - this.left) / (this.newHeight + this.left);

			this.tl.to(this.$images[1], outDur1, { x: _.clamp(300, 0, 10000000) * .4, ease: Power0.easeNone }, outStart1);
		}
	}, {
		key: 'raf',
		value: function raf(y) {
			(0, _get3.default)(PoliticalSlider.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalSlider.prototype), 'raf', this).call(this, y);
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(PoliticalSlider.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalSlider.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(PoliticalSlider.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalSlider.prototype), '_off', this).call(this);
		}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(PoliticalSlider.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalSlider.prototype), '_resize', this).call(this);

			this.left = parseInt(window.getComputedStyle(this.$el.querySelector('.slider'), null).getPropertyValue('padding-left'));

			this.newHeight = this.$wrapSlider.getBoundingClientRect().width - window.innerWidth + this.left;

			this.bounds.height = window.innerHeight + this.newHeight;
			this.$el.style.height = this.bounds.height + "px";

			this.boundsAnim = {
				top: this.bounds.top,
				bottom: this.bounds.top + this.newHeight
			};

			this.initTimeline();
		}
	}]);
	return PoliticalSlider;
}(_scrollable2.default)) || _class);
exports.default = PoliticalSlider;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(435);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("0de73079", content, true, {});

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".cover-image{position:relative;width:100%;height:100%}.cover-image img{width:100%;height:100%;object-fit:cover}", ""]);

// exports


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CoverImage = (_dec = (0, _vueClassComponent2.default)({
	name: 'CoverImage',
	components: {},
	props: ["src"],
	data: function data() {
		return {
			img: undefined
		};
	}
}), _dec(_class = function (_Vue) {
	(0, _inherits3.default)(CoverImage, _Vue);

	function CoverImage() {
		(0, _classCallCheck3.default)(this, CoverImage);
		return (0, _possibleConstructorReturn3.default)(this, (CoverImage.__proto__ || (0, _getPrototypeOf2.default)(CoverImage)).apply(this, arguments));
	}

	(0, _createClass3.default)(CoverImage, [{
		key: 'mounted',
		value: function mounted() {
			this.init();
		}
	}, {
		key: 'init',
		value: function init() {

			this.load();
		}
	}, {
		key: 'load',
		value: function load() {
			var _this2 = this;

			var bufferImg = new Image();
			bufferImg.onload = function () {
				_this2.img = _this2.src;
			};
			bufferImg.src = this.src;
		}
	}, {
		key: '_resize',
		value: function _resize() {}
	}]);
	return CoverImage;
}(_vue2.default)) || _class);
exports.default = CoverImage;

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cover-image"},[_c('img',{ref:"image",staticClass:"image",attrs:{"src":_vm.img}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"political-slider"},[_c('div',{staticClass:"horizontal-wrapper"},[_c('div',{staticClass:"slider"},[_c('div',{staticClass:"wrap-elements"},[_c('div',{staticClass:"element"},[_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"wrap-text"},[_c('p',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.translate('political.slider.slider_1'))}})])]),_c('cover-image',{staticClass:"images",attrs:{"src":"assets/images/political-slide-1.jpg"}})],1),_c('div',{staticClass:"element"},[_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"wrap-text"},[_c('p',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.translate('political.slider.slider_2'))}})])]),_c('cover-image',{staticClass:"images",attrs:{"src":"assets/images/political-slide-2.jpg"}})],1),_c('div',{staticClass:"element"},[_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"wrap-text"},[_c('p',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.translate('political.slider.slider_3'))}})])]),_c('video',{staticClass:"images",attrs:{"src":"assets/videos/slider-video-badass.mp4","poster":"assets/images/political-slide-3.jpg","autoplay":"autoplay","loop":"loop","muted":"muted"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_political_presentation_vue__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_political_presentation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_political_presentation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e20485d_hasScoped_true_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_political_presentation_vue__ = __webpack_require__(443);
function injectStyle (ssrContext) {
  __webpack_require__(440)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e20485d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_political_presentation_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e20485d_hasScoped_true_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_political_presentation_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(441);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("5f951e66", content, true, {});

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".political-presentation[data-v-7e20485d]{width:100%;position:relative;overflow:hidden;padding-top:5vh}@media screen and (max-width:640px){.political-presentation[data-v-7e20485d]{padding:0 30px}}.political-presentation .wrap-text[data-v-7e20485d]{height:60vh;width:100%;display:flex;justify-content:center;will-change:transform}.political-presentation .wrap-text .splited-text[data-v-7e20485d]{width:50vw;text-align:center}@media screen and (max-width:640px){.political-presentation .wrap-text .splited-text[data-v-7e20485d]{width:100vw}}.political-presentation .badge[data-v-7e20485d]{position:absolute;width:18vw}.political-presentation .badge img[data-v-7e20485d]{width:100%}@media screen and (max-width:640px){.political-presentation .badge[data-v-7e20485d]{width:100px}}.political-presentation .badge-1[data-v-7e20485d]{top:25vh;right:5vw}@media screen and (max-width:640px){.political-presentation .badge-1[data-v-7e20485d]{right:-50px}}.political-presentation .badge-2[data-v-7e20485d]{top:1vh;left:2vw}@media screen and (max-width:640px){.political-presentation .badge-2[data-v-7e20485d]{bottom:-20px;left:-40px}}", ""]);

// exports


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _assetsLoader = __webpack_require__(50);

var _assetsLoader2 = _interopRequireDefault(_assetsLoader);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _Globals = __webpack_require__(16);

var _Globals2 = _interopRequireDefault(_Globals);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _splitedText = __webpack_require__(42);

var _splitedText2 = _interopRequireDefault(_splitedText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PoliticalPresentation = (_dec = (0, _vueClassComponent2.default)({
	name: 'PoliticalPresentation',
	props: [],
	components: { SplitedText: _splitedText2.default },
	data: function data() {
		return {
			text: ""
		};
	}
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(PoliticalPresentation, _Scrollable);

	function PoliticalPresentation() {
		(0, _classCallCheck3.default)(this, PoliticalPresentation);
		return (0, _possibleConstructorReturn3.default)(this, (PoliticalPresentation.__proto__ || (0, _getPrototypeOf2.default)(PoliticalPresentation)).apply(this, arguments));
	}

	(0, _createClass3.default)(PoliticalPresentation, [{
		key: 'created',
		value: function created() {
			this.text = this.translate('political.today');
		}
	}, {
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(PoliticalPresentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalPresentation.prototype), 'mounted', this).call(this);

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(PoliticalPresentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalPresentation.prototype), 'init', this).call(this);

			this.isResized = false;
		}
	}, {
		key: '_dom',
		value: function _dom() {
			this.$text = this.$el.querySelector('.wrap-text');
			this.$badge1 = this.$el.querySelector('.badge-1');
			this.$badge2 = this.$el.querySelector('.badge-2');
		}
	}, {
		key: 'initTimeline',
		value: function initTimeline() {
			var _this2 = this;

			(0, _get3.default)(PoliticalPresentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalPresentation.prototype), 'initTimeline', this).call(this);

			var h = _Globals2.default.height;

			this.tl.set(this.$badge1, { y: -120 });
			this.tl.set(this.$badge2, { y: 40 });
			this.tl.to(this.$badge1, 1, { y: 120, ease: Power0.easeNone }, 0);
			this.tl.to(this.$badge2, 1, { y: -60, ease: Power0.easeNone }, 0);
			this.tl.add(function () {
				if (_this2.scroller.direction == 1 || _this2.isResized == false) {
					_this2.$refs.splitedText.animateIn();
				} else {
					_this2.$refs.splitedText.animateOut();
				}

				_this2.isResized = true;
			}, _Globals2.default.height * .2 / (_Globals2.default.height + this.bounds.height));
		}
	}, {
		key: 'raf',
		value: function raf(y) {
			(0, _get3.default)(PoliticalPresentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalPresentation.prototype), 'raf', this).call(this, y);
		}

		// _points () {

		// 	this.scroller.point('text.appear'+this._uid,{
		// 		position: this.bounds.top - window.innerHeight*.7,
		// 		direction: 1,
		// 		exec: (e)=>{

		// 			if(e.direction == 1 || this.isResized == false) {
		// 				this.$refs.splitedText.animateIn()
		// 			} else {
		// 				this.$refs.splitedText.animateOut()
		// 			}

		// 			this.isResized = true
		// 		}
		// 	})
		// }

	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(PoliticalPresentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalPresentation.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(PoliticalPresentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalPresentation.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(PoliticalPresentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalPresentation.prototype), '_off', this).call(this);
		}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(PoliticalPresentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalPresentation.prototype), '_resize', this).call(this);

			this.isResized = false;

			this.boundsAnim = {
				top: this.bounds.top - _Globals2.default.height,
				bottom: this.bounds.top + this.bounds.height
			};

			this.initTimeline();

			// this._points()
		}
	}]);
	return PoliticalPresentation;
}(_scrollable2.default)) || _class);
exports.default = PoliticalPresentation;

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"political-presentation"},[_c('div',{staticClass:"wrap-text"},[_c('splited-text',{ref:"splitedText",attrs:{"text":_vm.text}})],1),_vm._m(0),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge badge-1"},[_c('img',{attrs:{"src":"assets/images/badge.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge badge-2"},[_c('img',{attrs:{"src":"assets/images/badge.png"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_political_car_vue__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_political_car_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_political_car_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_205a9861_hasScoped_true_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_political_car_vue__ = __webpack_require__(448);
function injectStyle (ssrContext) {
  __webpack_require__(445)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-205a9861"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_political_car_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_205a9861_hasScoped_true_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_political_car_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(446);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("279be6e7", content, true, {});

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".political-car[data-v-205a9861]{min-height:100vh;width:100vw;position:relative;overflow:hidden;z-index:60}.political-car .movable[data-v-205a9861]{height:100vh;width:100vw;position:relative;will-change:transform}.political-car .car-background[data-v-205a9861]{position:relative;z-index:30;height:100vh;width:100%}.political-car .car-background img[data-v-205a9861]{height:100%;width:100%;object-fit:cover}.political-car .car[data-v-205a9861]{position:absolute;width:100%;bottom:0;left:50%;transform:translateX(-50%);z-index:40}.political-car .car-body[data-v-205a9861]{position:relative;bottom:0;left:0;z-index:40;width:100%}.political-car .car-body img[data-v-205a9861]{height:100%;width:100%;object-fit:cover}.political-car .car-window[data-v-205a9861]{position:absolute;bottom:306px;left:807px;width:178px;height:72px;overflow:hidden;z-index:50}.political-car .car-window img[data-v-205a9861]{width:100%;transform:translateY(0)}.political-car [class^=car-wheel][data-v-205a9861]{position:absolute;bottom:50px;left:100px;z-index:50}.political-car [class^=car-wheel] img[data-v-205a9861]{width:100%}.political-car .car-wheel-left[data-v-205a9861]{bottom:100px}", ""]);

// exports


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _assetsLoader = __webpack_require__(50);

var _assetsLoader2 = _interopRequireDefault(_assetsLoader);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _Globals = __webpack_require__(16);

var _Globals2 = _interopRequireDefault(_Globals);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _imageCover = __webpack_require__(178);

var _imageCover2 = _interopRequireDefault(_imageCover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PoliticalCar = (_dec = (0, _vueClassComponent2.default)({
	name: 'PoliticalCar',
	props: [],
	components: { CoverImage: _imageCover2.default }
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(PoliticalCar, _Scrollable);

	function PoliticalCar() {
		(0, _classCallCheck3.default)(this, PoliticalCar);
		return (0, _possibleConstructorReturn3.default)(this, (PoliticalCar.__proto__ || (0, _getPrototypeOf2.default)(PoliticalCar)).apply(this, arguments));
	}

	(0, _createClass3.default)(PoliticalCar, [{
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(PoliticalCar.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalCar.prototype), 'mounted', this).call(this);

			this._dom();
			this.offset = 4000;
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(PoliticalCar.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalCar.prototype), 'init', this).call(this);
		}
	}, {
		key: '_dom',
		value: function _dom() {
			this.$movable = this.$el.querySelector('.movable');
			this.$window = this.$el.querySelector('.car-window');
			this.$windowEl = this.$window.querySelector('img');
			this.$car = this.$el.querySelector('.car-container');
			this.$wheelLeft = this.$el.querySelector('.car-wheel-left');
			this.$wheelRight = this.$el.querySelector('.car-wheel-right');
		}
	}, {
		key: 'initTimeline',
		value: function initTimeline() {
			(0, _get3.default)(PoliticalCar.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalCar.prototype), 'initTimeline', this).call(this);

			var width = 1701;
			var height = 1016;

			var g_w = _Globals2.default.width;

			this.$window.style.width = window.innerWidth * 211 / 1701 + "px";
			this.$window.style.height = window.innerWidth * 72 / 1440 + "px";
			this.$window.style.bottom = window.innerWidth * 306 / 1440 + "px";
			this.$window.style.left = window.innerWidth * 807 / 1440 + "px";

			this.$wheelLeft.style.width = window.innerWidth * 98 / 1440 + "px";
			this.$wheelLeft.style.left = window.innerWidth * 294 / 1440 + "px";
			this.$wheelLeft.style.bottom = window.innerWidth * 127 / 1440 + "px";

			this.$wheelRight.style.width = window.innerWidth * 93 / 1440 + "px";
			this.$wheelRight.style.left = window.innerWidth * 1082 / 1440 + "px";
			this.$wheelRight.style.bottom = window.innerWidth * 126 / 1440 + "px";

			var totalHeight = window.innerHeight * 2 + this.offset;
			var windowRatio = window.innerHeight / totalHeight;

			this.tl.fromTo(this.$car, 1 / 3, { x: g_w }, { x: 200, ease: Power0.easeNone }, 0);
			this.tl.to(this.$car, 1 / 3, { x: -200, ease: Power0.easeNone }, 1 / 3);
			this.tl.to(this.$car, 1 / 3, { x: -g_w, ease: Power0.easeNone }, 2 / 3);

			this.tl.fromTo(this.$windowEl, 1 / 3, { y: '0%' }, { y: '100%', ease: Power1.easeOut }, 1 / 3);

			this.tl.fromTo(this.$wheelLeft, 1 / 3, { rotationZ: 0 }, { rotationZ: -450, ease: Power0.easeNone }, 0);
			this.tl.to(this.$wheelLeft, 1 / 3, { rotationZ: -630, ease: Power0.easeNone }, 1 / 3);
			this.tl.to(this.$wheelLeft, 1 / 3, { rotationZ: -1080, ease: Power0.easeNone }, 2 / 3);

			this.tl.fromTo(this.$wheelRight, 1 / 3, { rotationZ: 0 }, { rotationZ: -450, ease: Power0.easeNone }, 0);
			this.tl.to(this.$wheelRight, 1 / 3, { rotationZ: -630, ease: Power0.easeNone }, 1 / 3);
			this.tl.to(this.$wheelRight, 1 / 3, { rotationZ: -1080, ease: Power0.easeNone }, 2 / 3);

			this.tl.fromTo(this.$movable, 1 - windowRatio * 2, { y: 0 }, { y: this.offset, ease: Power0.easeNone }, windowRatio);
		}
	}, {
		key: 'raf',
		value: function raf(y) {
			(0, _get3.default)(PoliticalCar.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalCar.prototype), 'raf', this).call(this, y);
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(PoliticalCar.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalCar.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(PoliticalCar.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalCar.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(PoliticalCar.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalCar.prototype), '_off', this).call(this);
		}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(PoliticalCar.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalCar.prototype), '_resize', this).call(this);

			this.bounds.height = window.innerHeight + this.offset;
			this.$el.style.height = this.bounds.height + "px";

			this.boundsAnim = {
				top: this.bounds.top - window.innerHeight,
				bottom: this.bounds.top + this.offset + window.innerHeight
			};

			this.initTimeline();
		}
	}]);
	return PoliticalCar;
}(_scrollable2.default)) || _class);
exports.default = PoliticalCar;

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"political-car"},[_c('div',{staticClass:"movable"},[_c('div',{staticClass:"car-background"},[_c('cover-image',{attrs:{"src":"assets/images/car-background.jpg"}})],1),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"car"},[_c('div',{staticClass:"car-container"},[_c('div',{staticClass:"car-body"},[_c('img',{attrs:{"src":"assets/images/car.png"}})]),_c('div',{staticClass:"car-window"},[_c('img',{attrs:{"src":"assets/images/car-window.png"}})]),_c('div',{staticClass:"car-wheel-left"},[_c('img',{attrs:{"src":"assets/images/wheel-left.png"}})]),_c('div',{staticClass:"car-wheel-right"},[_c('img',{attrs:{"src":"assets/images/wheel-right.png"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(450);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("38d5b94a", content, true, {});

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".flags-overlay{width:100vw;height:100vh}", ""]);

// exports


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scroller = __webpack_require__(18);

var _scroller2 = _interopRequireDefault(_scroller);

var _ticker = __webpack_require__(19);

var _ticker2 = _interopRequireDefault(_ticker);

var _section = __webpack_require__(41);

var _section2 = _interopRequireDefault(_section);

var _flagsData = __webpack_require__(452);

var _flagsData2 = _interopRequireDefault(_flagsData);

var _flag = __webpack_require__(453);

var _flag2 = _interopRequireDefault(_flag);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _Globals = __webpack_require__(16);

var _Globals2 = _interopRequireDefault(_Globals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlagsOverlay = (_dec = (0, _vueClassComponent2.default)({
	name: 'FlagsOverlay',
	components: { Flag: _flag2.default },
	props: [],
	data: function data() {
		return {
			flags: _flagsData2.default.flags
		};
	}
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(FlagsOverlay, _Scrollable);

	function FlagsOverlay() {
		(0, _classCallCheck3.default)(this, FlagsOverlay);
		return (0, _possibleConstructorReturn3.default)(this, (FlagsOverlay.__proto__ || (0, _getPrototypeOf2.default)(FlagsOverlay)).apply(this, arguments));
	}

	(0, _createClass3.default)(FlagsOverlay, [{
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(FlagsOverlay.prototype.__proto__ || (0, _getPrototypeOf2.default)(FlagsOverlay.prototype), 'mounted', this).call(this);

			this.$events.on('app.loaded', this.init);
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(FlagsOverlay.prototype.__proto__ || (0, _getPrototypeOf2.default)(FlagsOverlay.prototype), 'init', this).call(this);
		}
	}, {
		key: 'initTimeline',
		value: function initTimeline() {
			(0, _get3.default)(FlagsOverlay.prototype.__proto__ || (0, _getPrototypeOf2.default)(FlagsOverlay.prototype), 'initTimeline', this).call(this);

			for (var i = 0; i < this.$refs.flag.length; i++) {
				var f = this.$refs.flag[i].$el;
				var r = Math.random() * (300 - 50) + 50;
				this.tl.fromTo(f, 1, { y: r }, { y: 0 }, 0);
			}
		}
	}, {
		key: 'raf',
		value: function raf(y) {
			(0, _get3.default)(FlagsOverlay.prototype.__proto__ || (0, _getPrototypeOf2.default)(FlagsOverlay.prototype), 'raf', this).call(this, y);
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(FlagsOverlay.prototype.__proto__ || (0, _getPrototypeOf2.default)(FlagsOverlay.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(FlagsOverlay.prototype.__proto__ || (0, _getPrototypeOf2.default)(FlagsOverlay.prototype), '_resize', this).call(this);

			this.boundsAnim = {
				top: this.bounds.top - window.innerHeight,
				bottom: this.bounds.top
			};

			for (var i = 0; i < this.$refs.flag.length; i++) {
				var f = this.$refs.flag[i];

				f.resize();
			}
		}
	}, {
		key: 'update',
		value: function update(pos) {
			for (var i = 0; i < this.$refs.flag.length; i++) {
				var f = this.$refs.flag[i];

				f.update(pos);
			}
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(FlagsOverlay.prototype.__proto__ || (0, _getPrototypeOf2.default)(FlagsOverlay.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(FlagsOverlay.prototype.__proto__ || (0, _getPrototypeOf2.default)(FlagsOverlay.prototype), '_off', this).call(this);
		}
	}]);
	return FlagsOverlay;
}(_scrollable2.default)) || _class);
exports.default = FlagsOverlay;

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports = {"flags":[{"x":50,"y":180,"mobile":true},{"x":90,"y":730,"mobile":true},{"x":180,"y":400,"mobile":true},{"x":426,"y":180,"mobile":true},{"x":400,"y":600,"mobile":true},{"x":485,"y":622,"mobile":true},{"x":530,"y":78,"mobile":true},{"x":500,"y":400,"mobile":true},{"x":1130,"y":360,"mobile":true},{"x":1194,"y":116,"mobile":true},{"x":1260,"y":530,"mobile":true},{"x":1282,"y":550,"mobile":true},{"x":1400,"y":379,"mobile":true}]}

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_flag_vue__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_flag_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_flag_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f9fd18b_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_flag_vue__ = __webpack_require__(457);
function injectStyle (ssrContext) {
  __webpack_require__(454)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_flag_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f9fd18b_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_flag_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(455);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("b45b24fa", content, true, {});

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".flag{position:absolute}.flag .flag-wrapper{height:50px;width:40px;background-repeat:no-repeat;background-position:0 0}", ""]);

// exports


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scroller = __webpack_require__(18);

var _scroller2 = _interopRequireDefault(_scroller);

var _ticker = __webpack_require__(19);

var _ticker2 = _interopRequireDefault(_ticker);

var _section = __webpack_require__(41);

var _section2 = _interopRequireDefault(_section);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Flag = (_dec = (0, _vueClassComponent2.default)({
	name: 'Flag',
	components: {},
	props: ["x", "y"]
}), _dec(_class = function (_Vue) {
	(0, _inherits3.default)(Flag, _Vue);

	function Flag() {
		(0, _classCallCheck3.default)(this, Flag);
		return (0, _possibleConstructorReturn3.default)(this, (Flag.__proto__ || (0, _getPrototypeOf2.default)(Flag)).apply(this, arguments));
	}

	(0, _createClass3.default)(Flag, [{
		key: 'mounted',
		value: function mounted() {
			this.init();
		}
	}, {
		key: 'init',
		value: function init() {

			this.gap = 40;
			this.steps = 11;
			this.random = Math.random() * 11;

			this._dom();
			this.setPosition();
		}
	}, {
		key: '_dom',
		value: function _dom() {
			this.$flag = this.$el.querySelector('.flag-wrapper');
		}
	}, {
		key: 'setPosition',
		value: function setPosition() {
			this.$el.style.left = this.x * window.innerWidth / 1440 + "px";
			this.$el.style.top = this.y * window.innerHeight / 900 + "px";
		}
	}, {
		key: 'update',
		value: function update(pos) {
			var to = Math.floor((pos * 0.05 + this.random) % this.steps);
			this.$flag.style.backgroundPosition = -this.gap * to + 'px 0px';
		}
	}, {
		key: 'resize',
		value: function resize() {
			this.setPosition();
		}
	}]);
	return Flag;
}(_vue2.default)) || _class);
exports.default = Flag;

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flag"},[_c('div',{staticClass:"flag-wrapper",staticStyle:{"background-image":"url(assets/images/joey-flag-small.png)"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flags-overlay"},_vm._l((_vm.flags),function(flag,i){return _c('flag',{key:flag.id,ref:"flag",refInFor:true,attrs:{"x":flag.x,"y":flag.y}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"political"},[_c('flags-overlay',{ref:"flags"}),_c('political-intro',{staticClass:"political-section"}),_c('political-slider',{staticClass:"political-section"}),_c('political-presentation',{staticClass:"political-section"}),_c('political-car',{staticClass:"political-section"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_youth_vue__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_youth_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_youth_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d6f93e0_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_youth_vue__ = __webpack_require__(487);
function injectStyle (ssrContext) {
  __webpack_require__(461)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_youth_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d6f93e0_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_youth_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(462);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("77f2710c", content, true, {});

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".youth{width:100%;background:#05006c;position:relative}", ""]);

// exports


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scroller = __webpack_require__(18);

var _scroller2 = _interopRequireDefault(_scroller);

var _ticker = __webpack_require__(19);

var _ticker2 = _interopRequireDefault(_ticker);

var _pixi = __webpack_require__(25);

var PIXI = _interopRequireWildcard(_pixi);

var _youthIntro = __webpack_require__(464);

var _youthIntro2 = _interopRequireDefault(_youthIntro);

var _youthPresentation = __webpack_require__(179);

var _youthPresentation2 = _interopRequireDefault(_youthPresentation);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Youth = (_dec = (0, _vueClassComponent2.default)({
	name: 'Youth',
	components: { YouthIntro: _youthIntro2.default, YouthPresentation: _youthPresentation2.default }
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(Youth, _Scrollable);

	function Youth() {
		(0, _classCallCheck3.default)(this, Youth);
		return (0, _possibleConstructorReturn3.default)(this, (Youth.__proto__ || (0, _getPrototypeOf2.default)(Youth)).apply(this, arguments));
	}

	(0, _createClass3.default)(Youth, [{
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(Youth.prototype.__proto__ || (0, _getPrototypeOf2.default)(Youth.prototype), 'mounted', this).call(this);

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(Youth.prototype.__proto__ || (0, _getPrototypeOf2.default)(Youth.prototype), 'init', this).call(this);
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(Youth.prototype.__proto__ || (0, _getPrototypeOf2.default)(Youth.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_dom',
		value: function _dom() {}
	}, {
		key: 'initIntervals',
		value: function initIntervals() {}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(Youth.prototype.__proto__ || (0, _getPrototypeOf2.default)(Youth.prototype), '_resize', this).call(this);

			this.initIntervals();
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(Youth.prototype.__proto__ || (0, _getPrototypeOf2.default)(Youth.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(Youth.prototype.__proto__ || (0, _getPrototypeOf2.default)(Youth.prototype), '_off', this).call(this);
		}
	}]);
	return Youth;
}(_scrollable2.default)) || _class);
exports.default = Youth;

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_youth_intro_vue__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_youth_intro_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_youth_intro_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b0b93e5_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_youth_intro_vue__ = __webpack_require__(486);
function injectStyle (ssrContext) {
  __webpack_require__(465)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_youth_intro_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b0b93e5_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_youth_intro_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(466);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("1d63b6af", content, true, {});

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".youth-intro{width:100%;position:relative}", ""]);

// exports


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scroller = __webpack_require__(18);

var _scroller2 = _interopRequireDefault(_scroller);

var _ticker = __webpack_require__(19);

var _ticker2 = _interopRequireDefault(_ticker);

var _pixi = __webpack_require__(25);

var PIXI = _interopRequireWildcard(_pixi);

var _sectionIntro = __webpack_require__(57);

var _sectionIntro2 = _interopRequireDefault(_sectionIntro);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _youthPresentation = __webpack_require__(179);

var _youthPresentation2 = _interopRequireDefault(_youthPresentation);

var _youthBaby = __webpack_require__(485);

var _youthBaby2 = _interopRequireDefault(_youthBaby);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var YouthIntro = (_dec = (0, _vueClassComponent2.default)({
	name: 'YouthIntro',
	components: { SectionIntro: _sectionIntro2.default, YouthPresentation: _youthPresentation2.default },
	data: function data() {
		return {
			babyImg: _youthBaby2.default
		};
	}
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(YouthIntro, _Scrollable);

	function YouthIntro() {
		(0, _classCallCheck3.default)(this, YouthIntro);
		return (0, _possibleConstructorReturn3.default)(this, (YouthIntro.__proto__ || (0, _getPrototypeOf2.default)(YouthIntro)).apply(this, arguments));
	}

	(0, _createClass3.default)(YouthIntro, [{
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(YouthIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(YouthIntro.prototype), 'mounted', this).call(this);

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(YouthIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(YouthIntro.prototype), 'init', this).call(this);
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(YouthIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(YouthIntro.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_dom',
		value: function _dom() {}
	}, {
		key: 'onEnter',
		value: function onEnter() {
			this.$events.emit('scroll.out');
		}
	}, {
		key: 'onLeave',
		value: function onLeave() {
			this.$events.emit('scroll.in');
		}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(YouthIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(YouthIntro.prototype), '_resize', this).call(this);
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(YouthIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(YouthIntro.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(YouthIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(YouthIntro.prototype), '_off', this).call(this);
		}
	}]);
	return YouthIntro;
}(_scrollable2.default)) || _class);
exports.default = YouthIntro;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(469);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("86cd9018", content, true, {});

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".youth-presentation{width:100%;padding-bottom:40%;position:relative;padding-top:50px}.youth-presentation .youth-presentation-text{width:20%;margin-left:10%;position:relative;z-index:50}@media screen and (max-width:640px){.youth-presentation .youth-presentation-text{width:100%;margin-left:0}}.youth-presentation .youth-presentation-text .text{font-size:1em;line-height:1.5em;color:#fff;font-family:Abhaya Libre,serif;width:100%}.youth-presentation .youth-presentation-text .text a{color:#fff;font-weight:700}@media screen and (max-width:640px){.youth-presentation .youth-presentation-text .text{font-size:1.25em}}.youth-presentation .youth-presentation-quote{width:100%;max-width:1050px;margin:auto;text-align:center;margin-top:60px;position:relative;z-index:50}@media screen and (max-width:640px){.youth-presentation .youth-presentation-quote{margin-top:30px}}.youth-presentation .mobile-image{width:100%;margin:20px 0}.youth-presentation .wrap-image{position:absolute;z-index:30}.youth-presentation .wrap-image img{width:100%}.youth-presentation .wrap-image.image-1{left:40%;top:150px;width:15%}.youth-presentation .wrap-image.image-2{top:400px;left:-5%;width:35%}.youth-presentation .wrap-image.image-3{right:15%;top:250px;width:25%}.youth-presentation .wrap-image.image-4{right:30%;top:700px;width:25%}.youth-presentation .wrap-image.image-5{bottom:70px;right:8%;width:10%}", ""]);

// exports


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _gsap = __webpack_require__(6);

var _Globals = __webpack_require__(16);

var _Globals2 = _interopRequireDefault(_Globals);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _quote = __webpack_require__(99);

var _quote2 = _interopRequireDefault(_quote);

var _responsiveImage = __webpack_require__(100);

var _responsiveImage2 = _interopRequireDefault(_responsiveImage);

var _youthCrew = __webpack_require__(479);

var _youthCrew2 = _interopRequireDefault(_youthCrew);

var _youthDuo = __webpack_require__(480);

var _youthDuo2 = _interopRequireDefault(_youthDuo);

var _youthTrio = __webpack_require__(481);

var _youthTrio2 = _interopRequireDefault(_youthTrio);

var _youthMom = __webpack_require__(482);

var _youthMom2 = _interopRequireDefault(_youthMom);

var _youthStudent = __webpack_require__(483);

var _youthStudent2 = _interopRequireDefault(_youthStudent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var YouthPresentation = (_dec = (0, _vueClassComponent2.default)({
	name: 'YouthPresentation',
	components: { ResponsiveImage: _responsiveImage2.default, Quote: _quote2.default },
	data: function data() {
		return {
			state: _Globals2.default.state,
			crewImg: _youthCrew2.default,
			duoImg: _youthDuo2.default,
			trioImg: _youthTrio2.default,
			momImg: _youthMom2.default,
			studenImg: _youthStudent2.default
		};
	},
	computed: {
		isMobile: function isMobile() {
			return this.state.isMobile;
		},
		isTablet: function isTablet() {
			return this.state.isTablet;
		}
	}
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(YouthPresentation, _Scrollable);

	function YouthPresentation() {
		(0, _classCallCheck3.default)(this, YouthPresentation);
		return (0, _possibleConstructorReturn3.default)(this, (YouthPresentation.__proto__ || (0, _getPrototypeOf2.default)(YouthPresentation)).apply(this, arguments));
	}

	(0, _createClass3.default)(YouthPresentation, [{
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(YouthPresentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(YouthPresentation.prototype), 'mounted', this).call(this);

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(YouthPresentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(YouthPresentation.prototype), 'init', this).call(this);
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(YouthPresentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(YouthPresentation.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_dom',
		value: function _dom() {
			this.$image1 = this.$el.querySelector('.image-1');
			this.$image2 = this.$el.querySelector('.image-2');
			this.$image3 = this.$el.querySelector('.image-3');
			this.$image4 = this.$el.querySelector('.image-4');
			this.$image5 = this.$el.querySelector('.image-5');
		}
	}, {
		key: 'initTimeline',
		value: function initTimeline() {
			(0, _get3.default)(YouthPresentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(YouthPresentation.prototype), 'initTimeline', this).call(this);

			this.tl.fromTo(this.$image1, 1, { y: 200 }, { y: -200 }, 0);
			this.tl.fromTo(this.$image2, 1, { y: -100 }, { y: 100 }, 0);
			this.tl.fromTo(this.$image3, 1, { y: 0 }, { y: 100 }, 0);
			this.tl.fromTo(this.$image4, 1, { y: 50 }, { y: -50 }, 0);
			this.tl.fromTo(this.$image5, 1, { y: 200 }, { y: -50 }, 0);
		}
	}, {
		key: 'raf',
		value: function raf(y) {
			(0, _get3.default)(YouthPresentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(YouthPresentation.prototype), 'raf', this).call(this, y);
		}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(YouthPresentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(YouthPresentation.prototype), '_resize', this).call(this);

			this.boundsAnim = {
				top: this.bounds.top - window.innerHeight,
				bottom: this.bounds.top + this.bounds.height + window.innerHeight
			};

			if (!this.isMobile) {
				this.initTimeline();
			}
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(YouthPresentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(YouthPresentation.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(YouthPresentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(YouthPresentation.prototype), '_off', this).call(this);
		}
	}]);
	return YouthPresentation;
}(_scrollable2.default)) || _class);
exports.default = YouthPresentation;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(472);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("102ac424", content, true, {});

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".quote{width:100%}.quote blockquote{color:#fff;font-size:1.875em;line-height:1.333333333333333em;font-family:Poppins,sans-serif;letter-spacing:.01em}@media screen and (max-width:640px){.quote blockquote{font-size:1.5em}}.quote .translation{color:#fff;font-size:.9375em;line-height:1.4em;letter-spacing:.15em;font-family:Saira Extra Condensed,sans-serif;font-weight:300;text-transform:uppercase;margin-top:8px}", ""]);

// exports


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Quote = (_dec = (0, _vueClassComponent2.default)({
	name: 'Quote',
	components: {}
}), _dec(_class = function (_Vue) {
	(0, _inherits3.default)(Quote, _Vue);

	function Quote() {
		(0, _classCallCheck3.default)(this, Quote);
		return (0, _possibleConstructorReturn3.default)(this, (Quote.__proto__ || (0, _getPrototypeOf2.default)(Quote)).apply(this, arguments));
	}

	return Quote;
}(_vue2.default)) || _class);
exports.default = Quote;

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quote"},[_vm._t("quote"),_vm._t("translation")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(476);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("3c27550a", content, true, {});

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".responsive-image,.responsive-image .image-wrapper{position:relative;width:100%}.responsive-image .image-wrapper .image{position:absolute;top:0;left:0;width:100%}", ""]);

// exports


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResponsiveImage = (_dec = (0, _vueClassComponent2.default)({
	name: 'ResponsiveImage',
	components: {},
	props: ["width", "height", "src"],
	data: function data() {
		return {
			img: undefined
		};
	}
}), _dec(_class = function (_Vue) {
	(0, _inherits3.default)(ResponsiveImage, _Vue);

	function ResponsiveImage() {
		(0, _classCallCheck3.default)(this, ResponsiveImage);
		return (0, _possibleConstructorReturn3.default)(this, (ResponsiveImage.__proto__ || (0, _getPrototypeOf2.default)(ResponsiveImage)).apply(this, arguments));
	}

	(0, _createClass3.default)(ResponsiveImage, [{
		key: 'mounted',
		value: function mounted() {
			this.init();
		}
	}, {
		key: 'init',
		value: function init() {

			this._dom();
			this._setPadding();
			this.load();
		}
	}, {
		key: 'load',
		value: function load() {
			var _this2 = this;

			var bufferImg = new Image();
			bufferImg.onload = function () {
				_this2.img = _this2.src;
			};
			bufferImg.src = this.src;
		}
	}, {
		key: '_dom',
		value: function _dom() {
			this.$wrapImage = this.$el.querySelector('.image-wrapper');
		}
	}, {
		key: '_setPadding',
		value: function _setPadding() {
			this.$wrapImage.style.paddingBottom = this.height / this.width * 100 + '%';
		}
	}, {
		key: '_resize',
		value: function _resize() {}
	}]);
	return ResponsiveImage;
}(_vue2.default)) || _class);
exports.default = ResponsiveImage;

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"responsive-image"},[_c('div',{staticClass:"image-wrapper"},[_c('img',{staticClass:"image",attrs:{"src":_vm.img}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e1c451391d3b493018f11904d218bcff.png";

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ab028b1234365deb0a3957e7ce0fba88.png";

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7bf95324a44dce7c2ef3242eed0ff992.png";

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "baed3b75eb85a4b5de0aef43855b4dc9.png";

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d70e230a48875885ad88f8325d6fc25b.png";

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"youth-presentation"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"youth-presentation-text"},[_c('p',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.translate('youth.text'))}})]),(_vm.isMobile)?_c('div',{staticClass:"mobile-image"},[_c('responsive-image',{attrs:{"src":"assets/images/youth-duo.png","width":"504","height":"504"}})],1):_vm._e(),_c('div',{staticClass:"youth-presentation-quote"},[_c('quote',[_c('blockquote',{attrs:{"slot":"quote"},slot:"quote"},[_vm._v(_vm._s(_vm.translate('youth.quote')))]),_c('p',{staticClass:"translation",attrs:{"slot":"translation"},slot:"translation"},[_vm._v(_vm._s(_vm.translate('youth.translation')))])])],1),_c('div',{staticClass:"wrap-image image-1"},[_c('responsive-image',{attrs:{"src":_vm.crewImg,"height":"253","width":"253"}})],1),_c('div',{staticClass:"wrap-image image-2"},[_c('responsive-image',{attrs:{"src":_vm.duoImg,"width":"504","height":"504"}})],1),_c('div',{staticClass:"wrap-image image-3"},[_c('responsive-image',{attrs:{"src":_vm.trioImg,"height":"360","width":"360"}})],1),_c('div',{staticClass:"wrap-image image-4"},[_c('responsive-image',{attrs:{"src":_vm.momImg,"height":"360","width":"360"}})],1),_c('div',{staticClass:"wrap-image image-5"},[_c('responsive-image',{attrs:{"src":_vm.studenImg,"height":"144","width":"144"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "29ad9cfd0b1c49061cf1b8c18fcac6e9.jpg";

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"youth-intro"},[_c('section-intro',{attrs:{"img":_vm.babyImg,"title":_vm.translate('youth.title'),"onEnter":_vm.onEnter,"onLeave":_vm.onLeave}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"youth"},[_c('youth-intro'),_c('youth-presentation')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pro_era_vue__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pro_era_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pro_era_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b787f1bc_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_pro_era_vue__ = __webpack_require__(505);
function injectStyle (ssrContext) {
  __webpack_require__(489)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pro_era_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b787f1bc_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_pro_era_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(490);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("54ee0e75", content, true, {});

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".pro-era{width:100%;background:#05006c;position:relative}", ""]);

// exports


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scroller = __webpack_require__(18);

var _scroller2 = _interopRequireDefault(_scroller);

var _ticker = __webpack_require__(19);

var _ticker2 = _interopRequireDefault(_ticker);

var _pixi = __webpack_require__(25);

var PIXI = _interopRequireWildcard(_pixi);

var _proEraIntro = __webpack_require__(492);

var _proEraIntro2 = _interopRequireDefault(_proEraIntro);

var _proEraPresentation = __webpack_require__(498);

var _proEraPresentation2 = _interopRequireDefault(_proEraPresentation);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProEra = (_dec = (0, _vueClassComponent2.default)({
	name: 'ProEra',
	components: { ProEraIntro: _proEraIntro2.default, ProEraPresentation: _proEraPresentation2.default }
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(ProEra, _Scrollable);

	function ProEra() {
		(0, _classCallCheck3.default)(this, ProEra);
		return (0, _possibleConstructorReturn3.default)(this, (ProEra.__proto__ || (0, _getPrototypeOf2.default)(ProEra)).apply(this, arguments));
	}

	(0, _createClass3.default)(ProEra, [{
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(ProEra.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProEra.prototype), 'mounted', this).call(this);

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(ProEra.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProEra.prototype), 'init', this).call(this);
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(ProEra.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProEra.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_dom',
		value: function _dom() {}
	}, {
		key: 'initIntervals',
		value: function initIntervals() {}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(ProEra.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProEra.prototype), '_resize', this).call(this);

			this.initIntervals();
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(ProEra.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProEra.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(ProEra.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProEra.prototype), '_off', this).call(this);
		}
	}]);
	return ProEra;
}(_scrollable2.default)) || _class);
exports.default = ProEra;

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pro_era_intro_vue__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pro_era_intro_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pro_era_intro_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ef392a7_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_pro_era_intro_vue__ = __webpack_require__(497);
function injectStyle (ssrContext) {
  __webpack_require__(493)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pro_era_intro_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ef392a7_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_pro_era_intro_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(494);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("59fb21aa", content, true, {});

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".pro-era-intro{width:100%;position:relative}", ""]);

// exports


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scroller = __webpack_require__(18);

var _scroller2 = _interopRequireDefault(_scroller);

var _ticker = __webpack_require__(19);

var _ticker2 = _interopRequireDefault(_ticker);

var _pixi = __webpack_require__(25);

var PIXI = _interopRequireWildcard(_pixi);

var _sectionIntro = __webpack_require__(57);

var _sectionIntro2 = _interopRequireDefault(_sectionIntro);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _proEra = __webpack_require__(496);

var _proEra2 = _interopRequireDefault(_proEra);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProEra = (_dec = (0, _vueClassComponent2.default)({
	name: 'ProEra',
	components: { SectionIntro: _sectionIntro2.default },
	data: function data() {
		return {
			proImg: _proEra2.default
		};
	}
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(ProEra, _Scrollable);

	function ProEra() {
		(0, _classCallCheck3.default)(this, ProEra);
		return (0, _possibleConstructorReturn3.default)(this, (ProEra.__proto__ || (0, _getPrototypeOf2.default)(ProEra)).apply(this, arguments));
	}

	(0, _createClass3.default)(ProEra, [{
		key: 'created',
		value: function created() {
			this.title = this.translate('pro_era.title');
		}
	}, {
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(ProEra.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProEra.prototype), 'mounted', this).call(this);

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(ProEra.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProEra.prototype), 'init', this).call(this);
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(ProEra.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProEra.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_dom',
		value: function _dom() {}
	}, {
		key: 'initIntervals',
		value: function initIntervals() {}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(ProEra.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProEra.prototype), '_resize', this).call(this);

			this.initIntervals();
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(ProEra.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProEra.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(ProEra.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProEra.prototype), '_off', this).call(this);
		}
	}]);
	return ProEra;
}(_scrollable2.default)) || _class);
exports.default = ProEra;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "200336b2a998a59672e40452990afbb0.jpg";

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pro-era-intro"},[_c('section-intro',{attrs:{"img":_vm.proImg,"title":_vm.title}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pro_era_presentation_vue__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pro_era_presentation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pro_era_presentation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3896b7af_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_pro_era_presentation_vue__ = __webpack_require__(504);
function injectStyle (ssrContext) {
  __webpack_require__(499)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pro_era_presentation_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3896b7af_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_pro_era_presentation_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(500);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("3fc99f87", content, true, {});

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".pro-era-presentation{width:100%;padding-bottom:25%;position:relative;padding-top:50px}.pro-era-presentation .pro-era-text{width:100%;display:flex;position:relative;z-index:40}@media screen and (max-width:640px){.pro-era-presentation .pro-era-text{flex-wrap:wrap}.pro-era-presentation .pro-era-text .mobile-image{width:100%;margin:20px 0}}.pro-era-presentation .pro-era-text .text-part-1{width:20%;margin-left:30%}.pro-era-presentation .pro-era-text .text-part-2{width:20%;margin-left:5%;margin-top:90px}@media screen and (max-width:640px){.pro-era-presentation .pro-era-text [class^=text-part]{width:100%;margin:0}}.pro-era-presentation .pro-era-text .text{font-size:.9375em;line-height:1.6em;color:#fff;font-family:Abhaya Libre,serif;width:100%}.pro-era-presentation .pro-era-text .text a,.pro-era-presentation .pro-era-text .text span{font-family:Poppins,sans-serif;color:#e94646;text-decoration:underline}.pro-era-presentation .wrap-image{position:absolute;z-index:30}.pro-era-presentation .wrap-image img{width:100%}.pro-era-presentation .wrap-image.image-1{left:5%;top:170px;width:30%}.pro-era-presentation .wrap-image.image-2{top:360px;left:40%;width:50%}", ""]);

// exports


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _gsap = __webpack_require__(6);

var _Globals = __webpack_require__(16);

var _Globals2 = _interopRequireDefault(_Globals);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _responsiveImage = __webpack_require__(100);

var _responsiveImage2 = _interopRequireDefault(_responsiveImage);

var _proEraShoes = __webpack_require__(502);

var _proEraShoes2 = _interopRequireDefault(_proEraShoes);

var _proEraJoey = __webpack_require__(503);

var _proEraJoey2 = _interopRequireDefault(_proEraJoey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProEraPresentation = (_dec = (0, _vueClassComponent2.default)({
	name: 'ProEraPresentation',
	components: { ResponsiveImage: _responsiveImage2.default },
	data: function data() {
		return {
			state: _Globals2.default.state,
			shoesImg: _proEraShoes2.default,
			joeyImg: _proEraJoey2.default
		};
	},
	computed: {
		isMobile: function isMobile() {
			return this.state.isMobile;
		},
		isTablet: function isTablet() {
			return this.state.isTablet;
		}
	}
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(ProEraPresentation, _Scrollable);

	function ProEraPresentation() {
		(0, _classCallCheck3.default)(this, ProEraPresentation);
		return (0, _possibleConstructorReturn3.default)(this, (ProEraPresentation.__proto__ || (0, _getPrototypeOf2.default)(ProEraPresentation)).apply(this, arguments));
	}

	(0, _createClass3.default)(ProEraPresentation, [{
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(ProEraPresentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProEraPresentation.prototype), 'mounted', this).call(this);

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(ProEraPresentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProEraPresentation.prototype), 'init', this).call(this);
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(ProEraPresentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProEraPresentation.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_dom',
		value: function _dom() {
			this.$image1 = this.$el.querySelector('.image-1');
			this.$image2 = this.$el.querySelector('.image-2');
		}
	}, {
		key: 'initTimeline',
		value: function initTimeline() {
			(0, _get3.default)(ProEraPresentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProEraPresentation.prototype), 'initTimeline', this).call(this);

			this.tl.fromTo(this.$image1, 1, { y: _Globals2.default.responsiveHeight(-200) }, { y: _Globals2.default.responsiveHeight(200) }, 0);
			this.tl.fromTo(this.$image2, 1, { y: _Globals2.default.responsiveHeight(100) }, { y: _Globals2.default.responsiveHeight(-150) }, 0);
		}
	}, {
		key: 'raf',
		value: function raf(y) {
			(0, _get3.default)(ProEraPresentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProEraPresentation.prototype), 'raf', this).call(this, y);
		}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(ProEraPresentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProEraPresentation.prototype), '_resize', this).call(this);

			this.boundsAnim = {
				top: this.bounds.top - window.innerHeight,
				bottom: this.bounds.top + this.bounds.height + window.innerHeight
			};

			this.initTimeline();
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(ProEraPresentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProEraPresentation.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(ProEraPresentation.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProEraPresentation.prototype), '_off', this).call(this);
		}
	}]);
	return ProEraPresentation;
}(_scrollable2.default)) || _class);
exports.default = ProEraPresentation;

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9a15069ebfcbef538b8457b94f881bfc.jpg";

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c6c86d44153b91168d03960283e21224.jpg";

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pro-era-presentation"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"pro-era-text"},[_c('div',{staticClass:"text-part-1"},[_c('p',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.translate('pro_era.text_1'))}})]),_c('div',{staticClass:"text-part-2"},[_c('p',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.translate('pro_era.text_2'))}},[_vm._v("Ce dernier s’étant ôté la vie à l’âge de 19 ans un 24 décembre 2012 pendant l’ascension du label, le crew connaîtra une triste période de deuil et rendra multiples hommages à leur ami décédé. ")])])]),_c('div',{staticClass:"wrap-image image-1"},[_c('responsive-image',{attrs:{"src":_vm.shoesImg,"width":"432","height":"325"}})],1),_c('div',{staticClass:"wrap-image image-2"},[_c('responsive-image',{attrs:{"src":_vm.joeyImg,"width":"793","height":"528"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pro-era"},[_c('pro-era-intro'),_c('pro-era-presentation')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_badass_origins_vue__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_badass_origins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_badass_origins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aab92910_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_badass_origins_vue__ = __webpack_require__(550);
function injectStyle (ssrContext) {
  __webpack_require__(507)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_badass_origins_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aab92910_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_badass_origins_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(508);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("7dcf64d0", content, true, {});

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".badass-origins{width:100%;background:#0f0d37;position:relative;overflow:hidden}.badass-origins .background-image{position:absolute;top:0;left:0;width:100%;height:100vh;z-index:40}.badass-origins .background-image img{height:100%;width:100%;object-fit:cover;position:relative;z-index:40}.badass-origins__section{position:relative;z-index:60}", ""]);

// exports


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scroller = __webpack_require__(18);

var _scroller2 = _interopRequireDefault(_scroller);

var _ticker = __webpack_require__(19);

var _ticker2 = _interopRequireDefault(_ticker);

var _pixi = __webpack_require__(25);

var PIXI = _interopRequireWildcard(_pixi);

var _badassOriginsIntro = __webpack_require__(510);

var _badassOriginsIntro2 = _interopRequireDefault(_badassOriginsIntro);

var _albumsSlider = __webpack_require__(518);

var _albumsSlider2 = _interopRequireDefault(_albumsSlider);

var _badassAlbum = __webpack_require__(528);

var _badassAlbum2 = _interopRequireDefault(_badassAlbum);

var _blackBeetles = __webpack_require__(533);

var _blackBeetles2 = _interopRequireDefault(_blackBeetles);

var _likemeClip = __webpack_require__(545);

var _likemeClip2 = _interopRequireDefault(_likemeClip);

var _background = __webpack_require__(30);

var _background2 = _interopRequireDefault(_background);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Youth = (_dec = (0, _vueClassComponent2.default)({
	name: 'Youth',
	components: { Background: _background2.default, BadassOriginsIntro: _badassOriginsIntro2.default, AlbumsSlider: _albumsSlider2.default, BadassAlbum: _badassAlbum2.default, BlackBeetles: _blackBeetles2.default, LikemeClip: _likemeClip2.default }
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(Youth, _Scrollable);

	function Youth() {
		(0, _classCallCheck3.default)(this, Youth);
		return (0, _possibleConstructorReturn3.default)(this, (Youth.__proto__ || (0, _getPrototypeOf2.default)(Youth)).apply(this, arguments));
	}

	(0, _createClass3.default)(Youth, [{
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(Youth.prototype.__proto__ || (0, _getPrototypeOf2.default)(Youth.prototype), 'mounted', this).call(this);

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(Youth.prototype.__proto__ || (0, _getPrototypeOf2.default)(Youth.prototype), 'init', this).call(this);
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(Youth.prototype.__proto__ || (0, _getPrototypeOf2.default)(Youth.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_dom',
		value: function _dom() {
			this.$bg = this.$el.querySelector('.background-image');
			this.$intro = this.$el.querySelector('.badass-origins-intro');
			this.$slider = this.$el.querySelector('.albums-slider');
		}
	}, {
		key: 'initTimeline',
		value: function initTimeline() {
			(0, _get3.default)(Youth.prototype.__proto__ || (0, _getPrototypeOf2.default)(Youth.prototype), 'initTimeline', this).call(this);

			var windowRatio = window.innerHeight / this.totalHeight;

			this.tl.fromTo(this.$bg, 1, { y: 0 }, { y: this.totalHeight, ease: Power0.easeNone }, 0);
			this.tl.fromTo(this.$bg, windowRatio, { opacity: 1 }, { opacity: 0, ease: Power0.easeNone }, 1 - windowRatio);
		}
	}, {
		key: 'raf',
		value: function raf(y) {
			(0, _get3.default)(Youth.prototype.__proto__ || (0, _getPrototypeOf2.default)(Youth.prototype), 'raf', this).call(this, y);
		}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(Youth.prototype.__proto__ || (0, _getPrototypeOf2.default)(Youth.prototype), '_resize', this).call(this);

			this.totalHeight = this.$intro.getBoundingClientRect().height + this.$slider.getBoundingClientRect().height;

			this.boundsAnim = {
				top: this.bounds.top,
				bottom: this.bounds.top + this.totalHeight
			};

			this.initTimeline();
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(Youth.prototype.__proto__ || (0, _getPrototypeOf2.default)(Youth.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(Youth.prototype.__proto__ || (0, _getPrototypeOf2.default)(Youth.prototype), '_off', this).call(this);
		}
	}]);
	return Youth;
}(_scrollable2.default)) || _class);
exports.default = Youth;

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_badass_origins_intro_vue__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_badass_origins_intro_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_badass_origins_intro_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16414071_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_badass_origins_intro_vue__ = __webpack_require__(517);
function injectStyle (ssrContext) {
  __webpack_require__(511)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_badass_origins_intro_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16414071_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_badass_origins_intro_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(512);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("428d5e2d", content, true, {});

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".badass-origins-intro{width:100%;position:relative;padding-top:100vh}.badass-origins-intro .spray-wrapper{position:absolute;top:0;left:0;width:100%}.badass-origins-intro .spray-wrapper .spray-movable{position:relative;height:100vh;width:100%;overflow:hidden}.badass-origins-intro .spray-wrapper .spray{position:absolute;top:0;left:0;width:100%;height:100%}.badass-origins-intro .spray-wrapper .spray canvas{height:100%;width:100%}.badass-origins-intro .spray-wrapper .bg-paint{height:100%;width:100%;object-fit:cover}.badass-origins-intro .title{width:100%;padding:0 10vw;text-align:center;position:relative;z-index:80;margin-bottom:8%;opacity:1}@media screen and (max-width:640px){.badass-origins-intro .title{padding:0}}.badass-origins-intro .title h2{color:#fff;font-size:6.25em;font-weight:700;color:red!important;opacity:0}@media screen and (max-width:640px){.badass-origins-intro .title h2{font-size:5em}}.badass-origins-intro .splited-text{max-width:700px;margin:auto;text-align:center}@media screen and (min-width:1700px){.badass-origins-intro .splited-text{max-width:1000px}}", ""]);

// exports


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _values = __webpack_require__(177);

var _values2 = _interopRequireDefault(_values);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _gsap = __webpack_require__(6);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _Globals = __webpack_require__(16);

var _Globals2 = _interopRequireDefault(_Globals);

var _splitedText = __webpack_require__(42);

var _splitedText2 = _interopRequireDefault(_splitedText);

var _pixi = __webpack_require__(25);

var PIXI = _interopRequireWildcard(_pixi);

var _badassOriginsIntro = __webpack_require__(514);

var _badassOriginsIntro2 = _interopRequireDefault(_badassOriginsIntro);

var _sprayBw = __webpack_require__(515);

var _sprayBw2 = _interopRequireDefault(_sprayBw);

var _sprayBw3 = __webpack_require__(516);

var _sprayBw4 = _interopRequireDefault(_sprayBw3);

var _coverBackground = __webpack_require__(180);

var _coverBackground2 = _interopRequireDefault(_coverBackground);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BadassOriginsIntro = (_dec = (0, _vueClassComponent2.default)({
	name: 'BadassOriginsIntro',
	components: { SplitedText: _splitedText2.default },
	data: function data() {
		return {
			state: _Globals2.default.state,
			text: "",
			animOffset: 500
		};
	},
	computed: {
		isMobile: function isMobile() {
			return this.state.isMobile;
		},
		isTablet: function isTablet() {
			return this.state.isTablet;
		}
	}
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(BadassOriginsIntro, _Scrollable);

	function BadassOriginsIntro() {
		var _ref;

		var _temp, _this, _ret;

		(0, _classCallCheck3.default)(this, BadassOriginsIntro);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BadassOriginsIntro.__proto__ || (0, _getPrototypeOf2.default)(BadassOriginsIntro)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'redimensionate', {
			enumerable: true,
			writable: true,
			value: function value(element) {
				var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

				if (!element) return;

				var sizes = size ? size : { w: window.innerWidth, h: window.innerHeight };
				var dimension = _coverBackground2.default.Cover(element.width, element.height, sizes.w, sizes.h);

				element.width = dimension.w;
				element.height = dimension.h;
				element.position.x = dimension.pos.x;
				element.position.y = dimension.pos.y;
			}
		}), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	}

	(0, _createClass3.default)(BadassOriginsIntro, [{
		key: 'created',
		value: function created() {
			this.text = this.translate('badass.about');
			this.title = this.translate('badass.title');
		}
	}, {
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(BadassOriginsIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(BadassOriginsIntro.prototype), 'mounted', this).call(this);

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(BadassOriginsIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(BadassOriginsIntro.prototype), 'init', this).call(this);

			this.currentFrame = null;
			this.currentIndex = null;

			this.app = new PIXI.Application(window.innerWidth, window.innerHeight, {
				transparent: true,
				antialias: true
			});

			this.app.renderer.autoResize = true;
			this.$refs.spray.appendChild(this.app.view);

			PIXI.loader.reset().add('bg', _badassOriginsIntro2.default).add('spray-bw', _sprayBw2.default).load(this.loaded);
		}
	}, {
		key: 'createTitle',
		value: function createTitle() {

			var title = new PIXI.Text(this.title, { fontFamily: 'Poppins', fontSize: 100, fontWeight: 700, fill: 0xffffff, align: 'center' });

			title.position.x = window.innerWidth / 2;
			title.anchor.set(0.5);
			// title.alpha = 0

			return title;
		}
	}, {
		key: 'loaded',
		value: function loaded(loader, resources) {
			var _this2 = this;

			this.bg = PIXI.Sprite.fromImage(_badassOriginsIntro2.default);

			this.imageContainer = new PIXI.Container();
			this.spriteContainer = new PIXI.Container();

			this.titleCanvas = this.createTitle();

			this.imageContainer.addChild(this.bg);
			this.imageContainer.addChild(this.titleCanvas);
			var maskSprite = new PIXI.Spritesheet(resources['spray-bw'].texture.baseTexture, _sprayBw4.default);

			this.app.stage.addChild(this.imageContainer);

			maskSprite.parse(function (w) {
				_this2.mask = (0, _values2.default)(maskSprite.textures);
				_this2.maskImage(0);
				_this2._resize();
			});
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(BadassOriginsIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(BadassOriginsIntro.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_dom',
		value: function _dom() {}
	}, {
		key: 'initTimeline',
		value: function initTimeline() {
			var _this3 = this;

			(0, _get3.default)(BadassOriginsIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(BadassOriginsIntro.prototype), 'initTimeline', this).call(this);

			// this.tl = new TimelineMax({onReverseComplete: ()=>{
			// 	console.log('end reverse')
			// 	TweenMax.set(this.bg,{alpha:1})
			// 	TweenMax.set(this.$refs.background,{opacity:1},0)
			// }})

			if (this.bg) {
				this.tl.set(this.bg, { alpha: 1, onComplete: function onComplete() {} }, 0);
				this.tl.set(this.$refs.background, { opacity: 1 }, 0);
			}

			var whRatio = window.innerHeight / (this.animOffset + window.innerHeight);

			this.tl.fromTo(this.$refs.sprayWrapper, whRatio, { scale: 1.05, y: -window.innerHeight * .3 }, { scale: 1, y: 0, ease: Power0.easeNone }, 0);
			this.tl.fromTo(this.$refs.movable, 1 - whRatio, { y: 0 }, { y: this.animOffset, ease: Power0.easeNone }, whRatio);

			if (this.titleCanvas) {

				var fromTop = this.$refs.title.getBoundingClientRect().top - this.bounds.top - this.scroller.scroll.position + this.$refs.title.getBoundingClientRect().height / 2;
				var toTop = this.$refs.title.getBoundingClientRect().top - this.bounds.top - this.scroller.scroll.position - this.animOffset + this.$refs.title.getBoundingClientRect().height / 2;

				// console.log(this.$refs.title.getBoundingClientRect().top)
				// console.log(fromTop)
				// console.log(toTop)

				this.tl.fromTo(this.titleCanvas.position, 1 - whRatio, { x: window.innerWidth / 2, y: fromTop }, { y: toTop, ease: Power0.easeNone }, whRatio);
			}

			if (this.bg) {
				this.tl.set(this.bg, { alpha: 0 }, 0.999999);
				this.tl.set(this.$refs.background, { opacity: 0 }, 0.999999);
				this.tl.add(function () {

					if (_this3.scroller.direction == 1 || _this3.isResized == false) {
						_this3.$refs.splitedText.animateIn();
					} else {
						_this3.$refs.splitedText.animateOut();
					}
					_this3.isResized = true;
				}, 0.8);
			}
		}
	}, {
		key: 'raf',
		value: function raf(y) {
			(0, _get3.default)(BadassOriginsIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(BadassOriginsIntro.prototype), 'raf', this).call(this, y);

			if (!this.mask) return;
			if (!this.isInViewport) return;

			var whRatio = _Globals2.default.height / (this.animOffset + _Globals2.default.height);

			var sprayBounds = {
				top: this.bounds.top,
				bottom: this.bounds.top + this.animOffset
			};

			var i = Math.floor(30 * this.scroller.getPerc(sprayBounds, y) * .8);
			this.maskImage(i);
		}
	}, {
		key: 'maskImage',
		value: function maskImage(i) {
			var frame = this.getMaskFrame(i);
			frame.name = 'frame-' + i;

			if (i === this.currentIndex) return false;

			this.imageContainer.removeChild(this.currentFrame);

			this.imageContainer.mask = frame;
			this.imageContainer.addChild(frame);

			this.currentFrame = frame;
			this.currentIndex = i;
		}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(BadassOriginsIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(BadassOriginsIntro.prototype), '_resize', this).call(this);

			this.app && this.app.renderer.resize(window.innerWidth, window.innerHeight);

			this.bounds.height = window.innerHeight + this.animOffset;
			this.$el.style.height = this.bounds.height + "px";

			this.boundsAnim = {
				top: this.bounds.top - window.innerHeight,
				bottom: this.bounds.top + this.animOffset
			};

			this.redimensionate(this.bg);

			this.initTimeline();
		}
	}, {
		key: 'getMaskFrame',
		value: function getMaskFrame(i) {
			var frame = new PIXI.Sprite(this.mask[i]);
			this.redimensionate(frame);

			return frame;
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(BadassOriginsIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(BadassOriginsIntro.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(BadassOriginsIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(BadassOriginsIntro.prototype), '_off', this).call(this);
		}
	}]);
	return BadassOriginsIntro;
}(_scrollable2.default)) || _class);
exports.default = BadassOriginsIntro;

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cf9df6886c6f3bb6b50bb402040a4d82.jpg";

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7f95b2a88c58a5da20fcf2fb0d7c8aec.png";

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports = {"frames":{"01.jpg":{"frame":{"x":1,"y":1,"w":720,"h":450},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"02.jpg":{"frame":{"x":723,"y":1,"w":720,"h":450},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"03.jpg":{"frame":{"x":1445,"y":1,"w":720,"h":450},"rotated":true,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"04.jpg":{"frame":{"x":1,"y":453,"w":720,"h":450},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"05.jpg":{"frame":{"x":723,"y":453,"w":720,"h":450},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"06.jpg":{"frame":{"x":1445,"y":723,"w":720,"h":450},"rotated":true,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"07.jpg":{"frame":{"x":1,"y":905,"w":720,"h":450},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"08.jpg":{"frame":{"x":723,"y":905,"w":720,"h":450},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"09.jpg":{"frame":{"x":1,"y":1357,"w":720,"h":450},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"10.jpg":{"frame":{"x":723,"y":1357,"w":720,"h":450},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"11.jpg":{"frame":{"x":1445,"y":1445,"w":720,"h":450},"rotated":true,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"12.jpg":{"frame":{"x":1,"y":1809,"w":720,"h":450},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"13.jpg":{"frame":{"x":723,"y":1809,"w":720,"h":450},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"14.jpg":{"frame":{"x":1445,"y":2167,"w":720,"h":450},"rotated":true,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"15.jpg":{"frame":{"x":1,"y":2261,"w":720,"h":450},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"16.jpg":{"frame":{"x":723,"y":2261,"w":720,"h":450},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"17.jpg":{"frame":{"x":1,"y":2713,"w":720,"h":450},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"18.jpg":{"frame":{"x":723,"y":2713,"w":720,"h":450},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"19.jpg":{"frame":{"x":1445,"y":2889,"w":720,"h":450},"rotated":true,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"20.jpg":{"frame":{"x":1,"y":3165,"w":720,"h":450},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"21.jpg":{"frame":{"x":723,"y":3165,"w":720,"h":450},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"22.jpg":{"frame":{"x":1445,"y":3611,"w":720,"h":450},"rotated":true,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"23.jpg":{"frame":{"x":1,"y":3617,"w":720,"h":450},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"24.jpg":{"frame":{"x":723,"y":3617,"w":720,"h":450},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"25.jpg":{"frame":{"x":1,"y":4069,"w":720,"h":450},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"26.jpg":{"frame":{"x":723,"y":4069,"w":720,"h":450},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"27.jpg":{"frame":{"x":1445,"y":4333,"w":720,"h":450},"rotated":true,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"28.jpg":{"frame":{"x":1,"y":4521,"w":720,"h":450},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"29.jpg":{"frame":{"x":723,"y":4521,"w":720,"h":450},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"30.jpg":{"frame":{"x":1,"y":4973,"w":720,"h":450},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}},"31.jpg":{"frame":{"x":723,"y":4973,"w":720,"h":450},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":720,"h":450},"sourceSize":{"w":720,"h":450}}},"meta":{"app":"https://www.codeandweb.com/texturepacker","version":"1.0","image":"spray.png","format":"RGBA8888","size":{"w":1896,"h":5424},"scale":"1","smartupdate":"$TexturePacker:SmartUpdate:f665c21cd6f8451b6c0074117ac06058:ef0907532bbaf2c8a06693272c83b307:fb0877432a79f0f78b95d374b37f2204$"}}

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badass-origins-intro"},[_c('div',{ref:"sprayWrapper",staticClass:"spray-wrapper"},[_c('div',{ref:"movable",staticClass:"spray-movable"},[_c('img',{ref:"background",staticClass:"bg-paint",attrs:{"src":"assets/images/painting-background.jpg"}}),_c('div',{ref:"spray",staticClass:"spray"})])]),_c('div',{ref:"title",staticClass:"title"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.translate('badass.title'))}})]),_c('splited-text',{ref:"splitedText",attrs:{"text":_vm.text}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_albums_slider_vue__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_albums_slider_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_albums_slider_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5660c38_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_albums_slider_vue__ = __webpack_require__(527);
function injectStyle (ssrContext) {
  __webpack_require__(519)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_albums_slider_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5660c38_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_albums_slider_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(520);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("794c1c1c", content, true, {});

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".albums-slider{width:100%;height:100vh;position:relative}.albums-slider .movable{height:100vh;width:100%;position:absolute;top:0;left:0;will-change:transform}.albums-slider .movable .slider-movable{position:relative}.albums-slider .movable .slider-movable .album-cover:nth-child(2){z-index:50}.albums-slider .movable .slider-movable .album-cover:nth-child(3){z-index:40}.albums-slider .movable .slider-movable .album-cover:nth-child(5){z-index:20}.albums-slider .movable .slider-movable .album-cover:nth-child(6){z-index:10}.albums-slider .movable .vinyl{position:absolute;top:2px;left:0;padding:20px;box-sizing:border-box}.albums-slider .movable .vinyl img{height:100%}.albums-slider .movable .slider-container{width:100%;height:100%;display:flex;align-items:center;position:relative;overflow:hidden}.albums-slider .movable .slider-container .slider{width:999999px;display:flex}.albums-slider .movable .slider-container .slider .slider-movable{display:flex;align-items:center;padding:0 90px;padding-right:190px;will-change:transform}.albums-slider .movable .slider-container .albums-story{width:350px;margin-left:190px;position:relative;z-index:30}@media screen and (min-width:1700px){.albums-slider .movable .slider-container .albums-story{width:550px}}.albums-slider .movable .slider-container .albums-story .text{color:#fff;font-size:1.125em;line-height:1.333333333333333em;font-family:Abhaya Libre,serif}.albums-slider .movable .slider-container .albums-story .text span{text-decoration:underline;font-family:Poppins,sans-serif}", ""]);

// exports


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _gsap = __webpack_require__(6);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _albumCover = __webpack_require__(522);

var _albumCover2 = _interopRequireDefault(_albumCover);

var _Globals = __webpack_require__(16);

var _Globals2 = _interopRequireDefault(_Globals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BadassOriginsAlbums = (_dec = (0, _vueClassComponent2.default)({
	name: 'BadassOriginsAlbums',
	components: { AlbumCover: _albumCover2.default }
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(BadassOriginsAlbums, _Scrollable);

	function BadassOriginsAlbums() {
		(0, _classCallCheck3.default)(this, BadassOriginsAlbums);
		return (0, _possibleConstructorReturn3.default)(this, (BadassOriginsAlbums.__proto__ || (0, _getPrototypeOf2.default)(BadassOriginsAlbums)).apply(this, arguments));
	}

	(0, _createClass3.default)(BadassOriginsAlbums, [{
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(BadassOriginsAlbums.prototype.__proto__ || (0, _getPrototypeOf2.default)(BadassOriginsAlbums.prototype), 'mounted', this).call(this);

			this.count = 0;

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(BadassOriginsAlbums.prototype.__proto__ || (0, _getPrototypeOf2.default)(BadassOriginsAlbums.prototype), 'init', this).call(this);
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(BadassOriginsAlbums.prototype.__proto__ || (0, _getPrototypeOf2.default)(BadassOriginsAlbums.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_dom',
		value: function _dom() {

			this.$slider = this.$el.querySelector('.slider-movable');
			this.$movable = this.$el.querySelector('.movable');
			this.$vinyl = this.$el.querySelector('.vinyl');
		}
	}, {
		key: 'onHover',
		value: function onHover(e, i) {

			var direction = e.type === "mouseenter" ? 'in' : 'out';

			this.setVinylPosition(i, direction);
		}
	}, {
		key: 'setVinylPosition',
		value: function setVinylPosition(i, direction) {
			var r = this.$refs['cover' + i].$el;
			var l = r.getBoundingClientRect().left;
			var w = this.$vinyl.getBoundingClientRect().width;
			var offset = this.bounds.top - _.clamp(Math.abs(this.scroller.scroll.lerped), this.bounds.top, this.bounds.top + this.offsetAnim);
			var toLeft = l - offset;
			var elw = r.getBoundingClientRect().width;

			if (direction === 'in') {
				_gsap.TweenMax.to(this.$vinyl, .4, { x: toLeft + w * .4 });
			} else if (direction === 'out') {
				_gsap.TweenMax.to(this.$vinyl, .3, { x: toLeft });
			}
		}
	}, {
		key: 'initTimeline',
		value: function initTimeline() {
			(0, _get3.default)(BadassOriginsAlbums.prototype.__proto__ || (0, _getPrototypeOf2.default)(BadassOriginsAlbums.prototype), 'initTimeline', this).call(this);

			this.tl.fromTo(this.$movable, 1, { y: 0 }, { y: this.offsetAnim, ease: Power0.easeNone }, 0);
			this.tl.fromTo(this.$slider, 1, { x: 0 }, { x: -this.offsetAnim, ease: Power0.easeNone }, 0);
		}
	}, {
		key: '_points',
		value: function _points() {}
	}, {
		key: 'resizeVinyl',
		value: function resizeVinyl() {
			this.$refs.vinyl.style.height = _Globals2.default.responsiveHeight(330) + "px";
			this.$refs.vinyl.style.width = _Globals2.default.responsiveHeight(330) * 370 / 330 + "px";
		}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(BadassOriginsAlbums.prototype.__proto__ || (0, _getPrototypeOf2.default)(BadassOriginsAlbums.prototype), '_resize', this).call(this);

			this.resizeVinyl();
			this.setVinylPosition(0, 'out');

			this.sliderWidth = this.$slider.getBoundingClientRect().width;
			this.offsetAnim = this.sliderWidth - window.innerWidth;

			this.bounds.height = window.innerHeight + this.offsetAnim;
			this.$el.style.height = this.bounds.height + "px";

			this.boundsAnim = {
				top: this.bounds.top,
				bottom: this.bounds.top + this.offsetAnim
			};

			this.initTimeline();
			this._points();
		}
	}, {
		key: 'raf',
		value: function raf(y) {
			(0, _get3.default)(BadassOriginsAlbums.prototype.__proto__ || (0, _getPrototypeOf2.default)(BadassOriginsAlbums.prototype), 'raf', this).call(this, y);
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(BadassOriginsAlbums.prototype.__proto__ || (0, _getPrototypeOf2.default)(BadassOriginsAlbums.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(BadassOriginsAlbums.prototype.__proto__ || (0, _getPrototypeOf2.default)(BadassOriginsAlbums.prototype), '_off', this).call(this);
		}
	}]);
	return BadassOriginsAlbums;
}(_scrollable2.default)) || _class);
exports.default = BadassOriginsAlbums;

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_album_cover_vue__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_album_cover_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_album_cover_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bb6725a_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_album_cover_vue__ = __webpack_require__(526);
function injectStyle (ssrContext) {
  __webpack_require__(523)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_album_cover_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bb6725a_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_album_cover_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(524);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("0cf81dcc", content, true, {});

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".album-cover{width:330px;height:330px;position:relative;margin-left:190px;cursor:pointer}.album-cover:hover img.cover-tongue{transform:translatex(55%)}.album-cover img.cover{position:absolute;top:0;right:0;z-index:50;height:100%}.album-cover img.cover-tongue{right:0;transform:translatex(40%)}.album-cover img.cover-shadow,.album-cover img.cover-tongue{position:absolute;top:0;transition:all .3s;z-index:30;height:100%}.album-cover img.cover-shadow{left:0;transform:translatex(-100%)}.album-cover .album-legend{position:absolute;left:0;bottom:-2em;display:flex;align-items:center}.album-cover .album-legend .word{color:#fff;font-family:Saira Extra Condensed,sans-serif;font-weight:300;letter-spacing:.15em;text-transform:uppercase;font-size:.9375em}.album-cover .album-legend .album-name{position:relative;margin-left:4px;margin-bottom:1px}.album-cover .album-legend .album-name span{display:inline-block;color:#fff;font-family:Saira Extra Condensed,sans-serif;font-weight:300;letter-spacing:.15em;text-transform:uppercase;font-size:.9375em;font-weight:700;opacity:0;transform:translateY(5px)}.album-cover .album-legend img{margin-left:10px;width:24px}", ""]);

// exports


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _Globals = __webpack_require__(16);

var _Globals2 = _interopRequireDefault(_Globals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlbumCover = (_dec = (0, _vueClassComponent2.default)({
	name: 'AlbumCover',
	components: {},
	props: ['name', 'title', 'href'],
	data: function data() {
		return {
			img: 'assets/images/album-' + this.name + '-cover.png',
			shadow: 'assets/images/album-shadow.png',
			tongue: 'assets/images/album-' + this.name + '-tongue.png'
		};
	}
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(AlbumCover, _Scrollable);

	function AlbumCover() {
		(0, _classCallCheck3.default)(this, AlbumCover);
		return (0, _possibleConstructorReturn3.default)(this, (AlbumCover.__proto__ || (0, _getPrototypeOf2.default)(AlbumCover)).apply(this, arguments));
	}

	(0, _createClass3.default)(AlbumCover, [{
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(AlbumCover.prototype.__proto__ || (0, _getPrototypeOf2.default)(AlbumCover.prototype), 'mounted', this).call(this);
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(AlbumCover.prototype.__proto__ || (0, _getPrototypeOf2.default)(AlbumCover.prototype), 'init', this).call(this);
			this._dom();
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(AlbumCover.prototype.__proto__ || (0, _getPrototypeOf2.default)(AlbumCover.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_dom',
		value: function _dom() {
			this.$name = this.$el.querySelector('.album-name');
			this.$nameLetter = this.$el.querySelectorAll('.album-name span');
			this.$icon = this.$el.querySelector('.icon');

			this.nameWidth = this.$name.getBoundingClientRect().width + 4;
			_gsap.TweenMax.set(this.$icon, { x: -this.nameWidth });

			this.tl = new TimelineMax({ paused: true });
			this.tl.to(this.$icon, .3, { x: 0 }, 0);
			this.tl.staggerTo(this.$nameLetter, .3, { y: 0, opacity: 1 }, .05, 0);
		}
	}, {
		key: 'onHover',
		value: function onHover(e) {

			if (e.type === "mouseenter") {
				this.tl.play();
			} else if (e.type === "mouseleave") {
				this.tl.reverse(0);
			}
		}
	}, {
		key: '_intervals',
		value: function _intervals() {}
	}, {
		key: '_points',
		value: function _points() {}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(AlbumCover.prototype.__proto__ || (0, _getPrototypeOf2.default)(AlbumCover.prototype), '_resize', this).call(this);

			this.$el.style.height = _Globals2.default.responsiveHeight(330) + "px";
			this.$el.style.width = _Globals2.default.responsiveHeight(330) * 340 / 330 + "px";

			this._intervals();
			this._points();
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(AlbumCover.prototype.__proto__ || (0, _getPrototypeOf2.default)(AlbumCover.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(AlbumCover.prototype.__proto__ || (0, _getPrototypeOf2.default)(AlbumCover.prototype), '_off', this).call(this);
		}
	}]);
	return AlbumCover;
}(_scrollable2.default)) || _class);
exports.default = AlbumCover;

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"album-cover",attrs:{"href":_vm.href,"target":"blank"},on:{"mouseenter":_vm.onHover,"mouseleave":_vm.onHover}},[_c('img',{staticClass:"cover",attrs:{"src":_vm.img}}),_c('img',{staticClass:"cover-shadow",attrs:{"src":_vm.shadow}}),_c('img',{staticClass:"cover-tongue",attrs:{"src":_vm.tongue}}),_c('div',{staticClass:"album-legend"},[_c('span',{staticClass:"word"},[_vm._v(_vm._s(_vm.translate('globals.listen')))]),_c('p',{staticClass:"album-name"},_vm._l((_vm.name),function(l){return _c('span',[_vm._v(_vm._s(l))])})),_c('img',{staticClass:"icon",attrs:{"src":"assets/images/play-icon.png"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"albums-slider"},[_c('div',{staticClass:"movable"},[_c('div',{staticClass:"slider-container"},[_c('div',{staticClass:"slider"},[_c('div',{staticClass:"slider-movable"},[_c('div',{ref:"vinyl",staticClass:"vinyl"},[_c('img',{attrs:{"src":"assets/images/vinyl.png"}})]),_c('AlbumCover',{ref:"cover0",attrs:{"name":"1999","href":"https://www.youtube.com/watch?v=EJOujsrIgOc"},nativeOn:{"mouseenter":function($event){_vm.onHover($event,0)},"mouseleave":function($event){_vm.onHover($event,0)}}}),_c('AlbumCover',{ref:"cover1",attrs:{"name":"rejex","href":"https://www.youtube.com/watch?v=WI92jrybHPo&list=PLMyw0dWAIHv4R7sjh-Iga4KaeioA34m4B"},nativeOn:{"mouseenter":function($event){_vm.onHover($event,1)},"mouseleave":function($event){_vm.onHover($event,1)}}}),_c('div',{staticClass:"albums-story"},[_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.translate('badass.between_albums')))])]),_c('AlbumCover',{ref:"cover2",attrs:{"name":"summer","href":"https://www.youtube.com/watch?v=jZr_aKxwk7g"},nativeOn:{"mouseenter":function($event){_vm.onHover($event,2)},"mouseleave":function($event){_vm.onHover($event,2)}}}),_c('AlbumCover',{ref:"cover3",attrs:{"name":"badass","href":"https://www.youtube.com/watch?v=fyZPH7kbFZ8"},nativeOn:{"mouseenter":function($event){_vm.onHover($event,3)},"mouseleave":function($event){_vm.onHover($event,3)}}})],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_badass_album_vue__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_badass_album_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_badass_album_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d856fb4_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_badass_album_vue__ = __webpack_require__(532);
function injectStyle (ssrContext) {
  __webpack_require__(529)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_badass_album_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d856fb4_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_badass_album_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(530);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("5416ff36", content, true, {});

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".badass-album{width:100%;position:relative;padding-bottom:70px}.badass-album .presentation{max-width:720px;margin:auto;text-align:center}@media screen and (min-width:1700px){.badass-album .presentation{max-width:1000px}}.badass-album .presentation .text{color:#fff;font-family:Abhaya Libre,serif;font-weight:700;font-size:1.25em;line-height:2.5em}.badass-album .presentation .text a,.badass-album .presentation .text span{text-decoration:underline;font-family:Poppins,sans-serif;font-weight:400;color:#fff}.badass-album .quote{max-width:1100px;margin:auto;text-align:center}@media screen and (min-width:1700px){.badass-album .quote{max-width:1400px}}.badass-album .quote blockquote{font-size:3.5em;line-height:1.2em;color:#fff;font-family:Poppins,sans-serif;font-weight:700;margin-top:60px}@media screen and (max-width:640px){.badass-album .quote blockquote{font-size:2.5em}}.badass-album .quote .translation{color:#fff;font-family:Saira Extra Condensed,sans-serif;font-size:.9375em;line-height:1.4em;letter-spacing:.15em;max-width:560px;margin:auto;margin-top:50px;text-transform:uppercase}", ""]);

// exports


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _gsap = __webpack_require__(6);

var _Globals = __webpack_require__(16);

var _Globals2 = _interopRequireDefault(_Globals);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BadassAlbum = (_dec = (0, _vueClassComponent2.default)({
	name: 'BadassAlbum',
	components: {},
	data: function data() {
		return {
			state: _Globals2.default.state
		};
	},
	computed: {
		isMobile: function isMobile() {
			return this.state.isMobile;
		},
		isTablet: function isTablet() {
			return this.state.isTablet;
		}
	}
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(BadassAlbum, _Scrollable);

	function BadassAlbum() {
		(0, _classCallCheck3.default)(this, BadassAlbum);
		return (0, _possibleConstructorReturn3.default)(this, (BadassAlbum.__proto__ || (0, _getPrototypeOf2.default)(BadassAlbum)).apply(this, arguments));
	}

	(0, _createClass3.default)(BadassAlbum, [{
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(BadassAlbum.prototype.__proto__ || (0, _getPrototypeOf2.default)(BadassAlbum.prototype), 'mounted', this).call(this);

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(BadassAlbum.prototype.__proto__ || (0, _getPrototypeOf2.default)(BadassAlbum.prototype), 'init', this).call(this);
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(BadassAlbum.prototype.__proto__ || (0, _getPrototypeOf2.default)(BadassAlbum.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_dom',
		value: function _dom() {}
	}, {
		key: '_intervals',
		value: function _intervals() {

			// this.tlScroll = new TimelineMax({paused: true})

			// this.scroller.interval('badass.album.timeline',{
			// 	start:this.bounds.top,
			// 	end: this.bounds.top + this.bounds.height,
			// 	exec:(e) => {
			// 		if(!e.isInside) return
			// 		this.tlScroll.progress(e.ratio)
			// 	}
			// })

		}
	}, {
		key: '_points',
		value: function _points() {}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(BadassAlbum.prototype.__proto__ || (0, _getPrototypeOf2.default)(BadassAlbum.prototype), '_resize', this).call(this);

			this._intervals();
			this._points();
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(BadassAlbum.prototype.__proto__ || (0, _getPrototypeOf2.default)(BadassAlbum.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(BadassAlbum.prototype.__proto__ || (0, _getPrototypeOf2.default)(BadassAlbum.prototype), '_off', this).call(this);
		}
	}]);
	return BadassAlbum;
}(_scrollable2.default)) || _class);
exports.default = BadassAlbum;

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badass-album"},[_c('div',{staticClass:"presentation"},[_c('p',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.translate('badass.badass_album_1'))}})]),_c('div',{staticClass:"quote"},[_c('blockquote',{domProps:{"innerHTML":_vm._s(_vm.translate('badass.quote_1'))}}),_c('p',{staticClass:"translation",domProps:{"innerHTML":_vm._s(_vm.translate('badass.traduction_1'))}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_black_beetles_vue__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_black_beetles_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_black_beetles_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a4ca3d4_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_black_beetles_vue__ = __webpack_require__(544);
function injectStyle (ssrContext) {
  __webpack_require__(534)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_black_beetles_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a4ca3d4_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_black_beetles_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(535);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("fa0a40f6", content, true, {});

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".black-beetles{width:100%;position:relative;padding-bottom:50px}.black-beetles .presentation{position:relative;width:100%;padding-top:15%;padding-bottom:25%}@media screen and (max-width:640px){.black-beetles .presentation{padding-top:50px;padding-bottom:0}}.black-beetles .presentation .text{color:#fff;font-family:Abhaya Libre,serif;font-weight:700;font-size:1.25em;line-height:2.5em;width:30%;margin-left:55%;position:relative;z-index:80}@media screen and (max-width:640px){.black-beetles .presentation .text{width:100%;margin-left:0}}.black-beetles .presentation .text a,.black-beetles .presentation .text span{text-decoration:underline;font-family:Abhaya Libre,serif;font-weight:700;color:#fff}.black-beetles .parallax-image,.black-beetles .wrap-image{position:absolute}.black-beetles .parallax-image.image-1,.black-beetles .wrap-image.image-1{top:0;left:0;width:50%}.black-beetles .parallax-image.image-2,.black-beetles .wrap-image.image-2{bottom:0;right:5%;width:50%}.black-beetles .parallax-image img,.black-beetles .wrap-image img{width:100%}.black-beetles .mobile-image{width:100%;margin:20px 0}.black-beetles .black-beetles-quote{width:100%;margin-top:50px;text-align:center;position:relative;z-index:80}@media screen and (max-width:640px){.black-beetles .black-beetles-quote{margin-top:50px}}.black-beetles .black-beetles-quote blockquote{font-size:2.5em;line-height:1.25em;color:#fff;font-family:Poppins,sans-serif;max-width:1200px;width:100%;margin:auto}.black-beetles .black-beetles-quote .quote-author{font-size:1.25em;line-height:2.5em;margin-top:15px}.black-beetles .black-beetles-quote .quote-author,.black-beetles .black-beetles-quote .quote-translation{text-transform:uppercase;font-family:Saira Extra Condensed,sans-serif;font-weight:300;color:#fff;letter-spacing:.15em}.black-beetles .black-beetles-quote .quote-translation{max-width:570px;margin:auto;margin-top:20px;font-size:15px;line-height:1.4em}", ""]);

// exports


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _gsap = __webpack_require__(6);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _mixins = __webpack_require__(181);

var _responsiveImage = __webpack_require__(100);

var _responsiveImage2 = _interopRequireDefault(_responsiveImage);

var _Globals = __webpack_require__(16);

var _Globals2 = _interopRequireDefault(_Globals);

var _parallaxImage = __webpack_require__(537);

var _parallaxImage2 = _interopRequireDefault(_parallaxImage);

var _mlk = __webpack_require__(542);

var _mlk2 = _interopRequireDefault(_mlk);

var _joeyBadaFtBjTheChicagoKidLikeMeOfficialMusicVideo = __webpack_require__(543);

var _joeyBadaFtBjTheChicagoKidLikeMeOfficialMusicVideo2 = _interopRequireDefault(_joeyBadaFtBjTheChicagoKidLikeMeOfficialMusicVideo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlackBeetles = (_dec = (0, _vueClassComponent2.default)({
	name: 'BlackBeetles',
	components: { ResponsiveImage: _responsiveImage2.default, ParallaxImage: _parallaxImage2.default },
	mixins: [_mixins.GlobalMixin],
	data: function data() {
		return {
			mlkImg: _mlk2.default,
			posterImg: _joeyBadaFtBjTheChicagoKidLikeMeOfficialMusicVideo2.default
		};
	}
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(BlackBeetles, _Scrollable);

	function BlackBeetles() {
		(0, _classCallCheck3.default)(this, BlackBeetles);
		return (0, _possibleConstructorReturn3.default)(this, (BlackBeetles.__proto__ || (0, _getPrototypeOf2.default)(BlackBeetles)).apply(this, arguments));
	}

	(0, _createClass3.default)(BlackBeetles, [{
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(BlackBeetles.prototype.__proto__ || (0, _getPrototypeOf2.default)(BlackBeetles.prototype), 'mounted', this).call(this);

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(BlackBeetles.prototype.__proto__ || (0, _getPrototypeOf2.default)(BlackBeetles.prototype), 'init', this).call(this);
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(BlackBeetles.prototype.__proto__ || (0, _getPrototypeOf2.default)(BlackBeetles.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_dom',
		value: function _dom() {
			this.$image1 = this.$el.querySelector('.image-1');
			this.$image2 = this.$el.querySelector('.image-2');
			this.$text1 = this.$el.querySelector('.text-1');
		}
	}, {
		key: 'initTimeline',
		value: function initTimeline() {
			(0, _get3.default)(BlackBeetles.prototype.__proto__ || (0, _getPrototypeOf2.default)(BlackBeetles.prototype), 'initTimeline', this).call(this);

			this.total = this.boundsAnim.bottom - this.boundsAnim.top;
			var dur = window.innerHeight / this.total;

			this.tl.fromTo(this.$text1, dur, {
				y: _Globals2.default.responsiveHeight(-150)
			}, {
				y: _Globals2.default.responsiveHeight(0)
			}, 0);

			this.tl.to(this.$text1, dur, { y: 40 }, dur);

			// this.tl.fromTo(this.$image2,1,{y:Globals.responsiveHeight(100)},{y:Globals.responsiveHeight(-20), delay:.3},0)
		}
	}, {
		key: 'raf',
		value: function raf(y) {
			(0, _get3.default)(BlackBeetles.prototype.__proto__ || (0, _getPrototypeOf2.default)(BlackBeetles.prototype), 'raf', this).call(this, y);
		}
	}, {
		key: '_points',
		value: function _points() {}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(BlackBeetles.prototype.__proto__ || (0, _getPrototypeOf2.default)(BlackBeetles.prototype), '_resize', this).call(this);

			this.boundsAnim = {
				top: this.bounds.top - window.innerHeight,
				bottom: this.bounds.top + window.innerHeight
			};

			this.initTimeline();
			this._points();
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(BlackBeetles.prototype.__proto__ || (0, _getPrototypeOf2.default)(BlackBeetles.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(BlackBeetles.prototype.__proto__ || (0, _getPrototypeOf2.default)(BlackBeetles.prototype), '_off', this).call(this);
		}
	}]);
	return BlackBeetles;
}(_scrollable2.default)) || _class);
exports.default = BlackBeetles;

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_parallax_image_vue__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_parallax_image_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_parallax_image_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49c3a2f8_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_parallax_image_vue__ = __webpack_require__(541);
function injectStyle (ssrContext) {
  __webpack_require__(538)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_parallax_image_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49c3a2f8_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_parallax_image_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(539);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("77fafaf2", content, true, {});

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".parallax-image{overflow:hidden}", ""]);

// exports


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _Globals = __webpack_require__(16);

var _Globals2 = _interopRequireDefault(_Globals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ParallaxImage = (_dec = (0, _vueClassComponent2.default)({
	name: 'PoliticalIntro',
	components: {},
	props: ["src"],
	data: function data() {
		return {
			img: undefined
		};
	}
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(ParallaxImage, _Scrollable);

	function ParallaxImage() {
		(0, _classCallCheck3.default)(this, ParallaxImage);
		return (0, _possibleConstructorReturn3.default)(this, (ParallaxImage.__proto__ || (0, _getPrototypeOf2.default)(ParallaxImage)).apply(this, arguments));
	}

	(0, _createClass3.default)(ParallaxImage, [{
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(ParallaxImage.prototype.__proto__ || (0, _getPrototypeOf2.default)(ParallaxImage.prototype), 'mounted', this).call(this);

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(ParallaxImage.prototype.__proto__ || (0, _getPrototypeOf2.default)(ParallaxImage.prototype), 'init', this).call(this);

			this.load();
		}
	}, {
		key: 'load',
		value: function load() {
			var _this2 = this;

			var bufferImg = new Image();
			bufferImg.onload = function () {
				_this2.img = _this2.src;
			};
			bufferImg.src = this.src;
		}
	}, {
		key: 'initTimeline',
		value: function initTimeline() {
			(0, _get3.default)(ParallaxImage.prototype.__proto__ || (0, _getPrototypeOf2.default)(ParallaxImage.prototype), 'initTimeline', this).call(this);

			var total = this.boundsAnim.bottom - this.boundsAnim.top;

			var durInOut = this.bounds.height / total;

			this.tl.fromTo(this.$img, durInOut, { scale: 1.1, y: -this.bounds.height * .2 - 10 }, { y: -10, scale: 1.1, ease: Power0.easeNone }, 0);
			this.tl.to(this.$img, 1 - durInOut * 2, { y: 10, scale: 1.1, ease: Power0.easeNone }, durInOut);
			this.tl.to(this.$img, durInOut, { scale: 1.1, y: this.bounds.height * .2 + 10, ease: Power0.easeNone }, 1 - durInOut);
		}
	}, {
		key: '_dom',
		value: function _dom() {
			this.$img = this.$el.querySelector('img');
		}
	}, {
		key: 'raf',
		value: function raf(y) {
			(0, _get3.default)(ParallaxImage.prototype.__proto__ || (0, _getPrototypeOf2.default)(ParallaxImage.prototype), 'raf', this).call(this, y);
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(ParallaxImage.prototype.__proto__ || (0, _getPrototypeOf2.default)(ParallaxImage.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(ParallaxImage.prototype.__proto__ || (0, _getPrototypeOf2.default)(ParallaxImage.prototype), '_resize', this).call(this);

			this.boundsAnim = {
				top: this.bounds.top - _Globals2.default.height,
				bottom: this.bounds.top + this.bounds.height
			};

			this.initTimeline();
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(ParallaxImage.prototype.__proto__ || (0, _getPrototypeOf2.default)(ParallaxImage.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(ParallaxImage.prototype.__proto__ || (0, _getPrototypeOf2.default)(ParallaxImage.prototype), '_off', this).call(this);
		}
	}]);
	return ParallaxImage;
}(_scrollable2.default)) || _class);
exports.default = ParallaxImage;

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parallax-image"},[_c('img',{attrs:{"src":_vm.img}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "63a0e5fac2407d150a5e0ce7e78dbeb4.png";

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "95a8b13a9b3a3a30cb4c85d9b538ddb9.png";

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"black-beetles"},[_c('div',{staticClass:"presentation"},[_c('p',{staticClass:"text text-1",domProps:{"innerHTML":_vm._s(_vm.translate('badass.badass_album_2'))}}),(_vm.isMobile)?_c('div',{staticClass:"mobile-image"},[_c('responsive-image',{attrs:{"src":"assets/images/mlk.png","width":"720","height":"720"}})],1):_vm._e(),(!_vm.isMobile)?_c('parallax-image',{staticClass:"image-1",attrs:{"src":_vm.mlkImg}}):_vm._e(),(!_vm.isMobile)?_c('parallax-image',{staticClass:"image-2",attrs:{"src":_vm.posterImg}}):_vm._e()],1),_c('div',{staticClass:"black-beetles-quote"},[_c('blockquote',{domProps:{"innerHTML":_vm._s(_vm.translate('badass.quote_2'))}}),_c('p',{staticClass:"quote-author",domProps:{"innerHTML":_vm._s(_vm.translate('badass.author_2'))}}),_c('p',{staticClass:"quote-translation",domProps:{"innerHTML":_vm._s(_vm.translate('badass.traduction_2'))}})]),(_vm.isMobile)?_c('div',{staticClass:"mobile-image"},[_c('responsive-image',{attrs:{"src":"assets/images/joey-bada-ft-bj-the-chicago-kid-like-me-official-music-video.png","width":"720","height":"306"}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_likeme_clip_vue__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_likeme_clip_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_likeme_clip_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2945fc68_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_likeme_clip_vue__ = __webpack_require__(549);
function injectStyle (ssrContext) {
  __webpack_require__(546)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_likeme_clip_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2945fc68_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_likeme_clip_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(547);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("1030cad4", content, true, {});

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".likeme-clip{width:100%;position:relative;padding-bottom:100px}.likeme-clip .splited-text{max-width:800px;margin:auto;text-align:center}@media screen and (min-width:1700px){.likeme-clip .splited-text{max-width:1200px}}@media screen and (max-width:640px){.likeme-clip .splited-text{text-align:left}}", ""]);

// exports


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _gsap = __webpack_require__(6);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _splitedText = __webpack_require__(42);

var _splitedText2 = _interopRequireDefault(_splitedText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LikemeClip = (_dec = (0, _vueClassComponent2.default)({
	name: 'LikemeClip',
	components: { SplitedText: _splitedText2.default },
	data: function data() {
		return {
			text: ""
		};
	}
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(LikemeClip, _Scrollable);

	function LikemeClip() {
		(0, _classCallCheck3.default)(this, LikemeClip);
		return (0, _possibleConstructorReturn3.default)(this, (LikemeClip.__proto__ || (0, _getPrototypeOf2.default)(LikemeClip)).apply(this, arguments));
	}

	(0, _createClass3.default)(LikemeClip, [{
		key: 'created',
		value: function created() {
			this.text = this.translate('badass.badass_album_3');
		}
	}, {
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(LikemeClip.prototype.__proto__ || (0, _getPrototypeOf2.default)(LikemeClip.prototype), 'mounted', this).call(this);

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(LikemeClip.prototype.__proto__ || (0, _getPrototypeOf2.default)(LikemeClip.prototype), 'init', this).call(this);
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(LikemeClip.prototype.__proto__ || (0, _getPrototypeOf2.default)(LikemeClip.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_dom',
		value: function _dom() {}
	}, {
		key: 'raf',
		value: function raf(y) {
			(0, _get3.default)(LikemeClip.prototype.__proto__ || (0, _getPrototypeOf2.default)(LikemeClip.prototype), 'raf', this).call(this, y);
		}
	}, {
		key: 'initTimeline',
		value: function initTimeline() {
			var _this2 = this;

			(0, _get3.default)(LikemeClip.prototype.__proto__ || (0, _getPrototypeOf2.default)(LikemeClip.prototype), 'initTimeline', this).call(this);

			var fake = { value: 0 };
			var appearTime = window.innerHeight * .2 / (window.innerHeight + this.bounds.height);

			this.tl.fromTo(fake, 1, { value: 0 }, { value: 1, ease: Power0.easeNone }, 0);
			this.tl.add(function () {
				if (_this2.scroller.direction == 1 || _this2.isResized == false) {
					_this2.$refs.splitedText.animateIn();
				} else {
					_this2.$refs.splitedText.animateOut();
				}
				_this2.isResized = true;
			}, appearTime);
		}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(LikemeClip.prototype.__proto__ || (0, _getPrototypeOf2.default)(LikemeClip.prototype), '_resize', this).call(this);

			this.boundsAnim = {
				top: this.bounds.top - window.innerHeight,
				bottom: this.bounds.top + this.bounds.height
			};

			this.initTimeline();
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(LikemeClip.prototype.__proto__ || (0, _getPrototypeOf2.default)(LikemeClip.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(LikemeClip.prototype.__proto__ || (0, _getPrototypeOf2.default)(LikemeClip.prototype), '_off', this).call(this);
		}
	}]);
	return LikemeClip;
}(_scrollable2.default)) || _class);
exports.default = LikemeClip;

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"likeme-clip"},[_c('splited-text',{ref:"splitedText",attrs:{"text":_vm.text}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badass-origins"},[_vm._m(0),_c('badass-origins-intro',{staticClass:"badass-origins__section"}),_c('albums-slider',{staticClass:"badass-origins__section"}),_c('badass-album',{staticClass:"badass-origins__section"}),_c('black-beetles',{staticClass:"badass-origins__section"}),_c('likeme-clip',{staticClass:"badass-origins__section"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background-image"},[_c('img',{attrs:{"src":"assets/images/badass-origins-intro.jpg"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_amerikkkan_vue__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_amerikkkan_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_amerikkkan_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67f7da78_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_amerikkkan_vue__ = __webpack_require__(566);
function injectStyle (ssrContext) {
  __webpack_require__(552)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_amerikkkan_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67f7da78_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_amerikkkan_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(553);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("6767ba02", content, true, {});

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".amerikkkan{width:100%;background:#0f0d37;position:relative;z-index:40}.amerikkkan .amerikkkan-section{position:relative;z-index:30}.amerikkkan .posters-overlay{position:absolute;top:0;left:0;z-index:50;will-change:transform}.amerikkkan .next-image{position:absolute;top:0;left:0;z-index:40;will-change:transform;height:100vh;width:100%;opacity:0;pointer-events:none}.amerikkkan .next-image img{height:100%;width:100%;object-fit:cover}", ""]);

// exports


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _amerikkkanIntro = __webpack_require__(555);

var _amerikkkanIntro2 = _interopRequireDefault(_amerikkkanIntro);

var _background = __webpack_require__(30);

var _background2 = _interopRequireDefault(_background);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _posterOverlay = __webpack_require__(560);

var _posterOverlay2 = _interopRequireDefault(_posterOverlay);

var _Globals = __webpack_require__(16);

var _Globals2 = _interopRequireDefault(_Globals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Political = (_dec = (0, _vueClassComponent2.default)({
	name: 'Political',
	components: { Background: _background2.default, AmerikkkanIntro: _amerikkkanIntro2.default, PosterOverlay: _posterOverlay2.default }
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(Political, _Scrollable);

	function Political() {
		(0, _classCallCheck3.default)(this, Political);
		return (0, _possibleConstructorReturn3.default)(this, (Political.__proto__ || (0, _getPrototypeOf2.default)(Political)).apply(this, arguments));
	}

	(0, _createClass3.default)(Political, [{
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(Political.prototype.__proto__ || (0, _getPrototypeOf2.default)(Political.prototype), 'mounted', this).call(this);

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(Political.prototype.__proto__ || (0, _getPrototypeOf2.default)(Political.prototype), 'init', this).call(this);
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(Political.prototype.__proto__ || (0, _getPrototypeOf2.default)(Political.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_dom',
		value: function _dom() {
			this.$posterOverlay = this.$refs.posters.$el;
			this.$posters = this.$refs.posters.$posters;
			this.$nextImage = this.$refs.nextImage;
			this.$introContent = this.$el.querySelector('.amerikkkan-section .amerikkkan-intro-content');
			this.$introContent1 = this.$el.querySelector('.amerikkkan-section .amerikkkan-intro-content .splited-text');
			this.$spotify = this.$el.querySelector('.amerikkkan-section .amerikkkan-intro-content .spotify-module');
		}
	}, {
		key: 'initTimeline',
		value: function initTimeline() {
			(0, _get3.default)(Political.prototype.__proto__ || (0, _getPrototypeOf2.default)(Political.prototype), 'initTimeline', this).call(this);

			var h = _Globals2.default.height;

			var start_in = Math.floor(this.$introContent.getBoundingClientRect().top - this.bounds.top - this.scroller.scroll.position) - window.innerHeight * .5 + this.$introContent.getBoundingClientRect().height * .5;

			var start_in_ratio = start_in / this.newHeight;

			var h_ratio = window.innerHeight / this.newHeight;

			this.tl.set(this.$introContent, { opacity: 1 }, 0);
			this.tl.set(this.$nextImage, { opacity: 0 }, 0);
			this.tl.set(this.$nextImage.querySelector('img'), { opacity: 1 }, 0);

			this.tl.fromTo([this.$posterOverlay, this.$nextImage], 1, { y: 0 }, { y: this.newHeight, ease: Power0.easeNone }, 0);

			this.tl.fromTo(this.$introContent1, 1 - start_in_ratio - h_ratio, { y: 0 }, { y: this.newHeight - h - start_in,
				ease: Power0.easeNone }, start_in_ratio);

			this.tl.fromTo(this.$spotify, 1 - start_in_ratio - h_ratio, { y: 0 }, { y: 300,
				ease: Power0.easeNone }, start_in_ratio);

			this.tl.set(this.$introContent, { opacity: 0 }, 1 - h_ratio);
			this.tl.set(this.$nextImage, { opacity: 1 }, 1 - h_ratio);
			this.tl.fromTo(this.$nextImage, h_ratio * .9, { scale: 1.2 }, { scale: 1 }, 1 - h_ratio);
			this.tl.set(this.$nextImage.querySelector('img'), { opacity: 0 }, 1);

			var start = start_in_ratio;
			var end = 1 - h_ratio;

			for (var i = 0; i < this.$posters.length; i++) {

				var rand_start = Math.random() * (end - .05 - start) + start / 2;
				var rotZ = this.$refs.posters.posters[i].rotation;

				var rand_start2 = Math.random() * (1.2 - .8) + .8;

				this.tl.to(this.$posters[i], 1 - rand_start - h_ratio, { y: 0, x: 0, rotationZ: rotZ, ease: Power0.easeNone }, rand_start);

				this.tl.to(this.$posters[i], h_ratio, { y: -(h * 2) * rand_start2, ease: Power0.easeNone }, 1 - h_ratio);
			}
		}
	}, {
		key: 'raf',
		value: function raf(y) {
			(0, _get3.default)(Political.prototype.__proto__ || (0, _getPrototypeOf2.default)(Political.prototype), 'raf', this).call(this, y);
		}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(Political.prototype.__proto__ || (0, _getPrototypeOf2.default)(Political.prototype), '_resize', this).call(this);

			this.offset = _Globals2.default.responsiveHeight(300);

			this.newHeight = this.offset + this.bounds.height;
			this.bounds.height = this.newHeight;
			this.$el.style.height = this.bounds.height + "px";

			this.boundsAnim = {
				top: this.bounds.top,
				bottom: this.bounds.top + this.newHeight
			};

			this.$refs.posters._resize();

			this.initTimeline();
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(Political.prototype.__proto__ || (0, _getPrototypeOf2.default)(Political.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(Political.prototype.__proto__ || (0, _getPrototypeOf2.default)(Political.prototype), '_off', this).call(this);
		}
	}]);
	return Political;
}(_scrollable2.default)) || _class);
exports.default = Political;

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_amerikkkan_intro_vue__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_amerikkkan_intro_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_amerikkkan_intro_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4e6231e_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_amerikkkan_intro_vue__ = __webpack_require__(559);
function injectStyle (ssrContext) {
  __webpack_require__(556)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_amerikkkan_intro_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4e6231e_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_amerikkkan_intro_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(557);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("056ee01d", content, true, {});

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".amerikkkan-intro{width:100%;position:relative;min-height:100vh;padding-bottom:250px}@media screen and (max-width:640px){.amerikkkan-intro{padding-bottom:50px}}.amerikkkan-intro .amerikkkan-intro-content{position:relative;width:100%}@media screen and (max-width:640px){.amerikkkan-intro .amerikkkan-intro-content{padding-top:30px}}.amerikkkan-intro .splited-text{width:50vw;margin:auto;text-align:center;margin-top:0;max-width:720px;position:relative;z-index:80}@media screen and (min-width:1700px){.amerikkkan-intro .splited-text{max-width:900px}}@media screen and (max-width:640px){.amerikkkan-intro .splited-text{width:100%;margin-top:8px}}.amerikkkan-intro .spotify-module{position:absolute;top:50px;left:5%;z-index:80}@media screen and (max-width:640px){.amerikkkan-intro .spotify-module{position:relative;top:0;left:0}}.amerikkkan-intro .spotify-module .spotify-link{position:relative;display:inline-block;outline:none;text-decoration:none;color:#fff;text-align:center}.amerikkkan-intro .spotify-module .spotify-link .module-image{position:relative}@media screen and (max-width:640px){.amerikkkan-intro .spotify-module .spotify-link{display:flex;align-items:flex-end}.amerikkkan-intro .spotify-module .spotify-link .module-text{text-align:left;margin-bottom:12px;padding-left:10px}}.amerikkkan-intro .spotify-module .spotify-link .thumb{margin-bottom:15px}@media screen and (max-width:640px){.amerikkkan-intro .spotify-module .spotify-link .thumb{margin-bottom:0}}.amerikkkan-intro .spotify-module .spotify-link .play-icon{position:absolute;width:42px;left:calc(50% - 21px);top:130px}@media screen and (max-width:640px){.amerikkkan-intro .spotify-module .spotify-link .play-icon{top:0;left:0;position:relative;margin-bottom:6px}}.amerikkkan-intro .spotify-module .spotify-link p{font-size:15px;line-height:1.266666666666667em;font-family:Saira Extra Condensed,sans-serif;text-transform:uppercase;font-weight:300;letter-spacing:.15em}.amerikkkan-intro .spotify-module .spotify-link p.album-name{font-weight:700}", ""]);

// exports


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _sectionIntro = __webpack_require__(57);

var _sectionIntro2 = _interopRequireDefault(_sectionIntro);

var _splitedText = __webpack_require__(42);

var _splitedText2 = _interopRequireDefault(_splitedText);

var _mixins = __webpack_require__(181);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PoliticalIntro = (_dec = (0, _vueClassComponent2.default)({
	name: 'PoliticalIntro',
	components: { SectionIntro: _sectionIntro2.default, SplitedText: _splitedText2.default },
	mixins: [_mixins.GlobalMixin],
	data: function data() {
		return {
			text: ""
		};
	}
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(PoliticalIntro, _Scrollable);

	function PoliticalIntro() {
		(0, _classCallCheck3.default)(this, PoliticalIntro);
		return (0, _possibleConstructorReturn3.default)(this, (PoliticalIntro.__proto__ || (0, _getPrototypeOf2.default)(PoliticalIntro)).apply(this, arguments));
	}

	(0, _createClass3.default)(PoliticalIntro, [{
		key: 'created',
		value: function created() {
			this.text = this.translate('amerikkkan.text');
		}
	}, {
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(PoliticalIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalIntro.prototype), 'mounted', this).call(this);

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(PoliticalIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalIntro.prototype), 'init', this).call(this);
		}
	}, {
		key: '_dom',
		value: function _dom() {

			this.$text = this.$el.querySelector('.text');
			this.$fakeText = this.$el.querySelector('.fake-text');
		}
	}, {
		key: 'initTimeline',
		value: function initTimeline() {
			var _this2 = this;

			(0, _get3.default)(PoliticalIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalIntro.prototype), 'initTimeline', this).call(this);

			this.tl.fromTo(this.fakeAnim, 1, { value: 0 }, { value: 1, ease: Power0.easeNone }, 0);
			this.tl.add(function () {

				if (_this2.scroller.direction == 1 || _this2.isResized == false) {
					_this2.$refs.splitedText.animateIn();
				} else {
					_this2.$refs.splitedText.animateOut();
				}
				_this2.isResized = true;
			}, window.innerHeight * .7 / this.bounds.height);
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(PoliticalIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalIntro.prototype), '_bind', this).call(this);
		}
	}, {
		key: 'raf',
		value: function raf(y) {
			(0, _get3.default)(PoliticalIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalIntro.prototype), 'raf', this).call(this, y);
		}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(PoliticalIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalIntro.prototype), '_resize', this).call(this);

			this.$refs.splitedText.resize();

			this.boundsAnim = {
				top: this.bounds.top - window.innerHeight,
				bottom: this.bounds.top + this.bounds.height
			};

			this.initTimeline();
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(PoliticalIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalIntro.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(PoliticalIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalIntro.prototype), '_off', this).call(this);
		}
	}]);
	return PoliticalIntro;
}(_scrollable2.default)) || _class);
exports.default = PoliticalIntro;

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amerikkkan-intro"},[_c('section-intro',{attrs:{"img":"assets/images/amerikkkan.jpg","title":"All AmeriKKKan Bada$$"}}),_c('div',{staticClass:"amerikkkan-intro-content"},[_c('div',{staticClass:"spotify-module"},[_c('a',{staticClass:"spotify-link",attrs:{"href":"https://www.youtube.com/watch?v=kYgarGQnfJ4","target":"blank"}},[_c('div',{staticClass:"module-image"},[_c('img',{staticClass:"thumb",attrs:{"src":"assets/images/amerikkkan-thumb.png"}}),(!_vm.isMobile)?_c('img',{staticClass:"play-icon",attrs:{"src":"assets/images/play-full-icon.png"}}):_vm._e()]),_c('div',{staticClass:"module-text"},[(_vm.isMobile)?_c('img',{staticClass:"play-icon",attrs:{"src":"assets/images/play-full-icon.png"}}):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.translate('globals.listen')))]),_c('p',{staticClass:"album-name"},[_vm._v("all - amerikkkan bada$$")])])])]),_c('splited-text',{ref:"splitedText",attrs:{"text":_vm.text}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_poster_overlay_vue__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_poster_overlay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_poster_overlay_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4e815cc_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_poster_overlay_vue__ = __webpack_require__(565);
function injectStyle (ssrContext) {
  __webpack_require__(561)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_poster_overlay_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4e815cc_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_poster_overlay_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(562);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("fdc34524", content, true, {});

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".posters-overlay{width:100vw;height:100vh;pointer-events:none}.posters-overlay .poster{position:absolute;width:350px}.posters-overlay .poster height 497px,.posters-overlay .poster img{width:100%}.posters-overlay .poster:first-child{top:10px;left:-200px;transform:rotate(-8deg);z-index:1}", ""]);

// exports


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scroller = __webpack_require__(18);

var _scroller2 = _interopRequireDefault(_scroller);

var _ticker = __webpack_require__(19);

var _ticker2 = _interopRequireDefault(_ticker);

var _section = __webpack_require__(41);

var _section2 = _interopRequireDefault(_section);

var _posters = __webpack_require__(564);

var _posters2 = _interopRequireDefault(_posters);

var _Globals = __webpack_require__(16);

var _Globals2 = _interopRequireDefault(_Globals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PostersOverlay = (_dec = (0, _vueClassComponent2.default)({
	name: 'PostersOverlay',
	components: {},
	props: [],
	data: function data() {
		return {
			posters: _posters2.default.posters
		};
	}
}), _dec(_class = function (_Vue) {
	(0, _inherits3.default)(PostersOverlay, _Vue);

	function PostersOverlay() {
		(0, _classCallCheck3.default)(this, PostersOverlay);
		return (0, _possibleConstructorReturn3.default)(this, (PostersOverlay.__proto__ || (0, _getPrototypeOf2.default)(PostersOverlay)).apply(this, arguments));
	}

	(0, _createClass3.default)(PostersOverlay, [{
		key: 'mounted',
		value: function mounted() {
			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {}
	}, {
		key: '_dom',
		value: function _dom() {
			this.$posters = this.$el.querySelectorAll('.poster');
		}
	}, {
		key: 'initPosters',
		value: function initPosters() {
			var _this2 = this;

			this.tlScroll = new TimelineMax({ paused: true });

			this.posters.forEach(function (w, i) {

				var left = _Globals2.default.responsiveWidth(w.x);
				var top = _Globals2.default.responsiveHeight(w.y);
				var height = _Globals2.default.responsiveHeight(497);
				var width = _Globals2.default.responsiveWidth(350);
				var scale = window.innerWidth / 1440;

				_gsap.TweenMax.set(_this2.$posters[i], { left: left, top: top, rotationZ: Math.random() * 360 - 180, height: height, width: width, zIndex: w.position });

				var x = left + width / 2 > window.innerWidth / 2 ? window.innerWidth / 2 + width / 2 + Math.random() * window.innerWidth / 2 : -(window.innerWidth / 2 + width / 2) - Math.random() * window.innerWidth / 2;

				var y = top + height / 2 > window.innerHeight / 2 ? window.innerHeight / 2 + height / 2 + Math.random() * window.innerHeight / 2 : -(window.innerHeight / 2 + height / 2) - Math.random() * window.innerHeight / 2;

				_gsap.TweenMax.set(_this2.$posters[i], { x: x, y: y });
			});
		}
	}, {
		key: 'play',
		value: function play(ratio) {
			this.tlScroll.progress(ratio);
		}
	}, {
		key: '_resize',
		value: function _resize() {

			this.initPosters();
		}
	}, {
		key: 'update',
		value: function update() {}
	}]);
	return PostersOverlay;
}(_vue2.default)) || _class);
exports.default = PostersOverlay;

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports = {"posters":[{"x":-200,"y":10,"position":1,"rotation":-8},{"x":1110,"y":460,"position":1,"rotation":1},{"x":-200,"y":480,"position":1,"rotation":0},{"x":110,"y":-10,"position":1,"rotation":-3},{"x":150,"y":450,"position":4,"rotation":0},{"x":-40,"y":25,"position":4,"rotation":80},{"x":450,"y":-250,"position":1,"rotation":4},{"x":1210,"y":260,"position":1,"rotation":-45},{"x":450,"y":220,"position":1,"rotation":2},{"x":450,"y":560,"position":1,"rotation":-10},{"x":720,"y":40,"position":3,"rotation":-2},{"x":760,"y":630,"position":2,"rotation":15},{"x":860,"y":-100,"position":1,"rotation":-18},{"x":780,"y":280,"position":1,"rotation":1},{"x":1130,"y":-60,"position":1,"rotation":5}]}

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"posters-overlay"},_vm._l((_vm.posters),function(poster){return _c('div',{staticClass:"poster"},[_c('img',{attrs:{"src":"assets/images/poster.jpg"}})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amerikkkan"},[_c('amerikkkan-intro',{staticClass:"amerikkkan-section"}),_c('poster-overlay',{ref:"posters"}),_c('div',{ref:"nextImage",staticClass:"next-image"},[_c('img',{attrs:{"src":"assets/images/land-of-free.jpg"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_land_of_free_vue__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_land_of_free_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_land_of_free_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fd97f38_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_land_of_free_vue__ = __webpack_require__(571);
function injectStyle (ssrContext) {
  __webpack_require__(568)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_land_of_free_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fd97f38_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_land_of_free_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(569);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("1ec77c94", content, true, {});

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".land-of-free{width:100%;min-height:100vh;background:#0f0d37;position:relative;padding-bottom:10%;z-index:50;background-color:transparent}@media screen and (max-width:640px){.land-of-free{padding-bottom:50px}}.land-of-free .background{z-index:30}.land-of-free .background-image{position:absolute;top:0;left:0;height:100vh;width:100%;z-index:20;will-change:transform}.land-of-free .background-image .layer{position:absolute;top:0;left:0;bottom:0;right:0;background-color:#000;opacity:0}.land-of-free .background-image img{width:100%;height:100%;object-fit:cover}.land-of-free .interview-wrapper{position:relative;z-index:70;padding-top:5vh;text-align:center}.land-of-free .interview-wrapper .title{color:#fff;font-size:6.25em;font-weight:700}.land-of-free .interview-wrapper .text{color:#fff;font-size:1.125em;line-height:1.333333333333333em;font-family:Abhaya Libre,serif;max-width:600px;margin:auto}@media screen and (max-width:640px){.land-of-free .interview-wrapper .text{font-size:1em}}.land-of-free .interview-wrapper .text span{font-size:1.125em;font-family:Poppins,sans-serif}.land-of-free .interview-wrapper blockquote{color:#fff;font-size:1.875em;line-height:1.333333333333333em;font-family:Poppins,sans-serif;max-width:800px;margin:auto}.land-of-free .interview-wrapper .translation{max-width:360px;margin:auto;color:#fff;font-size:.9375em;line-height:1.4em;letter-spacing:.15em;font-family:Saira Extra Condensed,sans-serif;font-weight:300;text-transform:uppercase}.land-of-free .interview-wrapper .about-birthday{margin-top:80px}.land-of-free .interview-wrapper .about-clip{margin-top:70px}@media screen and (max-width:640px){.land-of-free .interview-wrapper .about-clip{margin-top:50px}}.land-of-free .interview-wrapper .about-clip .text{margin-top:130px}@media screen and (max-width:640px){.land-of-free .interview-wrapper .about-clip .text{margin-top:50px}}.land-of-free .interview-wrapper .about-president{margin-top:42px}.land-of-free .interview-wrapper .about-president .translation{margin-top:20px}.land-of-free .interview-wrapper .about-storyboard{margin-top:50px}", ""]);

// exports


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _background = __webpack_require__(30);

var _background2 = _interopRequireDefault(_background);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LandOfFree = (_dec = (0, _vueClassComponent2.default)({
	name: 'LandOfFree',
	components: { Background: _background2.default }
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(LandOfFree, _Scrollable);

	function LandOfFree() {
		(0, _classCallCheck3.default)(this, LandOfFree);
		return (0, _possibleConstructorReturn3.default)(this, (LandOfFree.__proto__ || (0, _getPrototypeOf2.default)(LandOfFree)).apply(this, arguments));
	}

	(0, _createClass3.default)(LandOfFree, [{
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(LandOfFree.prototype.__proto__ || (0, _getPrototypeOf2.default)(LandOfFree.prototype), 'mounted', this).call(this);

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(LandOfFree.prototype.__proto__ || (0, _getPrototypeOf2.default)(LandOfFree.prototype), 'init', this).call(this);

			this.isResized = false;
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(LandOfFree.prototype.__proto__ || (0, _getPrototypeOf2.default)(LandOfFree.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_dom',
		value: function _dom() {
			this.$bg = this.$el.querySelector('.background-image');
			this.$bgLayer = this.$bg.querySelector('.layer');
		}
	}, {
		key: 'initTimeline',
		value: function initTimeline() {
			var _this2 = this;

			(0, _get3.default)(LandOfFree.prototype.__proto__ || (0, _getPrototypeOf2.default)(LandOfFree.prototype), 'initTimeline', this).call(this);

			var hw_ratio = window.innerHeight / 3 / this.bounds.height;

			var appearTime = window.innerHeight / (this.bounds.height + window.innerHeight * 2);

			// for(let i = 0; i < 6; i++) {
			// 	const el = this.$refs[`text${i}`]
			// 	const b = el.getBoundingClientRect()

			// 	const textAppearTime = (b.top - this.bounds.top + b.height * .5) / (this.bounds.height + window.innerHeight * 2)
			// 	const textAnimTime = b.height * .8 / (this.bounds.height + window.innerHeight * 2)				
			// 	this.tl.fromTo(el,textAnimTime,{y:0,opacity:0},{y:0,opacity:1, ease:Power0.easeNone},textAppearTime)
			// }


			_gsap.TweenMax.set(this.$refs.bgImg, { opacity: 0 });

			this.tl.add(function () {

				if (_this2.scroller.scroll.direction === 1 || _this2.isResized == false) {
					_gsap.TweenMax.set(_this2.$refs.bgImg, { opacity: 1 });
				} else {
					_gsap.TweenMax.set(_this2.$refs.bgImg, { opacity: 0 });
				}
				_this2.isResized = true;
			}, appearTime);

			this.tl.fromTo(this.$bg, 1, { y: -window.innerHeight }, { y: this.bounds.height + window.innerHeight, ease: Power0.easeNone }, 0);
			this.tl.fromTo(this.$bgLayer, .2, { opacity: 0 }, { opacity: .7, ease: Power0.easeNone }, 0);
		}
	}, {
		key: 'raf',
		value: function raf(y) {
			(0, _get3.default)(LandOfFree.prototype.__proto__ || (0, _getPrototypeOf2.default)(LandOfFree.prototype), 'raf', this).call(this, y);

			// console.log(this.perc)
		}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(LandOfFree.prototype.__proto__ || (0, _getPrototypeOf2.default)(LandOfFree.prototype), '_resize', this).call(this);

			this.boundsAnim = {
				top: this.bounds.top - window.innerHeight,
				bottom: this.bounds.top + this.bounds.height + window.innerHeight
			};

			this.initTimeline();
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(LandOfFree.prototype.__proto__ || (0, _getPrototypeOf2.default)(LandOfFree.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(LandOfFree.prototype.__proto__ || (0, _getPrototypeOf2.default)(LandOfFree.prototype), '_off', this).call(this);
		}
	}]);
	return LandOfFree;
}(_scrollable2.default)) || _class);
exports.default = LandOfFree;

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"land-of-free"},[_c('div',{ref:"bg",staticClass:"background-image"},[_c('div',{staticClass:"layer"}),_c('img',{ref:"bgImg",attrs:{"src":"assets/images/land-of-free.jpg"}})]),_c('div',{staticClass:"interview-wrapper"},[_c('h2',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.translate('land_of_free.title'))}}),_c('div',{staticClass:"about-birthday"},[_c('p',{ref:"text0",staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.translate('land_of_free.text_1'))}})]),_c('div',{staticClass:"about-clip"},[_c('blockquote',{ref:"text1",domProps:{"innerHTML":_vm._s(_vm.translate('land_of_free.quote_1'))}}),_c('p',{ref:"text2",staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.translate('land_of_free.text_2'))}})]),_c('div',{staticClass:"about-president"},[_c('blockquote',{ref:"text3",domProps:{"innerHTML":_vm._s(_vm.translate('land_of_free.quote_2'))}}),_c('p',{ref:"text4",staticClass:"translation",domProps:{"innerHTML":_vm._s(_vm.translate('land_of_free.translate_2'))}})]),_c('div',{staticClass:"about-storyboard"},[_c('p',{ref:"text5",staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.translate('land_of_free.text_3'))}})])]),_c('background')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_racism_vue__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_racism_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_racism_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d66ed18_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_racism_vue__ = __webpack_require__(596);
function injectStyle (ssrContext) {
  __webpack_require__(573)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_racism_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d66ed18_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_racism_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(574);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("4f6b5fa2", content, true, {});

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".racism{width:100%;min-height:100vh;background:rgba(15,13,55,0);position:relative;padding-bottom:40vh}.racism,.racism .bills-overlay{z-index:50}.racism .background{z-index:30}.racism .background-image{position:absolute;top:0;left:0;height:100vh;width:100%;z-index:20;will-change:transform;overflow:hidden}.racism .background-image .layer{position:absolute;top:0;left:0;bottom:0;right:0;background-color:#05006c;opacity:.7;z-index:40;opacity:0}.racism .background-image .canvas-flag{z-index:30;width:100%;height:100vh;position:relative;top:0;left:0}.racism .background-image .canvas-flag canvas{width:100%;height:100%}.racism .background-image .image-2{z-index:20;opacity:0}.racism .background-image img{width:100%;position:absolute;top:0;left:0;height:100%;object-fit:cover}.racism .section-title{max-width:820px;margin:auto}@media screen and (min-width:1700px){.racism .section-title{max-width:1200px}}.racism .section-title h2{font-size:5em}@media screen and (max-width:640px){.racism .section-title h2{font-size:3.75em}}.racism .about-victims{display:flex;align-items:flex-end;max-width:800px;margin:auto}@media screen and (max-width:640px){.racism .about-victims{flex-direction:column-reverse;align-items:center}.racism .about-victims .victim-list img{max-width:100%}}.racism .about-victims .story-text{margin-bottom:5vw;text-align:right;padding:0 5%}@media screen and (max-width:640px){.racism .about-victims .story-text{text-align:center;margin-top:20px;margin-bottom:0}}.racism .story-wrapper{position:relative;z-index:50;padding-top:20vh;text-align:center}.racism .story-wrapper .text{max-width:700px;margin:auto}@media screen and (min-width:1700px){.racism .story-wrapper .text{max-width:700px}}.racism .story-wrapper .text-1{margin-top:50px}@media screen and (max-width:640px){.racism .story-wrapper .text-1{margin-top:30px}}.racism .story-wrapper .text-2{margin-top:40px}@media screen and (max-width:640px){.racism .story-wrapper .text-2{margin-top:30px}}.racism .story-wrapper .about-victims{margin-top:50px}@media screen and (max-width:640px){.racism .story-wrapper .about-victims{margin-top:30px}}.racism .story-wrapper .large-quote{max-width:800px;margin:auto;margin-top:50px}@media screen and (min-width:1700px){.racism .story-wrapper .large-quote{max-width:1200px}}@media screen and (max-width:640px){.racism .story-wrapper .large-quote{margin-top:30px}}.racism .story-wrapper .large-quote blockquote{line-height:2em;font-size:1.25em}.racism .story-wrapper .text-3{margin-top:100px}@media screen and (max-width:640px){.racism .story-wrapper .text-3{margin-top:30px}}.racism .story-wrapper .text-4{margin-top:60px}.racism .story-wrapper .video-block{width:50%;padding:0 5%;text-align:left;margin-top:50px}.racism .story-wrapper .quote-list{max-width:820px;margin:auto;margin-top:60px}@media screen and (min-width:1700px){.racism .story-wrapper .quote-list{max-width:1000px}}.racism .story-wrapper .quote-list .quote{margin-top:32px}", ""]);

// exports


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _background = __webpack_require__(30);

var _background2 = _interopRequireDefault(_background);

var _sectionTitle = __webpack_require__(576);

var _sectionTitle2 = _interopRequireDefault(_sectionTitle);

var _quote = __webpack_require__(99);

var _quote2 = _interopRequireDefault(_quote);

var _storyText = __webpack_require__(182);

var _storyText2 = _interopRequireDefault(_storyText);

var _billsOverlay = __webpack_require__(585);

var _billsOverlay2 = _interopRequireDefault(_billsOverlay);

var _videoElement = __webpack_require__(183);

var _videoElement2 = _interopRequireDefault(_videoElement);

var _Globals = __webpack_require__(16);

var _Globals2 = _interopRequireDefault(_Globals);

var _racismJoey = __webpack_require__(594);

var _racismJoey2 = _interopRequireDefault(_racismJoey);

var _dispColumn = __webpack_require__(595);

var _dispColumn2 = _interopRequireDefault(_dispColumn);

var _coverBackground = __webpack_require__(180);

var _coverBackground2 = _interopRequireDefault(_coverBackground);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Racism = (_dec = (0, _vueClassComponent2.default)({
	name: 'Racism',
	components: { Background: _background2.default, SectionTitle: _sectionTitle2.default, StoryText: _storyText2.default, Quote: _quote2.default, BillsOverlay: _billsOverlay2.default, VideoElement: _videoElement2.default }
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(Racism, _Scrollable);

	function Racism() {
		var _ref;

		var _temp, _this, _ret;

		(0, _classCallCheck3.default)(this, Racism);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Racism.__proto__ || (0, _getPrototypeOf2.default)(Racism)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'redimensionate', {
			enumerable: true,
			writable: true,
			value: function value(element) {
				var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

				if (!element) return;

				var sizes = size ? size : { w: window.innerWidth, h: window.innerHeight };
				var dimension = _coverBackground2.default.Cover(element.width, element.height, sizes.w, sizes.h);

				element.width = dimension.w;
				element.height = dimension.h;
				element.position.x = dimension.pos.x;
				element.position.y = dimension.pos.y;
			}
		}), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	}

	(0, _createClass3.default)(Racism, [{
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(Racism.prototype.__proto__ || (0, _getPrototypeOf2.default)(Racism.prototype), 'mounted', this).call(this);

			this._dom();
		}
	}, {
		key: 'beforeDestroy',
		value: function beforeDestroy() {
			(0, _get3.default)(Racism.prototype.__proto__ || (0, _getPrototypeOf2.default)(Racism.prototype), 'beforeDestroy', this).call(this);
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(Racism.prototype.__proto__ || (0, _getPrototypeOf2.default)(Racism.prototype), 'init', this).call(this);

			this.isResized = false;

			this.app = new PIXI.Application(_Globals2.default.width, _Globals2.default.height, {
				antialiasing: true,
				transparent: true
			});

			this.app.renderer.autoResize = true;

			this.$refs.canvasFlag.appendChild(this.app.view);

			this.initBg();
		}
	}, {
		key: 'initBg',
		value: function initBg() {

			var loader = new PIXI.loaders.Loader();
			loader.add('bg-image', _racismJoey2.default).load(this.loaded);
		}
	}, {
		key: 'loaded',
		value: function loaded(loader, resources) {

			this.sprite = new PIXI.Sprite.fromImage(_racismJoey2.default);
			this.sprite.alpha = 0;
			this.redimensionate(this.sprite);

			this.stage = new PIXI.Container();
			this.stage.addChild(this.sprite);

			this.displacementSprite = PIXI.Sprite.fromImage(_dispColumn2.default);
			this.displacementFilter = new PIXI.filters.DisplacementFilter(this.displacementSprite);

			this.stage.filters = [this.displacementFilter];
			this.stage.addChild(this.displacementSprite);

			this.displacementFilter.scale.x = 30;

			this.app.stage.addChild(this.stage);
			this.displacementFilter.filterArea = this.app.screen;
			this.displacementFilter.padding = 0;
			this.initTimeline();
		}
	}, {
		key: 'animate',
		value: function animate() {}
	}, {
		key: 'raf',
		value: function raf(y) {
			(0, _get3.default)(Racism.prototype.__proto__ || (0, _getPrototypeOf2.default)(Racism.prototype), 'raf', this).call(this, y);
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(Racism.prototype.__proto__ || (0, _getPrototypeOf2.default)(Racism.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_dom',
		value: function _dom() {
			this.$bg = this.$el.querySelector('.background-image');
			this.$bgLayer = this.$bg.querySelector('.layer');
			this.$bgImg1 = this.$bg.querySelector('.image-2');
			this.$billsOverlay = this.$el.querySelector('.bills-overlay');
		}
	}, {
		key: 'initTimeline',
		value: function initTimeline() {
			var _this2 = this;

			(0, _get3.default)(Racism.prototype.__proto__ || (0, _getPrototypeOf2.default)(Racism.prototype), 'initTimeline', this).call(this);

			if (!this.sprite) return;

			this.flagTimeline = new TimelineMax({ paused: true });
			this.flagTimeline.fromTo(this.displacementSprite.position, 2.5, { x: -1440 / 2 }, { x: 1440, ease: Power2.easeInOut }, 0);
			this.flagTimeline.fromTo(this.sprite, .4, { alpha: 0 }, { alpha: 1, ease: Power0.easeNone }, 0);
			this.flagTimeline.fromTo(this.$refs.layer, .4, { opacity: 0 }, { opacity: .6, ease: Power0.easeNone }, 0);

			var hw_ratio = (window.innerHeight + window.innerHeight * .5) / (this.bounds.height + window.innerHeight);
			var h = window.innerHeight;

			this.tl.add(function () {

				if (_this2.flagTimeline) {
					var p = _this2.flagTimeline.progress();
					if (_this2.scroller.scroll.direction === 1 || _this2.isResized == false) {
						_this2.flagTimeline.play(0).timeScale(1);
					} else {
						_gsap.TweenMax.to(_this2.sprite, .4, { alpha: 0, ease: Power0.easeNone });
						_gsap.TweenMax.to(_this2.$refs.layer, .4, { opacity: 0, ease: Power0.easeNone });
						// this.flagTimeline.progress = 0
					}
				}

				_this2.isResized = true;
			}, h * .8 / (this.bounds.height + window.innerHeight));

			this.tl.fromTo(this.$bg, 1 - h / (this.bounds.height + window.innerHeight), { y: -window.innerHeight }, { y: this.bounds.height - h, ease: Power0.easeNone }, 0);
			this.tl.fromTo(this.$refs.canvasFlag, .1, { alpha: 1 }, { alpha: 0 }, 1 - h * 2 / (this.bounds.height + window.innerHeight));
			this.tl.fromTo(this.$bgImg1, .1, { opacity: 0 }, { opacity: 1 }, 1 - h * 2 / (this.bounds.height + window.innerHeight));

			this.tl.fromTo(this.$refs.video.$el, this.$refs.videoWrapper.getBoundingClientRect().width * .5 / (this.bounds.height + window.innerHeight), { x: window.innerWidth / 2 - this.$refs.videoWrapper.getBoundingClientRect().width / 2 - this.$refs.videoWrapper.getBoundingClientRect().left }, { x: 0 }, 1 - h * 1.7 / (this.bounds.height + window.innerHeight));

			this.tl.fromTo(this.$billsOverlay, 1, { y: -window.innerHeight }, { y: this.bounds.height, ease: Power0.easeNone }, 0);

			this.tl.fromTo([this.$refs.girlImg, this.$bgLayer], h / (this.bounds.height + window.innerHeight), { y: 0 }, { y: 500, ease: Power0.easeNone }, 1 - h / (this.bounds.height + window.innerHeight));

			this.scroller.interval('racism.bills.play', {
				start: this.bounds.top + this.bounds.height - window.innerHeight * 1.3,
				end: this.bounds.top + this.bounds.height + window.innerHeight * .5,
				exec: function exec(e) {
					if (!e.isInside) return;
					_this2.$refs.bills.play(e.ratio);
				}
			});
		}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(Racism.prototype.__proto__ || (0, _getPrototypeOf2.default)(Racism.prototype), '_resize', this).call(this);

			this.isResized = false;

			this.boundsAnim = {
				top: this.bounds.top - window.innerHeight,
				bottom: this.bounds.top + this.bounds.height
			};

			this.sprite && this.redimensionate(this.sprite);
			if (this.app) {
				this.app.renderer.view.style.width = window.innerWidth + 'px';
				this.app.renderer.view.style.height = window.innerHeight + 'px';
				this.app.renderer.resize(window.innerWidth, window.innerHeight);
			}

			this.initTimeline();
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(Racism.prototype.__proto__ || (0, _getPrototypeOf2.default)(Racism.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(Racism.prototype.__proto__ || (0, _getPrototypeOf2.default)(Racism.prototype), '_off', this).call(this);
		}
	}]);
	return Racism;
}(_scrollable2.default)) || _class);
exports.default = Racism;

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_title_vue__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_title_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_title_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e5d6cea_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_section_title_vue__ = __webpack_require__(580);
function injectStyle (ssrContext) {
  __webpack_require__(577)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_title_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e5d6cea_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_section_title_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(578);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("112789bb", content, true, {});

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".section-title{width:100%}.section-title h2{color:#fff;font-size:100px;line-height:1em;font-weight:700;font-family:Poppins,sans-serif}", ""]);

// exports


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SectionTitle = (_dec = (0, _vueClassComponent2.default)({
	name: 'SectionTitle',
	components: {}
}), _dec(_class = function (_Vue) {
	(0, _inherits3.default)(SectionTitle, _Vue);

	function SectionTitle() {
		(0, _classCallCheck3.default)(this, SectionTitle);
		return (0, _possibleConstructorReturn3.default)(this, (SectionTitle.__proto__ || (0, _getPrototypeOf2.default)(SectionTitle)).apply(this, arguments));
	}

	return SectionTitle;
}(_vue2.default)) || _class);
exports.default = SectionTitle;

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-title"},[_vm._t("title-content")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(582);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("7963e026", content, true, {});

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".story-text{width:100%}.story-text .text{color:#fff;font-size:1.125em;line-height:1.5em;font-family:Abhaya Libre,serif}.story-text .text span.underlined{text-decoration:underline;font-family:$FONT_PRIMALY}.story-text .text span.bold{font-size:18px;font-family:Poppins,sans-serif}", ""]);

// exports


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StoryText = (_dec = (0, _vueClassComponent2.default)({
	name: 'StoryText',
	components: {}
}), _dec(_class = function (_Vue) {
	(0, _inherits3.default)(StoryText, _Vue);

	function StoryText() {
		(0, _classCallCheck3.default)(this, StoryText);
		return (0, _possibleConstructorReturn3.default)(this, (StoryText.__proto__ || (0, _getPrototypeOf2.default)(StoryText)).apply(this, arguments));
	}

	return StoryText;
}(_vue2.default)) || _class);
exports.default = StoryText;

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"story-text"},[_vm._t("text-content")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bills_overlay_vue__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bills_overlay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bills_overlay_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18f914b6_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_bills_overlay_vue__ = __webpack_require__(589);
function injectStyle (ssrContext) {
  __webpack_require__(586)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bills_overlay_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18f914b6_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_bills_overlay_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(587);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("0409b06f", content, true, {});

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".bills-overlay{width:100%;position:absolute;top:0;left:0;height:100vh;width:100vw;overflow:hidden;pointer-events:none}.bills-overlay .bill{position:absolute;bottom:0;width:400px}", ""]);

// exports


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _Globals = __webpack_require__(16);

var _Globals2 = _interopRequireDefault(_Globals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BillsOverlay = (_dec = (0, _vueClassComponent2.default)({
	name: 'BillsOverlay',
	components: {},
	data: function data() {
		return {
			amount: 60
		};
	}
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(BillsOverlay, _Scrollable);

	function BillsOverlay() {
		(0, _classCallCheck3.default)(this, BillsOverlay);
		return (0, _possibleConstructorReturn3.default)(this, (BillsOverlay.__proto__ || (0, _getPrototypeOf2.default)(BillsOverlay)).apply(this, arguments));
	}

	(0, _createClass3.default)(BillsOverlay, [{
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(BillsOverlay.prototype.__proto__ || (0, _getPrototypeOf2.default)(BillsOverlay.prototype), 'mounted', this).call(this);

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(BillsOverlay.prototype.__proto__ || (0, _getPrototypeOf2.default)(BillsOverlay.prototype), 'init', this).call(this);
		}
	}, {
		key: 'beforeDestroy',
		value: function beforeDestroy() {
			(0, _get3.default)(BillsOverlay.prototype.__proto__ || (0, _getPrototypeOf2.default)(BillsOverlay.prototype), 'beforeDestroy', this).call(this);
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(BillsOverlay.prototype.__proto__ || (0, _getPrototypeOf2.default)(BillsOverlay.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_dom',
		value: function _dom() {
			this.$bills = this.$el.querySelectorAll('.bill');
		}
	}, {
		key: '_intervals',
		value: function _intervals() {

			var gap = window.innerWidth / this.amount;
			var range = _Globals2.default.responsiveWidth(350);

			this.tlScroll = new TimelineMax({ paused: true });

			for (var i = 0; i < this.amount; i++) {

				var min = gap * i - range;
				var max = gap * i + range / 2;

				var b = this.$bills[i];
				var posX = Math.random() * (max - min) + min;
				var rotZ = Math.random() * (40 + 40) - 40;
				var delay = Math.random() * .5;
				var rHeight = Math.random() * (_Globals2.default.responsiveHeight(600) + _Globals2.default.responsiveHeight(400)) - _Globals2.default.responsiveHeight(400);

				_gsap.TweenMax.set(b, { left: posX, rotationZ: rotZ, width: _Globals2.default.responsiveWidth(450), scale: 1 });

				this.tlScroll.fromTo(b, 1, { y: _Globals2.default.responsiveHeight(450) }, { y: -window.innerHeight - rHeight - _Globals2.default.responsiveHeight(600), delay: delay, ease: Power1.easeOut }, 0);
			}
		}
	}, {
		key: 'play',
		value: function play(ratio) {
			this.tlScroll.progress(ratio);
		}
	}, {
		key: 'test',
		value: function test(duration) {}
	}, {
		key: '_points',
		value: function _points() {}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(BillsOverlay.prototype.__proto__ || (0, _getPrototypeOf2.default)(BillsOverlay.prototype), '_resize', this).call(this);

			this._intervals();
			this._points();
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(BillsOverlay.prototype.__proto__ || (0, _getPrototypeOf2.default)(BillsOverlay.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(BillsOverlay.prototype.__proto__ || (0, _getPrototypeOf2.default)(BillsOverlay.prototype), '_off', this).call(this);
		}
	}]);
	return BillsOverlay;
}(_scrollable2.default)) || _class);
exports.default = BillsOverlay;

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bills-overlay"},_vm._l((_vm.amount),function(bill){return _c('img',{staticClass:"bill",attrs:{"src":"assets/images/trump-bill.png"}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(591);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("2eb5bad8", content, true, {});

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".video-element{will-change:transform;z-index:40}.video-element,.video-element .video-wrapper{position:relative;width:100%;overflow:hidden}.video-element .video-wrapper .video-visual{position:absolute;top:0;left:0;width:100%;height:100%;z-index:40;overflow:hidden}.video-element .video-wrapper .video-visual .video-overlay-background{background-color:#000;opacity:.7;position:absolute;z-index:50;top:-2px;left:-2px;bottom:-2px;right:-2px}.video-element .video-wrapper .video-visual img{width:100%;height:100%;object-fit:cover}.video-element .video-wrapper .video-content{position:absolute;top:0;left:0;height:100%;width:100%;z-index:60;display:flex;justify-content:center;align-items:center;flex-direction:column;cursor:pointer;text-decoration:none}.video-element .video-wrapper .video-content .video-play-icon{position:relative;z-index:60}.video-element .video-wrapper .video-content .video-play-icon img{display:inline-block;position:relative;z-index:50}.video-element .video-wrapper .video-content .video-title{position:relative;z-index:70;margin-top:4px}.video-element .video-wrapper .video-content .video-title .title{margin-top:6px}.video-element .video-wrapper .video-content .video-title p{color:#fff;text-align:center;font-family:Saira Extra Condensed,sans-serif;letter-spacing:.15em;font-size:.9375em;text-transform:uppercase}.video-element .video-wrapper .video-content .video-title p span{display:inline-block;transform:translateY(5px);opacity:0}.video-element .video-wrapper .video-content .video-title p.catch{font-weight:300}", ""]);

// exports


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _Globals = __webpack_require__(16);

var _Globals2 = _interopRequireDefault(_Globals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VideoElement = (_dec = (0, _vueClassComponent2.default)({
	name: 'VideoElement',
	components: {},
	props: ["width", "height", "poster", "video", "responsive", "title", "href", "onEnter", "onLeave", "item"],
	data: function data() {
		return {
			splitTitle: this.title ? this.title.split(' ') : []
		};
	}
}), _dec(_class = function (_Vue) {
	(0, _inherits3.default)(VideoElement, _Vue);

	function VideoElement() {
		(0, _classCallCheck3.default)(this, VideoElement);
		return (0, _possibleConstructorReturn3.default)(this, (VideoElement.__proto__ || (0, _getPrototypeOf2.default)(VideoElement)).apply(this, arguments));
	}

	(0, _createClass3.default)(VideoElement, [{
		key: 'mounted',
		value: function mounted() {
			this.init();
		}
	}, {
		key: 'init',
		value: function init() {

			this._dom();
			this._setPadding();
			this.resize = this._resize.bind(this);

			this.tl = new TimelineMax({ paused: true });

			this.tl.fromTo([this.$posterImg], .3, { scale: 1.1 }, { scale: 1.2 }, 0).fromTo(this.$videoVisual, .3, { scale: 1 }, { scale: .95 }, 0).staggerTo(this.$titleLetter, .4, { y: 0, opacity: 1, ease: Power3.easeInOut }, .03, 0);

			this._on();
		}
	}, {
		key: '_on',
		value: function _on() {
			this.$events.on('app.loaded', this.init);
			this.$events.on('app.resize', this._resize);
		}
	}, {
		key: '_dom',
		value: function _dom() {
			this.$wrapVideo = this.$el.querySelector('.video-wrapper');
			this.$posterImg = this.$el.querySelector('.poster');
			this.$videoVisual = this.$el.querySelector('.video-visual');
			this.$titleLetter = this.$el.querySelectorAll('.title span');
			this.$title = this.$el.querySelector('.title');
			this.$layer = this.$el.querySelector('.video-overlay-background');
		}
	}, {
		key: '_setPadding',
		value: function _setPadding() {

			var w = this.width;
			var h = this.height;

			this.$wrapVideo.style.paddingBottom = h / w * 100 + '%';

			if (!this.responsive) {
				this.$el.style.width = _Globals2.default.responsiveWidth(w) + 'px';
			}
		}
	}, {
		key: '_resize',
		value: function _resize() {
			this._setPadding();
		}
	}, {
		key: 'start',
		value: function start(e) {
			if (e.type === "mouseenter") {
				this.tl.play();
				this.onEnter && this.onEnter(this.item);
			} else if (e.type === "mouseleave") {
				this.tl.reverse();
				this.onLeave && this.onLeave(this.item);
			}
		}
	}]);
	return VideoElement;
}(_vue2.default)) || _class);
exports.default = VideoElement;

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-element"},[_c('div',{staticClass:"video-wrapper"},[_c('div',{staticClass:"video-visual"},[_c('div',{staticClass:"video-overlay-background"}),_c('img',{staticClass:"poster",attrs:{"src":_vm.poster}})]),_c('a',{staticClass:"video-content",attrs:{"href":_vm.href,"target":"blank"},on:{"mouseenter":_vm.start,"mouseleave":_vm.start}},[_vm._m(0),_c('div',{staticClass:"video-title"},[_c('p',{staticClass:"catch"},[_vm._v("Écouter")]),_c('p',{staticClass:"title"},_vm._l((_vm.splitTitle),function(word){return _c('span',[_vm._v(_vm._s(word)+" ")])}))])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-play-icon"},[_c('img',{attrs:{"src":"assets/images/play-full-icon.png"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ddc3cc593c55ddb065c162bdb8414c5c.jpg";

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8d6d039b026e4b998135aca52f7d7a93.jpg";

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"racism"},[_c('div',{staticClass:"background-image"},[_c('div',{ref:"layer",staticClass:"layer"}),_c('div',{ref:"canvasFlag",staticClass:"canvas-flag"}),_c('img',{ref:"girlImg",staticClass:"image-2",attrs:{"src":"assets/images/racism-crying-girl.jpg"}})]),_c('div',{staticClass:"story-wrapper"},[_c('section-title',[_c('h2',{attrs:{"slot":"title-content"},domProps:{"innerHTML":_vm._s(_vm.translate('racism.title'))},slot:"title-content"})]),_c('story-text',{staticClass:"text-1"},[_c('p',{staticClass:"text",attrs:{"slot":"text-content"},domProps:{"innerHTML":_vm._s(_vm.translate('racism.text_1'))},slot:"text-content"})]),_c('story-text',{staticClass:"text-2"},[_c('p',{staticClass:"text",attrs:{"slot":"text-content"},domProps:{"innerHTML":_vm._s(_vm.translate('racism.quote_1'))},slot:"text-content"})]),_c('div',{staticClass:"about-victims"},[_c('story-text',[_c('p',{staticClass:"text",attrs:{"slot":"text-content"},domProps:{"innerHTML":_vm._s(_vm.translate('racism.text_2'))},slot:"text-content"})]),_vm._m(0)],1),_c('quote',{staticClass:"large-quote"},[_c('blockquote',{attrs:{"slot":"quote"},domProps:{"innerHTML":_vm._s(_vm.translate('racism.quote_2'))},slot:"quote"})]),_c('story-text',{staticClass:"text-3"},[_c('p',{staticClass:"text",attrs:{"slot":"text-conte:t"},domProps:{"innerHTML":_vm._s(_vm.translate('racism.text_3'))},slot:"text-conte:t"})]),_c('div',{staticClass:"quote-list list-1"},_vm._l((_vm.translate('racism.quote_group_1')),function(trad){return _c('quote',{key:trad.id},[_c('blockquote',{attrs:{"slot":"quote"},slot:"quote"},[_vm._v(_vm._s(trad.sentence))]),_c('p',{staticClass:"translation",attrs:{"slot":"translation"},slot:"translation"},[_vm._v(_vm._s(trad.translation))])])})),_c('story-text',{staticClass:"text-4"},[_c('p',{staticClass:"text",attrs:{"slot":"text-content"},domProps:{"innerHTML":_vm._s(_vm.translate('racism.text_4'))},slot:"text-content"})]),_c('div',{ref:"videoWrapper",staticClass:"video-block"},[_c('video-element',{ref:"video",attrs:{"href":"https://www.youtube.com/watch?v=WDZJPJV__bQ","poster":"assets/images/temptation-thumbs.jpg","width":"577","height":"323","responsive":"responsive","title":"Formation - Beyoncé"}})],1),_c('div',{staticClass:"quote-list list-2"},_vm._l((_vm.translate('racism.quote_group_2')),function(trad,i){return _c('quote',{key:trad.id},[_c('blockquote',{attrs:{"slot":"quote"},slot:"quote"},[_vm._v(_vm._s(trad.sentence))]),_c('p',{staticClass:"translation",attrs:{"slot":"translation"},slot:"translation"},[_vm._v(_vm._s(trad.translation))])])}))],1),_c('bills-overlay',{ref:"bills"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"victim-list"},[_c('div',{staticClass:"wrap-image"},[_c('img',{attrs:{"src":"assets/images/racism-list-victims.jpg"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_engagement_vue__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_engagement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_engagement_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43d5ebd0_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_engagement_vue__ = __webpack_require__(611);
function injectStyle (ssrContext) {
  __webpack_require__(598)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_engagement_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43d5ebd0_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_engagement_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(599);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("735f3e5e", content, true, {});

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".engagement{width:100%;background:#05006c;position:relative}.engagement .engagement-section{position:relative;z-index:30}.engagement .flags-overlay{position:absolute;top:0;left:0;z-index:50}", ""]);

// exports


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _engagementIntro = __webpack_require__(601);

var _engagementIntro2 = _interopRequireDefault(_engagementIntro);

var _engagementSlider = __webpack_require__(606);

var _engagementSlider2 = _interopRequireDefault(_engagementSlider);

var _background = __webpack_require__(30);

var _background2 = _interopRequireDefault(_background);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _flagsOverlay = __webpack_require__(68);

var _flagsOverlay2 = _interopRequireDefault(_flagsOverlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Political = (_dec = (0, _vueClassComponent2.default)({
	name: 'Political',
	components: { FlagsOverlay: _flagsOverlay2.default, Background: _background2.default, EngagementIntro: _engagementIntro2.default, EngagementSlider: _engagementSlider2.default },
	data: function data() {
		return {
			introDistance: 0
		};
	}
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(Political, _Scrollable);

	function Political() {
		(0, _classCallCheck3.default)(this, Political);
		return (0, _possibleConstructorReturn3.default)(this, (Political.__proto__ || (0, _getPrototypeOf2.default)(Political)).apply(this, arguments));
	}

	(0, _createClass3.default)(Political, [{
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(Political.prototype.__proto__ || (0, _getPrototypeOf2.default)(Political.prototype), 'mounted', this).call(this);

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(Political.prototype.__proto__ || (0, _getPrototypeOf2.default)(Political.prototype), 'init', this).call(this);
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(Political.prototype.__proto__ || (0, _getPrototypeOf2.default)(Political.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_dom',
		value: function _dom() {
			this.$flagsOverlay = this.$el.querySelector('.flags-overlay');
		}
	}, {
		key: 'initIntervals',
		value: function initIntervals() {}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(Political.prototype.__proto__ || (0, _getPrototypeOf2.default)(Political.prototype), '_resize', this).call(this);

			this.introDistance = this.bounds.height;

			this.initIntervals();
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(Political.prototype.__proto__ || (0, _getPrototypeOf2.default)(Political.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(Political.prototype.__proto__ || (0, _getPrototypeOf2.default)(Political.prototype), '_off', this).call(this);
		}
	}]);
	return Political;
}(_scrollable2.default)) || _class);
exports.default = Political;

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_engagement_intro_vue__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_engagement_intro_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_engagement_intro_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77aed091_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_engagement_intro_vue__ = __webpack_require__(605);
function injectStyle (ssrContext) {
  __webpack_require__(602)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_engagement_intro_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77aed091_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_engagement_intro_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(603);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("10b00c8c", content, true, {});

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".engagement-intro{width:100%;position:relative}.engagement-intro .section-intro .title{max-width:1000px;margin:auto}.engagement-intro .story-wrapper{position:relative;z-index:50;text-align:center;margin-top:100px}.engagement-intro .story-wrapper .story-text{margin:auto;max-width:580px}.engagement-intro .story-wrapper .quote{margin:auto;max-width:830px}.engagement-intro .story-wrapper .quote-1,.engagement-intro .story-wrapper .quote-2,.engagement-intro .story-wrapper .text-3{margin-top:50px}", ""]);

// exports


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _sectionIntro = __webpack_require__(57);

var _sectionIntro2 = _interopRequireDefault(_sectionIntro);

var _splitedText = __webpack_require__(42);

var _splitedText2 = _interopRequireDefault(_splitedText);

var _quote = __webpack_require__(99);

var _quote2 = _interopRequireDefault(_quote);

var _storyText = __webpack_require__(182);

var _storyText2 = _interopRequireDefault(_storyText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PoliticalIntro = (_dec = (0, _vueClassComponent2.default)({
	name: 'PoliticalIntro',
	components: { SectionIntro: _sectionIntro2.default, SplitedText: _splitedText2.default, StoryText: _storyText2.default, Quote: _quote2.default }
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(PoliticalIntro, _Scrollable);

	function PoliticalIntro() {
		(0, _classCallCheck3.default)(this, PoliticalIntro);
		return (0, _possibleConstructorReturn3.default)(this, (PoliticalIntro.__proto__ || (0, _getPrototypeOf2.default)(PoliticalIntro)).apply(this, arguments));
	}

	(0, _createClass3.default)(PoliticalIntro, [{
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(PoliticalIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalIntro.prototype), 'mounted', this).call(this);

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(PoliticalIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalIntro.prototype), 'init', this).call(this);
		}
	}, {
		key: '_dom',
		value: function _dom() {

			this.$text = this.$el.querySelector('.text');
			this.$fakeText = this.$el.querySelector('.fake-text');
		}
	}, {
		key: '_intervals',
		value: function _intervals() {

			this.scroller.point('text.in', {
				position: this.bounds.top + window.innerHeight * .3,
				direction: 1,
				exec: function exec(e) {
					if (e.direction == 1) {
						// this.$refs.splitedText.tlAppear.play(0)
					} else {
							// this.$refs.splitedText.tlAppear.reverse(0)
						}
				}
			});
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(PoliticalIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalIntro.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(PoliticalIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalIntro.prototype), '_resize', this).call(this);

			this._intervals();
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(PoliticalIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalIntro.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(PoliticalIntro.prototype.__proto__ || (0, _getPrototypeOf2.default)(PoliticalIntro.prototype), '_off', this).call(this);
		}
	}]);
	return PoliticalIntro;
}(_scrollable2.default)) || _class);
exports.default = PoliticalIntro;

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"engagement-intro"},[_c('section-intro',{attrs:{"img":"assets/images/joey-concert.jpg","title":_vm.translate('engagement.title'),"fade":"0"}}),_c('div',{staticClass:"story-wrapper"},[_c('story-text',{staticClass:"text-1"},[_c('p',{staticClass:"text",attrs:{"slot":"text-content"},domProps:{"innerHTML":_vm._s(_vm.translate('engagement.text_1'))},slot:"text-content"})]),_c('story-text',{staticClass:"text-2"},[_c('p',{staticClass:"text",attrs:{"slot":"text-content"},domProps:{"innerHTML":_vm._s(_vm.translate('engagement.text_2'))},slot:"text-content"})]),_c('quote',{staticClass:"quote-1"},[_c('blockquote',{attrs:{"slot":"quote"},domProps:{"innerHTML":_vm._s(_vm.translate('engagement.quote_1'))},slot:"quote"}),_c('p',{staticClass:"translation",attrs:{"slot":"translation"},domProps:{"innerHTML":_vm._s(_vm.translate('engagement.translation_1'))},slot:"translation"})]),_c('quote',{staticClass:"quote-2"},[_c('blockquote',{attrs:{"slot":"quote"},domProps:{"innerHTML":_vm._s(_vm.translate('engagement.quote_2'))},slot:"quote"})]),_c('story-text',{staticClass:"text-3"},[_c('p',{staticClass:"text",attrs:{"slot":"text-content"},domProps:{"innerHTML":_vm._s(_vm.translate('engagement.sentence'))},slot:"text-content"})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_engagement_slider_vue__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_engagement_slider_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_engagement_slider_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77c9b70c_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_engagement_slider_vue__ = __webpack_require__(610);
function injectStyle (ssrContext) {
  __webpack_require__(607)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_engagement_slider_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77c9b70c_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_engagement_slider_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(608);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("0584a9d2", content, true, {});

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".engagement-slider{width:100%;height:100vh;position:relative}.engagement-slider .movable{height:100vh;width:100%;position:absolute;top:0;left:0;will-change:transform}.engagement-slider .movable .left-layer{width:45vw;height:100vh;position:absolute;top:0;left:0;z-index:80;overflow:hidden;opacity:0;visibility:hidden}.engagement-slider .movable .left-layer .layer{height:100%;width:100%;position:absolute;top:0;left:0;background-color:#fff;z-index:30;transform:translateX(-100%)}.engagement-slider .movable .left-layer .layer-content{position:relative;z-index:40;display:flex;flex-direction:column;justify-content:center;align-items:center;height:100%}.engagement-slider .movable .left-layer .layer-content .fact{max-width:390px;display:flex;align-items:center;margin-bottom:16px}.engagement-slider .movable .left-layer .layer-content .fact .fact-thumb{height:150px;min-width:150px;transform:translateY(40px);opacity:0}.engagement-slider .movable .left-layer .layer-content .fact .fact-thumb img{width:100%;height:100%;object-fit:cover}.engagement-slider .movable .left-layer .layer-content .fact .fact-text{padding-left:16px;transform:translateY(40px);opacity:0}.engagement-slider .movable .left-layer .layer-content .fact .fact-text .text{font-size:.9375em;line-height:1.6em;color:#05006c;font-family:Abhaya Libre,serif}.engagement-slider .movable .left-layer .layer-content .fact .fact-text .text a{color:currentColor}.engagement-slider .movable .left-layer .layer-content .fact-title{color:#05006c;font-size:1.5em;font-family:Saira Extra Condensed,sans-serif;letter-spacing:.15em;font-weight:700;max-width:200px;text-align:center;margin-bottom:32px;transform:translateY(40px);opacity:0}.engagement-slider .movable .left-layer .layer-content .fact-title a,.engagement-slider .movable .left-layer .layer-content .fact-title span{font-weight:300}.engagement-slider .movable .slider-container{width:100%;height:100%;display:flex;align-items:center;position:relative;overflow:hidden}.engagement-slider .movable .slider-container .slider{width:999999px;display:flex}.engagement-slider .movable .slider-container .slider .slider-movable{display:flex;align-items:center;padding-left:210px;padding-right:10vh;height:100vh;will-change:transform}.engagement-slider .movable .slider-container .slider-column{position:relative;margin-left:20px;display:flex;flex-direction:column;justify-content:space-between}.engagement-slider .movable .slider-container .slider-column .text{margin-top:30px}.engagement-slider .movable .slider-container .slider-column .text.text-1{max-width:380px;text-align:center;margin-left:auto;margin-right:auto}.engagement-slider .movable .slider-container .slider-column .text.text-2{max-width:100%;text-align:left}.engagement-slider .movable .slider-container .slider-column .text p{font-size:.9375em;color:#fff;line-height:1.6em;font-family:Abhaya Libre,serif}", ""]);

// exports


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scroller = __webpack_require__(18);

var _scroller2 = _interopRequireDefault(_scroller);

var _ticker = __webpack_require__(19);

var _ticker2 = _interopRequireDefault(_ticker);

var _pixi = __webpack_require__(25);

var PIXI = _interopRequireWildcard(_pixi);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _videoElement = __webpack_require__(183);

var _videoElement2 = _interopRequireDefault(_videoElement);

var _Globals = __webpack_require__(16);

var _Globals2 = _interopRequireDefault(_Globals);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EngagementSlider = (_dec = (0, _vueClassComponent2.default)({
	name: 'EngagementSlider',
	components: { VideoElement: _videoElement2.default }
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(EngagementSlider, _Scrollable);

	function EngagementSlider() {
		(0, _classCallCheck3.default)(this, EngagementSlider);
		return (0, _possibleConstructorReturn3.default)(this, (EngagementSlider.__proto__ || (0, _getPrototypeOf2.default)(EngagementSlider)).apply(this, arguments));
	}

	(0, _createClass3.default)(EngagementSlider, [{
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(EngagementSlider.prototype.__proto__ || (0, _getPrototypeOf2.default)(EngagementSlider.prototype), 'mounted', this).call(this);

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(EngagementSlider.prototype.__proto__ || (0, _getPrototypeOf2.default)(EngagementSlider.prototype), 'init', this).call(this);

			this.isResized = false;
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(EngagementSlider.prototype.__proto__ || (0, _getPrototypeOf2.default)(EngagementSlider.prototype), '_bind', this).call(this);

			// this.fadeElements = this.fadeElements.bind(this)
			// this.resetElement = this.resetElement.bind(this)
		}
	}, {
		key: '_dom',
		value: function _dom() {

			this.$slider = this.$el.querySelector('.slider-movable');
			this.$movable = this.$el.querySelector('.movable');

			this.$leftLayer = this.$el.querySelector('.left-layer');
			this.$layer = this.$el.querySelector('.left-layer .layer');
			this.$layerTitle = this.$el.querySelectorAll('.fact-title');
			this.$layerThumbs = this.$el.querySelectorAll('.fact .fact-thumb');
			this.$layerTexts = this.$el.querySelectorAll('.fact .fact-text');

			this.$movableColumn = this.$el.querySelectorAll('.slider-column:not(.movable-column)');
		}
	}, {
		key: 'raf',
		value: function raf(y) {
			(0, _get3.default)(EngagementSlider.prototype.__proto__ || (0, _getPrototypeOf2.default)(EngagementSlider.prototype), 'raf', this).call(this, y);
		}
	}, {
		key: 'fadeElements',
		value: function fadeElements(index) {
			var count = 11;

			for (var i = 0; i < count; i++) {
				if (i === index) {
					continue;
				}
				_gsap.TweenMax.to(this.$refs['video' + i].$el, .3, { opacity: .2, ease: Power3.easeInOut });
			}
		}
	}, {
		key: 'resetElement',
		value: function resetElement() {
			var count = 11;

			for (var i = 0; i < count; i++) {
				_gsap.TweenMax.to(this.$refs['video' + i].$el, .3, { opacity: 1, ease: Power3.easeInOut });
			}
		}
	}, {
		key: 'initTimeline',
		value: function initTimeline() {
			var _this2 = this;

			(0, _get3.default)(EngagementSlider.prototype.__proto__ || (0, _getPrototypeOf2.default)(EngagementSlider.prototype), 'initTimeline', this).call(this);

			this.tlAppear.set(this.$leftLayer, { autoAlpha: 1 });
			this.tlAppear.fromTo(this.$layer, .8, { x: '-100%' }, { x: '0%', ease: Power3.easeOut }, 0);
			this.tlAppear.fromTo(this.$layerTitle, .8, { y: 40, opacity: 0 }, { y: 0, opacity: 1, ease: Power3.easeOut }, 0);
			this.tlAppear.staggerFromTo(this.$layerThumbs, .8, { y: 40, opacity: 0 }, { y: 0, opacity: 1, ease: Power3.easeOut }, .1, .1);
			this.tlAppear.staggerFromTo(this.$layerTexts, .8, { y: 40, opacity: 0 }, { y: 0, opacity: 1, ease: Power3.easeOut }, .1, .2);

			// window.height ratio on total height
			var h_ratio = _Globals2.default.height / this.bounds.height;
			var appearTime = this.offset / this.bounds.height;

			var videoPos = [{
				x: 0,
				y: 0,
				xgap: 100
			}, {
				x: 10,
				y: -.3,
				xgap: 80
			}, {
				x: 200,
				y: .5,
				xgap: 300
			}, {
				x: -50,
				y: -.2,
				xgap: -200
			}, {
				x: 300,
				y: -.5,
				xgap: 130
			}, {
				x: -80,
				y: .6,
				xgap: 0
			}, {
				x: 0,
				y: 1,
				xgap: 20
			}, {
				x: -60,
				y: .3,
				xgap: -100
			}, {
				x: 100,
				y: -.5,
				xgap: 100
			}, {
				x: -90,
				y: .3,
				xgap: -90
			}];

			var w_h = window.innerHeight;

			this.tl.fromTo(this.$movable, 1, { y: 0 }, { y: this.offset + _Globals2.default.height, ease: Power0.easeNone }, 0);
			this.tl.fromTo(this.$slider, 1 - h_ratio, { x: 0 }, { x: -this.offset, ease: Power0.easeNone }, 0);
			this.tl.fromTo(this.$movableColumn, h_ratio, { y: 0 }, { y: -w_h * .3, ease: Power0.easeNone }, 1 - h_ratio);
			this.tl.add(function () {

				var p = _this2.tlAppear.progress();

				if (_this2.scroller.direction === 1 || _this2.isResized == false) {
					_this2.tlAppear.play(p);
				} else {
					_this2.tlAppear.reverse(p);
				}

				_this2.isResized = true;
			}, 1 - h_ratio);

			for (var i = 0; i < videoPos.length; i++) {

				var v = this.$refs['video' + i].$el;
				var vImg = [this.$refs['video' + i].$posterImg, this.$refs['video' + i].$layer];
				var p = videoPos[i];
				var h = v.getBoundingClientRect().height;

				this.tl.fromTo(v, 1 - h_ratio, { x: _Globals2.default.responsiveWidth(p.x), y: (window.innerHeight / 2 - _Globals2.default.responsiveHeight(h)) * p.y }, { x: _Globals2.default.responsiveWidth(p.x - p.xgap), ease: Power0.easeNone }, 0);
			}
		}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(EngagementSlider.prototype.__proto__ || (0, _getPrototypeOf2.default)(EngagementSlider.prototype), '_resize', this).call(this);

			this.isResized = false;

			this.sliderWidth = this.$slider.getBoundingClientRect().width;
			this.offset = this.sliderWidth - window.innerWidth;
			this.bounds.height = window.innerHeight * 2 + this.offset;
			this.$el.style.height = this.bounds.height + "px";

			this.boundsAnim = {
				top: this.bounds.top,
				bottom: this.bounds.top + this.offset + window.innerHeight
			};

			this.initTimeline();
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(EngagementSlider.prototype.__proto__ || (0, _getPrototypeOf2.default)(EngagementSlider.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(EngagementSlider.prototype.__proto__ || (0, _getPrototypeOf2.default)(EngagementSlider.prototype), '_off', this).call(this);
		}
	}]);
	return EngagementSlider;
}(_scrollable2.default)) || _class);
exports.default = EngagementSlider;

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"engagement-slider"},[_c('div',{staticClass:"movable"},[_c('div',{staticClass:"left-layer"},[_c('div',{staticClass:"layer"}),_c('div',{staticClass:"layer-content"},[_vm._m(0),_c('div',{staticClass:"fact"},[_vm._m(1),_c('div',{staticClass:"fact-text"},[_c('p',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.translate('engagement.text_left_1'))}})])]),_c('div',{staticClass:"fact"},[_vm._m(2),_c('div',{staticClass:"fact-text"},[_c('p',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.translate('engagement.text_left_2'))}})])]),_c('div',{staticClass:"fact"},[_vm._m(3),_c('div',{staticClass:"fact-text"},[_c('p',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.translate('engagement.text_left_3'))}})])])])]),_c('div',{staticClass:"slider-container"},[_c('div',{staticClass:"slider"},[_c('div',{staticClass:"slider-movable"},[_c('div',{staticClass:"slider-column"},[_c('video-element',{ref:"video0",attrs:{"href":"https://www.youtube.com/watch?v=kg00mbfXsEI","onEnter":_vm.fadeElements,"onLeave":_vm.resetElement,"item":0,"poster":"assets/images/engagment-video-1.jpg","width":"577","height":"323","title":"We will not - T.I."}}),_c('div',{staticClass:"text text-1"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.translate('engagement.text_3'))}})])],1),_c('div',{staticClass:"slider-column"},[_c('video-element',{ref:"video1",attrs:{"href":"https://www.youtube.com/watch?v=WDZJPJV__bQ","onEnter":_vm.fadeElements,"item":1,"onLeave":_vm.resetElement,"poster":"assets/images/engagment-video-2.jpg","width":"430","height":"240","title":"Formation - Beyoncé"}}),_c('video-element',{ref:"video2",attrs:{"href":"https://www.youtube.com/watch?v=RM7lw0Ovzq0","onEnter":_vm.fadeElements,"item":2,"onLeave":_vm.resetElement,"poster":"assets/images/engagment-video-3.jpg","width":"430","height":"240","title":"The story of 0.J. - Jay-Z"}})],1),_c('div',{staticClass:"slider-column"},[_c('video-element',{ref:"video3",attrs:{"href":"https://www.youtube.com/watch?v=Z-48u_uWMHY","onEnter":_vm.fadeElements,"item":3,"onLeave":_vm.resetElement,"poster":"assets/images/engagment-video-4.jpg","width":"430","height":"240","title":"Alright - Kendrick Lamar"}})],1),_c('div',{staticClass:"slider-column"},[_c('video-element',{ref:"video4",attrs:{"href":"https://www.youtube.com/watch?v=hsMraWleiCQ","onEnter":_vm.fadeElements,"item":4,"onLeave":_vm.resetElement,"poster":"assets/images/engagment-video-6.jpg","width":"430","height":"240","title":"Mosh (Explicit) - eminem"}}),_c('video-element',{ref:"video5",attrs:{"href":"https://www.youtube.com/watch?v=U3OD3mlJdT8","onEnter":_vm.fadeElements,"item":5,"onLeave":_vm.resetElement,"poster":"assets/images/engagment-video-5.jpg","width":"577","height":"323","title":"YG - YNS ft. Blac Youngsta, YFN Lucci"}})],1),_c('div',{staticClass:"slider-column"},[_c('video-element',{ref:"video6",attrs:{"href":"https://www.youtube.com/watch?v=c7zyAtkw6ac","onEnter":_vm.fadeElements,"item":6,"onLeave":_vm.resetElement,"poster":"assets/images/engagment-video-7.jpg","width":"577","height":"323","title":"Holler If Ya Hear Me - 2Pac"}}),_c('video-element',{ref:"video7",attrs:{"href":"https://www.youtube.com/watch?v=9jOqOlETcRU","onEnter":_vm.fadeElements,"item":7,"onLeave":_vm.resetElement,"poster":"assets/images/engagment-video-8.jpg","width":"430","height":"240","title":"Fuck Tha Police - N.W.A."}})],1),_c('div',{staticClass:"slider-column"},[_c('video-element',{ref:"video8",attrs:{"href":"https://www.youtube.com/watch?v=8PaoLy7PHwk","onEnter":_vm.fadeElements,"item":8,"onLeave":_vm.resetElement,"poster":"assets/images/engagment-video-9.jpg","width":"430","height":"240","title":"Fight The Power - Public Enemy"}}),_c('video-element',{ref:"video9",attrs:{"href":"https://www.youtube.com/watch?v=-SoKFycTmVU","onEnter":_vm.fadeElements,"item":9,"onLeave":_vm.resetElement,"poster":"assets/images/engagment-video-10.jpg","width":"577","height":"323","title":"New Slaves - Kanye West"}})],1),_c('div',{staticClass:"slider-column movable-column"},[_c('video-element',{ref:"video10",attrs:{"href":"https://www.youtube.com/watch?v=xE8ct6FvMN0","onEnter":_vm.fadeElements,"item":10,"onLeave":_vm.resetElement,"poster":"assets/images/engagment-video-11.jpg","width":"577","height":"323","title":"BUFFALO - Tyler, The Creator"}}),_c('div',{staticClass:"text text-2"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.translate('engagement.text_4'))}})])],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"fact-title"},[_vm._v("JOEY BADA$$ "),_c('br'),_c('span',[_vm._v("vs")]),_vm._v(" BARACK OBAMA")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fact-thumb"},[_c('img',{attrs:{"src":"assets/images/obama-daughter.jpg"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fact-thumb"},[_c('img',{attrs:{"src":"assets/images/joey-coachella.jpg"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fact-thumb"},[_c('img',{attrs:{"src":"assets/images/joey-about-obama.jpg"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"engagement"},[_c('engagement-intro',{staticClass:"engagement-section"}),_c('engagement-slider',{staticClass:"engagement-section"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_program_vue__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_program_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_program_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb9b007c_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_program_vue__ = __webpack_require__(616);
function injectStyle (ssrContext) {
  __webpack_require__(613)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_program_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb9b007c_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_program_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(614);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("37dee631", content, true, {});

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".program{width:100%;min-height:100vh;background:#0f0d37;position:relative;padding-bottom:10%;padding-top:90vh;padding-bottom:90vh}.program .layer{background-color:#000;position:absolute;left:0;bottom:0;height:100vh;width:100%;z-index:30;opacity:0}.program .interview{position:relative;z-index:50;max-width:740px;margin:auto}@media screen and (min-width:1700px){.program .interview{max-width:45%}}.program .interview img.bg-paper{width:100%}.program .interview .interview-content{position:absolute;top:0;left:0;padding:5vw}.program .interview .interview-content .title{text-align:center;font-size:50px;text-transform:uppercase;letter-spacing:.15em;font-family:Saira Extra Condensed,sans-serif;font-weight:700}.program .interview .interview-content .title span:first-child{color:#05006c}.program .interview .interview-content .title span:last-child{color:#e81e4e}.program .interview .interview-content .question-answer{margin-top:24px}.program .interview .interview-content .question-answer p{font-size:.9375em;line-height:1.6em;color:#05006c}.program .interview .interview-content .question-answer p.question{font-family:Poppins,sans-serif;font-weight:700}.program .interview .interview-content .question-answer p.answer{font-family:Abhaya Libre,serif}.program .background{z-index:30}.program .background-image{position:absolute;top:0;left:0;height:100vh;width:100%;z-index:20}.program .background-image .image-1{z-index:30}.program .background-image .image-2{z-index:20}.program .background-image img{width:100%;position:absolute;top:0;left:0;height:100%;object-fit:cover}.program .credits-layer{position:absolute;z-index:70;bottom:0;left:0;height:100vh;width:100%;display:flex;align-items:center;justify-content:center}.program .credits-layer .credits-layer-content{color:#fff;position:relative;z-index:50;width:100%;max-width:760px;padding:0 20px}@media screen and (min-width:1700px){.program .credits-layer .credits-layer-content{max-width:900px}}@media screen and (min-width:2400px){.program .credits-layer .credits-layer-content{max-width:1200px}}.program .credits-layer .credits-layer-content h3{font-size:2.625em;margin-bottom:32px}.program .credits-layer .credits-layer-content ul li{opacity:0;transform:translateY(40px);margin-bottom:24px}.program .credits-layer .credits-layer-content ul li a{font-size:1.5em;text-decoration:none;color:#fff}.program .credits-layer .credits-layer-content ul li a span{font-weight:900;letter-spacing:.05em;opacity:0;transform:translateY(20px);display:inline-block}", ""]);

// exports


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _background = __webpack_require__(30);

var _background2 = _interopRequireDefault(_background);

var _Globals = __webpack_require__(16);

var _Globals2 = _interopRequireDefault(_Globals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Racism = (_dec = (0, _vueClassComponent2.default)({
	name: 'Racism',
	components: { Background: _background2.default }
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(Racism, _Scrollable);

	function Racism() {
		(0, _classCallCheck3.default)(this, Racism);
		return (0, _possibleConstructorReturn3.default)(this, (Racism.__proto__ || (0, _getPrototypeOf2.default)(Racism)).apply(this, arguments));
	}

	(0, _createClass3.default)(Racism, [{
		key: 'mounted',
		value: function mounted() {
			(0, _get3.default)(Racism.prototype.__proto__ || (0, _getPrototypeOf2.default)(Racism.prototype), 'mounted', this).call(this);

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			(0, _get3.default)(Racism.prototype.__proto__ || (0, _getPrototypeOf2.default)(Racism.prototype), 'init', this).call(this);

			this.isResized = false;
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(Racism.prototype.__proto__ || (0, _getPrototypeOf2.default)(Racism.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_dom',
		value: function _dom() {
			this.$bg = this.$el.querySelector('.background-image');
			this.$bgImg1 = this.$bg.querySelector('.image-1');
		}
	}, {
		key: 'raf',
		value: function raf(y) {
			(0, _get3.default)(Racism.prototype.__proto__ || (0, _getPrototypeOf2.default)(Racism.prototype), 'raf', this).call(this, y);
		}
	}, {
		key: 'initTimeline',
		value: function initTimeline() {
			var _this2 = this;

			(0, _get3.default)(Racism.prototype.__proto__ || (0, _getPrototypeOf2.default)(Racism.prototype), 'initTimeline', this).call(this);

			var hw_ratio = (window.innerHeight + window.innerHeight * .2) / this.bounds.height;
			var appearRatio = window.innerHeight * .5 / this.bounds.height;

			this.tlAppear.fromTo(this.$refs.layer, .6, { opacity: 0 }, { opacity: .7 }, 0).fromTo(this.$refs.creditsTitle, .6, { y: 40, opacity: 0 }, { y: 0, opacity: 1 }, 0).staggerFromTo(this.$refs.creditsItems.children, .6, { y: 40, opacity: 0 }, { y: 0, opacity: 1 }, .1, .05).staggerFromTo(this.$refs.creditsItems.querySelectorAll('span'), .6, { y: 10, opacity: 0 }, { y: 0, opacity: 1 }, .1, .1);

			this.tl.fromTo(this.$bg, 1, { y: 0 }, { y: this.bounds.height - window.innerHeight, ease: Power0.easeNone }, 0);
			this.tl.fromTo(this.$bgImg1, .1, { opacity: 1 }, { opacity: 0, ease: Power0.easeNone }, 1 - hw_ratio);
			this.tl.add(function () {
				var p = _this2.tlAppear.progress();

				if (_this2.scroller.direction === 1 || _this2.isResized == false) {
					_this2.tlAppear.play(p);
				} else {
					_this2.tlAppear.reverse(p);
				}

				_this2.isResized = true;
			}, 1 - appearRatio);
		}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(Racism.prototype.__proto__ || (0, _getPrototypeOf2.default)(Racism.prototype), '_resize', this).call(this);

			this.isResized = false;

			this.boundsAnim = {
				top: this.bounds.top,
				bottom: this.bounds.top + this.bounds.height - window.innerHeight
			};

			this.initTimeline();
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(Racism.prototype.__proto__ || (0, _getPrototypeOf2.default)(Racism.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(Racism.prototype.__proto__ || (0, _getPrototypeOf2.default)(Racism.prototype), '_off', this).call(this);
		}
	}]);
	return Racism;
}(_scrollable2.default)) || _class);
exports.default = Racism;

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"program"},[_c('div',{staticClass:"background-image"},[_c('img',{staticClass:"image-1",attrs:{"src":"assets/images/joey-rounded-office.jpg"}}),_c('img',{staticClass:"image-2",attrs:{"src":"assets/images/joey-black-house.jpg"}}),_c('div',{ref:"layer",staticClass:"layer"})]),_c('div',{staticClass:"interview"},[_c('img',{staticClass:"bg-paper",attrs:{"src":"assets/images/program-paper.png"}}),_c('div',{staticClass:"interview-content"},[_c('h2',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.translate('program.title'))}}),_vm._l((_vm.translate('program.questions')),function(trad){return _c('div',{staticClass:"question-answer"},[_c('p',{staticClass:"question"},[_vm._v(_vm._s(trad.question))]),_c('p',{staticClass:"answer"},[_vm._v(_vm._s(trad.answer))])])})],2)]),_c('div',{staticClass:"credits-layer"},[_c('div',{staticClass:"credits-layer-content"},[_c('h3',{ref:"creditsTitle"},[_vm._v("Crédits")]),_c('ul',{ref:"creditsItems"},[_vm._m(0),_vm._m(1),_vm._m(2),_vm._m(3),_vm._m(4),_vm._m(5)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"https://www.instagram.com/ouilyame_shoesup/","target":"_blank"}},[_vm._v("Creative Director : "),_c('span',[_vm._v("William Roden")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"https://www.instagram.com/flow_shoesup/","target":"_blank"}},[_vm._v("Digital Art Director : "),_c('span',[_vm._v("Floriane Raux")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"https://www.instagram.com/melow_r_/","target":"_blank"}},[_vm._v("Editorial Manager : "),_c('span',[_vm._v("Mélodie Raymond")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"https://www.instagram.com/zergueii/","target":"_blank"}},[_vm._v("Creative Developer : "),_c('span',[_vm._v("Serge Wsevolojsky")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"https://www.instagram.com/banrocky/","target":"_blank"}},[_vm._v("Photographer & Retoucher : "),_c('span',[_vm._v("Richard Banroques")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"https://www.instagram.com/laurawaltersstylist/","target":"_blank"}},[_vm._v("Stylist : "),_c('span',[_vm._v("Laura Walters")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_vue__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14013dfc_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_menu_vue__ = __webpack_require__(625);
function injectStyle (ssrContext) {
  __webpack_require__(618)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14013dfc_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_menu_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(619);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("b43769a0", content, true, {});

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".menu{position:fixed;top:0;left:0;width:100vw;height:100%;z-index:90;overflow:hidden;display:none}.menu .bg-layer{position:absolute;top:0;right:0;bottom:0;left:0;background-color:#000;z-index:10;opacity:0}.menu .close-button{opacity:0;visibility:hidden}.menu-wrapper{position:relative;z-index:40;padding-top:42px;padding-bottom:20vh;height:100%}.menu-wrapper,.menu-wrapper .nav-wrapper{display:flex;flex-direction:column;align-items:center;justify-content:space-between}.menu-wrapper .nav-wrapper{height:55vh}.menu-wrapper .nav-item{position:relative;visibility:hidden;opacity:0;transform:translateY(100px)}.menu-wrapper .nav-item .stripe{position:absolute;top:2px;left:-2px;width:0;height:1.75em;background-color:#0e19ee;z-index:10;transition:width .5s cubic-bezier(.19,1,.22,1)}.menu-wrapper .nav-item-link{color:#fff;text-decoration:none;text-transform:uppercase;font-family:Saira Extra Condensed,sans-serif;font-weight:300;font-size:2.1875em;letter-spacing:.15em;position:relative;z-index:30}.menu-wrapper .nav-item:hover .stripe{width:100%}", ""]);

// exports


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scroller = __webpack_require__(18);

var _scroller2 = _interopRequireDefault(_scroller);

var _ticker = __webpack_require__(19);

var _ticker2 = _interopRequireDefault(_ticker);

var _section = __webpack_require__(41);

var _section2 = _interopRequireDefault(_section);

var _closeButton = __webpack_require__(184);

var _closeButton2 = _interopRequireDefault(_closeButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Menu = (_dec = (0, _vueClassComponent2.default)({
	name: 'Menu',
	components: { CloseButton: _closeButton2.default }
}), _dec(_class = function (_Vue) {
	(0, _inherits3.default)(Menu, _Vue);

	function Menu() {
		(0, _classCallCheck3.default)(this, Menu);
		return (0, _possibleConstructorReturn3.default)(this, (Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).apply(this, arguments));
	}

	(0, _createClass3.default)(Menu, [{
		key: 'mounted',
		value: function mounted() {

			this._bind();
			this._on();
			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {}
	}, {
		key: '_dom',
		value: function _dom() {
			this.$bg = this.$el.querySelector('.bg-layer');
			this.$menuItems = this.$el.querySelectorAll('.nav-item');
			this.$cross = this.$el.querySelector('.close-button');
		}
	}, {
		key: '_bind',
		value: function _bind() {
			this.$events.on('menu.in', this.show.bind(this));
		}
	}, {
		key: '_on',
		value: function _on() {}
	}, {
		key: 'onTap',
		value: function onTap() {
			this.$events.emit('menu.out');
			this.hide();
		}
	}, {
		key: 'show',
		value: function show() {
			var tl = new TimelineMax();
			tl.set(this.$el, { display: 'block' }, 0);
			tl.to(this.$bg, 1, { opacity: 1, ease: Expo.easeIn }, 0);
			tl.staggerTo(this.$menuItems, .6, { y: 0, autoAlpha: 1, ease: Expo.easeOut }, .05, .8);
			tl.to(this.$cross, .6, { autoAlpha: 1, ease: Power0.easeNone }, 1.2);
		}
	}, {
		key: 'hide',
		value: function hide() {
			var tl = new TimelineMax();
			tl.to(this.$cross, .5, { autoAlpha: 0, ease: Power0.easeNone });
			tl.staggerTo(this.$menuItems, .6, { y: 100, autoAlpha: 0, ease: Expo.easeIn }, -.05, 0);

			tl.to(this.$bg, 1, { opacity: 0, ease: Expo.easeIn }, 0);
			tl.set(this.$el, { display: 'none' });
		}
	}, {
		key: 'goTo',
		value: function goTo(e, target) {
			e.preventDefault();
			this.$events.emit('app.anchor', target);
			this.$events.emit('menu.out');
			this.hide();
		}
	}, {
		key: '_resize',
		value: function _resize() {}
	}]);
	return Menu;
}(_vue2.default)) || _class);
exports.default = Menu;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(622);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("8c6d468c", content, true, {});

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".close-button{display:flex;flex-direction:column;justify-content:space-between;align-items:center;cursor:pointer}.close-button,.close-button .cross{width:30px;height:30px;position:relative}.close-button .cross{transform:rotate(45deg)}.close-button .cross .bar{height:15px;width:15px;position:absolute;transition:transform .3s}.close-button .cross .bar:first-child{left:1px;bottom:1px;border-top:2px solid #fff;border-right:2px solid #fff}.close-button .cross .bar:nth-child(2){top:1px;right:1px;border-bottom:2px solid #fff;border-left:2px solid #fff}.close-button span.bar{width:20px;height:2px;display:block;background-color:#fff;transition:all .3s}.close-button span.bar:nth-child(2){width:16px}.close-button .text{color:#fff;position:absolute;text-transform:uppercase;font-weight:300;font-family:Saira Extra Condensed,sans-serif;font-size:12px;letter-spacing:.15em;top:9px;opacity:0;transition:opacity .3s}.close-button:hover .bar:first-child{transform:translate3d(18px,-18px,0)}.close-button:hover .bar:nth-child(2){transform:translate3d(-20px,20px,0)}.close-button:hover .text{opacity:1}", ""]);

// exports


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scroller = __webpack_require__(18);

var _scroller2 = _interopRequireDefault(_scroller);

var _ticker = __webpack_require__(19);

var _ticker2 = _interopRequireDefault(_ticker);

var _section = __webpack_require__(41);

var _section2 = _interopRequireDefault(_section);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BurgerButton = (_dec = (0, _vueClassComponent2.default)({
	name: 'BurgerButton',
	components: {},
	props: ["action"]
}), _dec(_class = function (_Vue) {
	(0, _inherits3.default)(BurgerButton, _Vue);

	function BurgerButton() {
		(0, _classCallCheck3.default)(this, BurgerButton);
		return (0, _possibleConstructorReturn3.default)(this, (BurgerButton.__proto__ || (0, _getPrototypeOf2.default)(BurgerButton)).apply(this, arguments));
	}

	(0, _createClass3.default)(BurgerButton, [{
		key: 'mounted',
		value: function mounted() {

			this._bind();
			this._on();
		}
	}, {
		key: 'init',
		value: function init() {}
	}, {
		key: '_bind',
		value: function _bind() {
			this.show = this.show.bind(this);
			this.hide = this.hide.bind(this);
		}
	}, {
		key: '_on',
		value: function _on() {}
	}, {
		key: 'onTap',
		value: function onTap() {}
	}, {
		key: 'show',
		value: function show() {}
	}, {
		key: 'hide',
		value: function hide() {}
	}, {
		key: '_resize',
		value: function _resize() {}
	}]);
	return BurgerButton;
}(_vue2.default)) || _class);
exports.default = BurgerButton;

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-touch',{staticClass:"close-button",on:{"tap":_vm.action}},[_c('div',{staticClass:"cross"},[_c('div',{staticClass:"bar"}),_c('div',{staticClass:"bar"})]),_c('span',{staticClass:"text"},[_vm._v("close")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_c('div',{staticClass:"bg-layer"}),_c('div',{staticClass:"menu-wrapper"},[_c('close-button',{attrs:{"action":_vm.onTap}}),_c('nav',{staticClass:"nav"},[_c('ul',{staticClass:"nav-wrapper"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-item-link",attrs:{"href":"#"},on:{"click":function($event){_vm.goTo($event,'youth')}}},[_vm._v(_vm._s(_vm.translate('globals.sections.youth')))]),_c('div',{staticClass:"stripe"})]),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-item-link",attrs:{"href":"#"},on:{"click":function($event){_vm.goTo($event,'proEra')}}},[_vm._v(_vm._s(_vm.translate('globals.sections.pro_era')))]),_c('div',{staticClass:"stripe"})]),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-item-link",attrs:{"href":"#"},on:{"click":function($event){_vm.goTo($event,'B4Da$$')}}},[_vm._v(_vm._s(_vm.translate('globals.sections.badass')))]),_c('div',{staticClass:"stripe"})]),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-item-link",attrs:{"href":"#"},on:{"click":function($event){_vm.goTo($event,'ameriKKKan')}}},[_vm._v(_vm._s(_vm.translate('globals.sections.all_amerikkkan')))]),_c('div',{staticClass:"stripe"})]),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-item-link",attrs:{"href":"#"},on:{"click":function($event){_vm.goTo($event,'landOfFree')}}},[_vm._v(_vm._s(_vm.translate('globals.sections.land_of_free')))]),_c('div',{staticClass:"stripe"})]),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-item-link",attrs:{"href":"#"},on:{"click":function($event){_vm.goTo($event,'racism')}}},[_vm._v(_vm._s(_vm.translate('globals.sections.racism')))]),_c('div',{staticClass:"stripe"})]),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-item-link",attrs:{"href":"#"},on:{"click":function($event){_vm.goTo($event,'engagement')}}},[_vm._v(_vm._s(_vm.translate('globals.sections.engagement')))]),_c('div',{staticClass:"stripe"})])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_credits_vue__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_credits_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_credits_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acc74c72_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_credits_vue__ = __webpack_require__(630);
function injectStyle (ssrContext) {
  __webpack_require__(627)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_credits_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acc74c72_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_credits_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(628);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("a8e9f198", content, true, {});

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".credits{position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:90;overflow:hidden;display:none}.credits .bg-layer{position:absolute;top:0;right:0;bottom:0;left:0;background-color:#000;z-index:10;opacity:0}.credits .close-button{position:absolute;top:42px;left:50%;transform:translateX(-50%)}.credits-wrapper{position:relative;z-index:40;display:flex;justify-content:center;align-items:center;height:100%}.credits-wrapper .credits-content{color:#fff;position:relative;z-index:50;width:100%;max-width:1000px;padding:0 20px}.credits-wrapper .credits-content h3{font-size:3.5em;margin-bottom:32px;opacity:0;transform:translateY(40px)}.credits-wrapper .credits-content ul li{opacity:0;transform:translateY(40px);margin-bottom:24px}.credits-wrapper .credits-content ul li a{font-size:1.5em;text-decoration:none;color:#fff}.credits-wrapper .credits-content ul li a span{font-weight:900;letter-spacing:.05em;opacity:0;transform:translateY(20px);display:inline-block}", ""]);

// exports


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _closeButton = __webpack_require__(184);

var _closeButton2 = _interopRequireDefault(_closeButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Credits = (_dec = (0, _vueClassComponent2.default)({
	name: 'Credits',
	components: { CloseButton: _closeButton2.default }
}), _dec(_class = function (_Vue) {
	(0, _inherits3.default)(Credits, _Vue);

	function Credits() {
		(0, _classCallCheck3.default)(this, Credits);
		return (0, _possibleConstructorReturn3.default)(this, (Credits.__proto__ || (0, _getPrototypeOf2.default)(Credits)).apply(this, arguments));
	}

	(0, _createClass3.default)(Credits, [{
		key: 'mounted',
		value: function mounted() {

			this._dom();
			this._on();
		}
	}, {
		key: 'init',
		value: function init() {}
	}, {
		key: '_dom',
		value: function _dom() {
			this.$bg = this.$el.querySelector('.bg-layer');
			this.$cross = this.$el.querySelector('.close-button');
		}
	}, {
		key: '_on',
		value: function _on() {
			this.$events.on('credits.in', this.show.bind(this));
		}
	}, {
		key: 'onTap',
		value: function onTap() {
			this.$events.emit('credits.out');
			this.hide();
		}
	}, {
		key: 'show',
		value: function show() {
			var tl = new TimelineMax();
			tl.set(this.$el, { display: 'block' }, 0);
			tl.to(this.$bg, 1, { opacity: 1, ease: Expo.easeIn }, 0);
			tl.to(this.$refs.creditsTitle, .6, { y: 0, autoAlpha: 1, ease: Expo.easeOut }, .8);
			tl.staggerTo(this.$refs.creditsItems.children, .6, { y: 0, autoAlpha: 1, ease: Expo.easeOut }, .05, .85);
			tl.staggerFromTo(this.$refs.creditsItems.querySelectorAll('span'), .6, { y: 10, opacity: 0 }, { y: 0, opacity: 1 }, .05, .9);
			tl.to(this.$cross, .6, { autoAlpha: 1, ease: Power0.easeNone }, 1.2);
		}
	}, {
		key: 'hide',
		value: function hide() {
			var tl = new TimelineMax();
			tl.to(this.$cross, .5, { autoAlpha: 0, ease: Power0.easeNone });
			tl.staggerTo(this.$refs.creditsItems.children, .6, { y: 100, autoAlpha: 0, ease: Expo.easeIn }, -.05, 0);
			tl.to(this.$refs.creditsTitle, .6, { y: 100, autoAlpha: 0, ease: Expo.easeIn }, .30);
			tl.to(this.$bg, 1, { opacity: 0, ease: Expo.easeIn }, 0);
			tl.set(this.$el, { display: 'none' });
			this.$events.emit('menu.out');
		}
	}]);
	return Credits;
}(_vue2.default)) || _class);
exports.default = Credits;

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"credits"},[_c('div',{staticClass:"bg-layer"}),_c('div',{staticClass:"credits-wrapper"},[_c('close-button',{attrs:{"action":_vm.onTap}}),_c('div',{staticClass:"credits-content"},[_c('h3',{ref:"creditsTitle"},[_vm._v("Crédits")]),_c('ul',{ref:"creditsItems"},[_vm._m(0),_vm._m(1),_vm._m(2),_vm._m(3),_vm._m(4),_vm._m(5)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"https://www.instagram.com/ouilyame_shoesup/","target":"_blank"}},[_vm._v("Creative Director : "),_c('span',[_vm._v("William Roden")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"https://www.instagram.com/flow_shoesup/","target":"_blank"}},[_vm._v("Digital Art Director : "),_c('span',[_vm._v("Floriane Raux")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"https://www.instagram.com/melow_r_/","target":"_blank"}},[_vm._v("Editorial Manager : "),_c('span',[_vm._v("Mélodie Raymond")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"https://www.instagram.com/zergueii/","target":"_blank"}},[_vm._v("Creative Developer : "),_c('span',[_vm._v("Serge Wsevolojsky")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"https://www.instagram.com/banrocky/","target":"_blank"}},[_vm._v("Photographer & Retoucher : "),_c('span',[_vm._v("Richard Banroques")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"https://www.instagram.com/laurawaltersstylist/","target":"_blank"}},[_vm._v("Stylist : "),_c('span',[_vm._v("Laura Walters")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mobile_version_vue__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mobile_version_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mobile_version_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7920ecf4_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_mobile_version_vue__ = __webpack_require__(636);
function injectStyle (ssrContext) {
  __webpack_require__(632)
}
var normalizeComponent = __webpack_require__(9)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mobile_version_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7920ecf4_hasScoped_false_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_mobile_version_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(633);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("4076e556", content, true, {});

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".mobile-version{width:100%;height:100vh;background-color:#05006c;position:relative}.mobile-version .background-wrapper,.mobile-version .joey-image{position:absolute;top:0;left:0;width:100%;overflow:hidden;opacity:0}.mobile-version .background-wrapper img,.mobile-version .joey-image img{width:100%}.mobile-version .background-wrapper{z-index:30}.mobile-version .joey-image{z-index:50}.mobile-version .gradient{position:absolute;bottom:0;left:0;height:20vh;width:100%;z-index:60;background-color:#05006c}.mobile-version .gradient:after{content:\"\";position:absolute;width:100%;height:40vh;top:1px;left:0;transform:translateY(-100%);background:linear-gradient(0deg,#05006c,rgba(5,0,108,0))}.mobile-version .mobile-content{position:absolute;z-index:70;bottom:0;left:0;height:50vh;width:100%;display:flex;align-items:center;flex-direction:column}.mobile-version .mobile-content .logo{max-width:200px;position:relative;z-index:50;opacity:0}.mobile-version .mobile-content .logo img{width:100%}.mobile-version .mobile-content .title,.mobile-version .mobile-content .title .chapo{opacity:0}.mobile-version .mobile-content .title p{color:#fff;font-size:1.875em;font-weight:900;text-align:center;line-height:1.133333333333333em}.mobile-version .mobile-content .title p:first-child{text-transform:uppercase;font-size:.625em;font-weight:400;letter-spacing:.2em;margin-bottom:12px}.mobile-version .mobile-content .title p:nth-child(2){text-transform:uppercase}.mobile-version .mobile-content .content-text{max-width:300px;text-align:center;margin-top:32px}.mobile-version .mobile-content .content-text p.line{line-height:1.6em;letter-spacing:.05em;font-weight:700;font-size:1.125em;color:#ff2c46}", ""]);

// exports


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _vueClassComponent = __webpack_require__(10);

var _vueClassComponent2 = _interopRequireDefault(_vueClassComponent);

var _jquery = __webpack_require__(11);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(6);

var _scrollable = __webpack_require__(12);

var _scrollable2 = _interopRequireDefault(_scrollable);

var _background = __webpack_require__(30);

var _background2 = _interopRequireDefault(_background);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _Globals = __webpack_require__(16);

var _Globals2 = _interopRequireDefault(_Globals);

var _flagsOverlay = __webpack_require__(68);

var _flagsOverlay2 = _interopRequireDefault(_flagsOverlay);

var _splitedText = __webpack_require__(42);

var _splitedText2 = _interopRequireDefault(_splitedText);

var _gyros = __webpack_require__(635);

var _gyros2 = _interopRequireDefault(_gyros);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MobileVersion = (_dec = (0, _vueClassComponent2.default)({
	name: 'MobileVersion',
	components: { FlagsOverlay: _flagsOverlay2.default, SplitedText: _splitedText2.default }
}), _dec(_class = function (_Scrollable) {
	(0, _inherits3.default)(MobileVersion, _Scrollable);

	function MobileVersion() {
		(0, _classCallCheck3.default)(this, MobileVersion);
		return (0, _possibleConstructorReturn3.default)(this, (MobileVersion.__proto__ || (0, _getPrototypeOf2.default)(MobileVersion)).apply(this, arguments));
	}

	(0, _createClass3.default)(MobileVersion, [{
		key: 'mounted',
		value: function mounted() {

			(0, _get3.default)(MobileVersion.prototype.__proto__ || (0, _getPrototypeOf2.default)(MobileVersion.prototype), 'mounted', this).call(this);

			this._dom();
		}
	}, {
		key: 'init',
		value: function init() {
			var _this2 = this;

			(0, _get3.default)(MobileVersion.prototype.__proto__ || (0, _getPrototypeOf2.default)(MobileVersion.prototype), 'init', this).call(this);

			var tl = new TimelineMax();

			tl.fromTo(this.$refs.bg, 1.4, { opacity: 0, scale: 1.1 }, { opacity: 1, scale: 1 }, 0);
			tl.fromTo(this.$refs.joey, .8, { opacity: 0, scale: .95 }, { opacity: 1, scale: 1 }, .2);
			tl.fromTo(this.$refs.title, 2, { opacity: 0, scale: .9 }, { opacity: 1, scale: 1 }, .2);
			tl.fromTo(this.$refs.chapo, 1.4, { opacity: 0, scale: .9 }, { opacity: 1, scale: 1 }, .3);
			tl.add(function () {
				_this2.$refs.splitedText.animateIn();
			}, .8);

			// this.tlAppear.play()
		}
	}, {
		key: '_dom',
		value: function _dom() {}
	}, {
		key: 'initTimeline',
		value: function initTimeline() {
			(0, _get3.default)(MobileVersion.prototype.__proto__ || (0, _getPrototypeOf2.default)(MobileVersion.prototype), 'initTimeline', this).call(this);
		}
	}, {
		key: 'raf',
		value: function raf(y) {
			(0, _get3.default)(MobileVersion.prototype.__proto__ || (0, _getPrototypeOf2.default)(MobileVersion.prototype), 'raf', this).call(this, y);

			var gamma1 = _lodash2.default.clamp(_gyros2.default.instance.gamma * .3, -13, 17);
			var gamma2 = _lodash2.default.clamp(_gyros2.default.instance.gamma * .5, -15, 15);
			var gamma3 = _lodash2.default.clamp(_gyros2.default.instance.gamma * .1, -1, 1);

			this.$refs.joeyImg.style.transform = 'translate3d(' + gamma1 + 'px,0,0)';
			this.$refs.bgImg.style.transform = 'scale(1.1) translate3d(' + -gamma2 + 'px,0,0)';
			this.$refs.title1.style.transform = 'scale(1.1) translate3d(' + -gamma3 + 'px,0,0)';
			this.$refs.title2.style.transform = 'scale(1.1) translate3d(' + gamma3 + 'px,0,0)';
		}
	}, {
		key: '_bind',
		value: function _bind() {
			(0, _get3.default)(MobileVersion.prototype.__proto__ || (0, _getPrototypeOf2.default)(MobileVersion.prototype), '_bind', this).call(this);
		}
	}, {
		key: '_resize',
		value: function _resize() {
			(0, _get3.default)(MobileVersion.prototype.__proto__ || (0, _getPrototypeOf2.default)(MobileVersion.prototype), '_resize', this).call(this);
		}
	}, {
		key: '_on',
		value: function _on() {
			(0, _get3.default)(MobileVersion.prototype.__proto__ || (0, _getPrototypeOf2.default)(MobileVersion.prototype), '_on', this).call(this);
		}
	}, {
		key: '_off',
		value: function _off() {
			(0, _get3.default)(MobileVersion.prototype.__proto__ || (0, _getPrototypeOf2.default)(MobileVersion.prototype), '_off', this).call(this);
		}
	}]);
	return MobileVersion;
}(_scrollable2.default)) || _class);
exports.default = MobileVersion;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Gyros = function () {
	function Gyros() {
		(0, _classCallCheck3.default)(this, Gyros);
		Object.defineProperty(this, 'instance', {
			enumerable: true,
			writable: true,
			value: {
				gamma: 0,
				beta: 0,
				alpha: 0
			}
		});

		this._addEvents();
	}

	(0, _createClass3.default)(Gyros, [{
		key: 'update',
		value: function update(event) {

			var x = void 0;
			var orientation = typeof window.orientation !== 'undefined' ? window.orientation : 0;

			// console.log(orientation)

			switch (orientation) {
				case 0:
				case 180:
					this.instance.gamma = event.gamma;
					break;
			}
		}
	}, {
		key: '_addEvents',
		value: function _addEvents() {

			// if ('ondeviceorientationabsolute' in window) {
			// 	console.log('test 1')
			// 	window.addEventListener('deviceorientationabsolute', this.update.bind(this),false)
			// } else if ('ondeviceorientation' in window) {
			// 	console.log('test 2')
			// 	window.addEventListener('deviceorientation', this.update.bind(this),false)
			// }

			// console.log('okokokokokokoko')

			// if ((window.screen.orientation) && ('onchange' in window.screen.orientation)) {
			// 	console.log('popo')
			// 	window.screen.orientation.addEventListener('change', this.update.bind(this))
			// } else if ('onorientationchange' in window) {
			// 	console.log('ok')
			// 	window.addEventListener('orientationchange', this.update.bind(this))
			// } else {
			// 	console.warn('No orientationchange events')
			// }

			window.addEventListener('deviceorientation', this.update.bind(this));
		}
	}]);
	return Gyros;
}();

exports.default = new Gyros();

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-version"},[_c('div',{ref:"bg",staticClass:"background-wrapper"},[_c('img',{ref:"bgImg",attrs:{"src":"assets/images/mobile-background.jpg"}})]),_c('div',{ref:"joey",staticClass:"joey-image"},[_c('img',{ref:"joeyImg",attrs:{"src":"assets/images/mobile-joey.png"}})]),_c('div',{staticClass:"gradient"}),_c('div',{ref:"content",staticClass:"mobile-content"},[_c('div',{ref:"title",staticClass:"title"},[_c('p',{ref:"chapo",staticClass:"chapo"},[_vm._v("Shoes up presents")]),_c('p',{ref:"title1"},[_vm._v("Joey Bada$$")]),_c('p',{ref:"title2"},[_vm._v("Political Mc")])]),_c('splited-text',{ref:"splitedText",staticClass:"content-text",attrs:{"text":_vm.translate('globals.mobile')}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container"}},[_c('div',{ref:"landing",staticClass:"landing"},[(!_vm.isTablet)?_c('background',{ref:"bg"}):_vm._e(),(!_vm.isTablet)?_c('header-element'):_vm._e(),(!_vm.isTablet)?_c('scroll-indicator'):_vm._e(),(!_vm.isTablet)?_c('menu-element'):_vm._e(),(!_vm.isTablet)?_c('credits'):_vm._e(),_c('div',{ref:"container",staticClass:"landing-container"},[(_vm.$mq === 'desktop')?_c('div',{staticClass:"desktop-version"},[_c('loader',{ref:"loader"}),_c('intro',{ref:"intro",staticClass:"section"}),_c('presentation',{staticClass:"section"}),_c('political',{staticClass:"section"}),_c('youth',{ref:"youth",staticClass:"section"}),_c('pro-era',{ref:"proEra",staticClass:"section"}),_c('badass-origins',{ref:"B4Da$$",staticClass:"section"}),_c('amerikkkan',{ref:"ameriKKKan",staticClass:"section"}),_c('land-of-free',{ref:"landOfFree",staticClass:"section"}),_c('racism',{ref:"racism",staticClass:"section"}),_c('engagement',{ref:"engagement",staticClass:"section"}),_c('program',{ref:"",staticClass:"section"})],1):_vm._e(),(_vm.$mq === 'tablet' || _vm.$mq === 'mobile')?_c('mobile-version'):_vm._e()],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var routes = [];

exports.default = routes;

/***/ }),
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */
/***/ (function(module, exports) {

module.exports = {"globals":{"header":"1k Electeurs","sections":{"youth":"Sa Jeunesse","pro_era":"De l'école à pro era","badass":"De 1999 à b4.da.$$","all_amerikkkan":"All amerikkkan badass","land_of_free":"Land of the free","racism":"Racisme & violences policières","engagement":"L’engagement chez les artistes"},"scroll":"Scroller pour découvrir","listen":"Écouter","mobile":"Check the story on your computer for a better experience."},"intro":{"bill_text":"« I'm out for dead presidents to represent me because I've never known a live one that represent me »"},"presentation":{"quote":"«Je suis pour que tout un tas de présidents morts* me représentent... parce que je n'ai jamais vu un président le faire de son vivant.»","asterix":"*dead presidents fait références aux billets de banque américains, sur lequel on retrouve les visages d'anciens présidents, aujourd'hui décédés."},"political":{"title":"Political MC","meeting":"SHOES UP a rencontré celui qui en décembre 2012 et alors qu'il n'a que 17 ans, refuse de signer un alléchant contrat sur le label Roc Nation d’un bien nommé Jay-Z. Depuis Jo-Vaughn Virginie Scott, alias Joey Bada$$ fait, en toute indépendance, un parcours sans faute et joue lui aussi dans la cours des grands du hip hop. Maintenant, Joey …","today":"Aujourd’hui, Bada$$ a 22 ans. Il a sorti trois mixtapes et deux albums que plus d’un considèrent déjà comme cultes. Le dernier projet en date ? All AmeriKKKan Bada$$ sorti le 7 avril 2017. Un album mature, politique, engagé, sur lequel souffle un vent d’insurrection contre la politique américaine, et qui pointe plus particulièrement du doigt celle de Donald Trump. Mais comment le MC américain en est-il arrivé là ?","slider":{"slider_1":"Maintenant, Joey<br />Boit des coups avec Puff Daddy","slider_2":"Fume des joints avec tonton Snoop Dogg","slider_3":"Partage la scene avec a$sap Rocky et Wiz khalifa"}},"youth":{"title":"Sa Jeunesse","text":"Né d’une mère caribéenne et d’un père jamaïcain à East Flatbush Brooklyn à New-York, c’est dans le quartier de Bed Stuy qu’il grandit. Il est le deuxième plus âgé d’une fratrie de cinq avec trois frères et une sœur et il est d’ailleurs le premier enfant à naître aux Etats-Unis tandis que ses parents ont longtemps vécu à Sainte Lucie.</br> Il a cinq ans lorsque ses parents se séparent. Sa famille connaîtra des difficultés financières ce qui poussera sa mère à jongler entre deux jobs pour subvenir aux besoins de ses enfants. Cet épisode de sa vie inspirera son morceau Devastated sorti en 2016 ou encore Paper Trail$ avec des paroles significatives telles que","quote":"« I got a dollar and a dream, know what I mean? And I gotta get my mama off the scene »","translation":"« J’ai un dollar et un rêve, tu vois ? Et il faut que je sorte ma mère de là »"},"pro_era":{"title":"De l'école à pro era","text_1":"En âge de pouvoir tenir un stylo, Joey s’essaie à la poésie tout en étant bercé à la pop de Prince, à la soul, au reggae et au hip-hop. C’est d’ailleurs le morceau <a href='https://www.youtube.com/watch?v=wk4ftn4PArg' target='blank'>Hypnotize</a> du légendaire Notorious B.I.G qu’il connaît par cœur dès l’âge de deux ans qui l’incitera à emboîter le pas et à transformer ses poèmes en rap. De ses freestyles balancés sur YouTube alors qu’il n’a que 15 ans à ses sessions d’enregistrements homemade (à l’aide d’une Playstation 2 et d’un condensateur USB), il forge ses armes et son flow de prodige.","text_2":"Ses années lycée à la Edward R. Murrow High School (établissement public célèbre pour ses programmes en musique, théâtre et media), l’amèneront à se lier d’amitié avec d’autres artistes et aficionados jusqu’à former le désormais fameux crew Pro Era. En effet, ce groupe d’amis devenu collectif comprend aujourd’hui une vingtaine de membres dont des musiciens, producteurs, graphistes et photographes mais, à l’origine, fut fondé par Joey Bada$$, CJ Fly, Powers Pleasant puis Capital STEEZ. Ce dernier s’étant ôté la vie à l’âge de 19 ans un 24 décembre 2012 pendant l’ascension du label, le crew connaîtra une triste période de deuil et rendra multiples hommages à leur ami "},"badass":{"title":"De 1999 à B4.Da.$$","about":"La première mixtape de Joey 1999 sort en 2012 et est certifié deux fois disque de Platine. Si ses influences 90’s se font clairement entendre, c’est sans doute l’un des constats qui agace le plus le rappeur qui se dit vouloir arrêter d’être associé à tel style ou telle époque et qui prône vouloir être reconnu pour son art et non celui d’un autre. Et le moins que l’on puisse dire est que son art, souvent acclamé par la critique, marque un tournant dans cette nouvelle génération de rappeurs New-Yorkais.","between_albums":"S’en suivront les mixtapes Rejex la même année, puis Summer Knights en 2013. Le début d’année 2015 lui, marquera la sortie de son premier album B4.Da.$$ (Before Da Money) le 20 janvier, jour de son anniversaire. On y retrouve des pointures telles que DJ Premier, Statik Selektah, Basquiat, Freddie Joachim et même la fondation J Dilla & The Roots qui lui propose de choisir une production inédite du compositeur de légende parti en février 2006.","badass_album_1":"Cet album introspectif sur lequel l’artiste dévoile des morceaux tels que Christ Conscious, Paper Trail$ ou encore Piece of Mind laisse transparaitre le témoignage d’un enfant black de 20 ans qui grandit au sein d’une amérique marquée par la prospérité d’une société blanche et les difficultés qu’engendrent parfois sa couleur de peau. L’engagement et certaines références s’affichent doucement dans certaines lyrics","quote_1":"“Put our backs on the fence, so we self defence, Followed by a series of unfortunate events, Looking like white America got a brother again”","traduction_1":"«Vous nous mettez le dos sur la clôture donc nous nous défendons. suivi par des séries de malheureux événements, regardez comment l’amérique blanche a retrouvé un frère»","badass_album_2":"dans <a href='https://www.youtube.com/watch?v=kSob6t-amfA' target='blank'>Piece of Mind</a> ou encore une référence dans <a href='https://www.youtube.com/watch?v=MNZ8FPnnoAE' target='blank'>Black Beetles</a> à Martin Luther King ou encore à Marcus Garvey, millitant jamaicain ayant œuvré toute sa vie pour l’union et l’émancipation de la diaspora africaine aux Etats-Unis.","quote_2":"“Who would've thought a marchin' Martin could spark a starvin' artist / Spit art, at heart young Marcus Garvey ”","author_2":"- BLACK BEETLES -","traduction_2":"«Qui aurait imaginé ce qu’un certain martin manifestant aurait suscité chez un artiste affamé / de l’art craché au jeune cœur de marcus garvey »","badass_album_3":"Le 11 février 2015, Joey Bada$$ dévoile le puissant clip de Like Me dans lequel on trouve des références à des black américains non-armés abattus par la police, notamment à Micheal Brown (Affaire de Ferguson) ou encore à Trayvon Martin tué à l’âge de 17 ans en 2012 en Floride. En effet, dans la vidéo de 5minutes, on y voit le rappeur vivre une romance qui vire au drame avec l’ex-petit ami de sa nouvelle copine. Tandis que ce dernier tire accidentellement sur la jeune femme, la police l’abat. Alors que Bada $$ s'enfuit, désarmé, la police l'arrête et lui tire dessus lorsqu’il lève ses mains en l’air. Mais si cet opus recèle d’une dimension politisée, les prises de position de l’artiste s’affirment clairement en 2017 avec un album lourd de sens :"},"amerikkkan":{"text":"Un titre d’album qui fait tout d’abord allusion au Ku Klux Klan comme Ice Cube l’a fait en avril 1990 à la sortie de son album très politisé AmeriKKKa's Most Wanted. À noter également que cette référence avait déjà été reprise par le membre disparu de Pro Era, Capital STEEZ cinq ans auparavant. En effet, AmeriKKKan Korruption sera la première et unique mixtape de Capital STEEZ dans laquelle il attaquera de manière très virulente les institutions politiques et religieuses. "},"land_of_free":{"title":"Land of free","text_1":"Le 20 janvier 2017 marque le jour de ses 22 ans mais aussi le jour de l'investiture du 45ème président américain aka Donald Trump, “Le pire cadeau d’anniversaire de tous les temps” nous confie-t-il, Ce jour là, Joey Badass dévoile le morceau Land of the Free. Deux mois plus tard, le clip qui ne se cache pas derrière l’implicitement correct tombe sur la toile et fait l’effet qui se doit être : un véritable coup de massue à l’encontre du système.","quote_1":"“Le clip était entièrement mon idée. On essayait de capturer le sentiment et la direction qui sont inhérents à cet album. On a d’abord juste shooté des photos pour la couverture et le livret, mais notre budget était tellement élevé qu’on a décidé d’en sortir une vidéo. C’est une jolie erreur, mais au final, pas vraiment une erreur si tu vois ce que je veux dire.”","text_2":"nous explique t-il. Une douce erreur qui fera en l'occurrence naître un clip poignant. Ici, sous l’œil avisé de Badmon lui même et du réalisateur Nathan R. Smith, on le découvre tantôt au beau milieu du désert entouré d’hommes black enchaînés, tantôt dans un paysage verdoyant en train de s’adresser à des enfants et de leur dire le doigt levé","quote_2":"« Obama just wasn't enough, I just need some more closure And Donald Trump is not equipped to take this country over »","translate_2":"« OBAMA N’ÉTAIT JUSTE PAS ASSEZ, J’AI JUSTE BESOIN DE PLUS DE PROMISCUITÉ. ET DONALD TRUMP N’EST PAS ÉQUIPÉ POUR DIRIGER CE PAYS »","text_3":"Le scénario quant à lui se veut violent et dénonciateur. Des policiers et des hommes en costumes exécutent froidement les hommes blacks enchaînés. Une autre scène dévoile des hommes vêtus des tenues du Ku Klux Klan en train de pendre un homme lors d’un rite lugubre tandis que les membres de la secte se révèlent en fait être les policiers et politiciens."},"racism":{"title":"Racisme & violences policières","text_1":"Si les années 60 ont bien entendu été marquées par la ségrégation raciale et des mouvements extrémistes particulièrement barbares, Bada$$ n’hésite pas à pointer du doigt le racisme ambiant qui sévit encore.","quote_1":"« Ce que je peux dire, c’est qu’évidemment, on a connu des “améliorations” quant à la violence physique, mais on est encore loin du compte. Il y a encore des flics ou des blancs qui tuent des noirs car ils pensent que leurs vies ne valent rien. Ce que je peux ajouter aussi, c’est que le racisme d’aujourd’hui est plus subtil, plus caché. Une grande partie de la frustration des gens de couleurs vient du fait que l’on vit chaque jour des expériences racistes, mais le prouver au reste du monde n’est pas chose facile, car justement le racisme est dissimulé. Tu vois le truc? Impossible de le savoir à moins que tu sois une personne de couleur. Alors qu’avant, les choses avaient au moins le mérite d’être explicites. Des “No Blacks” affichés ici et là. Aujourd’hui, les situations sont différentes. »","text_2":"C’est ainsi qu’il s’érige en tant que porte parole d’une amérique noire effrayée tant bien par les White Supremacists, que par le manque de liberté et de protection des plus faibles","quote_2":"”J’utilise ma voix premièrement parce que je peux. Ensuite, car je suis passionné par tout ce que je fais et par les sujets que j’aborde et je pense que c’est être bénéfiques pour les gens. Et troisièmement, je parle pour ceux qui ne peuvent pas parler pour eux-même. Pour finir, je n’aimerais pas être un politicien. Je n’aime pas la politique, je considère ça comme un vulgaire tour de passe passe. Je ne crois pas que la solution soit là-dedans. La politique c’est le contrôle, la désinformation. Je pense que les gens sont la solution. On a l’impression d’avoir besoin d’être gouvernés, alors qu’on a juste besoin de se gouverner sois-même. On a suffisamment de morale et d’intelligence pour le faire aujourd’hui.”","text_3":"All AmeriKKKan Badass offre non seulement une dimension artistique aux couleurs multiples, des invités de prestige tels que J.Cole ou Schoolboy Q. et de toute évidence une morale millitantiste, dénonciatrice mais pacifiste. Aussi, cette lettre ouverte à l’amérique n’épargne personne. Le titre <a href=''>“Super predator”</a> reprend un termes polémique utilisé par Hillary Clinton dans un discours de 1994. Elle qualifiait ainsi des enfants devenus membres de gang, étroitement liés à des cartels de drogue et qui n’avaient “ni conscience, ni empathie” Même si ce termes n’a jamais explicitement visé la communauté afro-américaine, le contexte laissa entrevoir une forte ambiguïté et aura porté du tort à celle qui se présentera à l’élection présidentielle de 2016. Bennie Sanders qualifiera d’ailleurs ouvertement ses propos comme raciste. Super predator :","quote_group_1":[{"sentence":"She critical, exactly what made my niggas criminals","translation":"Elle critique exactement ce qui a rendu mes niggas criminels"},{"sentence":"Typical AmeriKKKa, damn sure ain’t no miracle [...] the Presidents, the Congressmen, the Senators","translation":"Typique amérikkke, putain c’est sûr qu’il n’y a pas de miracle [...] les présidents, les hommes du congrès, les sénateurs"},{"sentence":"Who got us slavin’ while they reapin’ all the benefits","translation":"Qui nous réduisent en esclavage tandis qu’ils tirent tous les bénéfices"},{"sentence":"Got the world thinkin’ that it’s true ‘bout what they said for us","translation":"PErsuadent le monde à penser que ce qu’ils nous ont dit était vrai"}],"quote_group_2":[{"sentence":"The government been tryna take away what’s ours","translation":"Le gouvernement a essayé de s’emparer de ce qui nous appartient"},{"sentence":"It’s really all about the money and the power","translation":"Tout est vraiment une question d’argent et de pouvoir"},{"sentence":"I just wanna see my people empowered","translation":"J’aimerais juste que mon peuple ne soit plus sous cette emprise"}],"text_4":"Par ailleurs, Badmon n’hésite pas non plus dans son titre Temptation, à mettre en avant l’émouvante plaidoirie de <span>Zianna Oliphant</span>, une enfant de 9 ans entendu par un congrès lors du décès de Keith Lamont Scott, abattu par un policier à Charlotte en Caroline du Nord."},"engagement":{"title":"L’engagement chez les artistes","text_1":"Avec cet opus, Joey Badass “souhaite faire de la musique pour que le futur soit meilleur”, avec bon espoir pour que les choses changent. C’est aussi à l’instar de bien des artistes engagés dans cette lutte contre le racisme et du système que le MC de 22 ans s’est inscrit et compte bien ajouter sa pierre à l’édifice. “ C’est très important lorsque tu en as l’opportunité, de parler pour ceux qui ne peuvent rien dire. ”","text_2":"C’est dans le titre Good Morning AmeriKKKa que le rappeur s’adresse directement à la communauté américaine en leur demandant clairement","quote_1":"« Wake Up, Wake Up, I said wake up »","translation_1":"« Réveillez vous, réveillez vous, j’ai dit réveillez vous »","quote_2":"« J’aimerais que les gens ouvrent les yeux sur ce qui ne va pas et sur ce qu’il se passe aujourd’hui. Du lavage de cerveau à la propagande, en passant par les guerres de civilisations et le terrorisme. »","sentence":"se désole-t-il.","text_3":"Comme Tupac, Public Enemy, Nas ou encore Eminem ont pu le faire, au moment où Kendrick Lamar règle ses comptes avec l’amérique avec son album DAMN, où Beyoncé s’engage dans une lutte féministe et black power avec « Formation », où Jay-Z met en lumière les fractures sociales et raciales dans « The Story of O.J. » ou en parodiant le générique de la série Friends avec des acteurs afro-américains, le hip hop s’insurge.","text_4":"C’est aussi lorsque des évènements creusent le fossé entre les communautés en Amérique que All AmeriKKKan Badass prend tout son sens. À l’heure où David Duke, ex-leader du Ku Klux Klan apporte un soutien invétéré à Donald Trump. À l’heure où des rassemblements d’extrême droite virent au drame à Charlottesville, tandis qu’une manifestante anti-raciste de 32 ans se fait tué par un suprémaciste blanc au moyen d’une voiture bélier, blessant au passage une vingtaine de personnes. À l’heure où ces groupes de haine sont non seulement loin d’avoir disparu mais profèrent leurs propos hauts et forts sans le moindre risque. Protégés par le premier amendement de la Constitution, ils sont même largement tolérés par le gouvernement.","text_left_1":"En 2015, <span>Malia Obama</span>, fille de Barack Obama, s'est retrouvé sur Instagram portant un t-shirt... du crew de Pro Era","text_left_2":"En 2016, Joey Badass était censé jouer le meilleur ami de Barack Obama dans un biopic appellé “Barry”. Ce dernier a dû refuser le rôle pour jouer sur la scène de Coachella.","text_left_3":"En 2017, Badass s’exprime pour Genius sur le mandat du 44ème président américain"},"program":{"title":"<span>Joey</span> <span>programme</span>","questions":[{"question":"Si tu étais président, quelle serait la première chose que tu ferais ?","answer":"Hummm. Je ne sais pas. J’y ai jamais pensé. Je pense que je courrai à poil autour de la Maison Blanche (rires)"},{"question":"Qui serait ton vice président ?","answer":"C’est une excellente question ! (rires) Je choisirais surement Killer Mike de Run The Jewels en tant que VP. Il sait de quoi il parle et il serait un partenaire génial avec qui partager des idées. Il saurait comment me conseiller."},{"question":"Qui serait ton éminence grise ? (ndlr : un conseiller politique qui reste dans l’ombre)","answer":"Surement mon poto Nasty, car il est juste trop intelligent."},{"question":"Que penses-tu des armes ? Devraient-elles être régularisées au US ?","answer":"Je ne crois pas que ça devrait être interdit. Je veux dire, même dans les pays où ça l’est, il y a des tireurs fous. Je ne suis pas contre, et personnellement, j’apprécie les pistolets. J’aime aller au stand de tire et shooter. Mais je n’aime pas tirer sur les gens bien sûr, j’aime juste le côté sportif du truc. Je n’ai jamais chassé et je n’aime pas l’idée qu’on tue un animal - je n’aime pas l’idée de tuer quoi que ce soit - mais voilà, pour la protection personnelle, de tes biens, de ta famille, ouais, j’y crois. On devrait respecter les lois sur le port d’arme, et les rendre plus précises aussi. Tout le monde ne peut pas avoir accès à une arme. Acheter un lance-roquette devrait être interdit par exemple. Ca devrait être comme le permis de conduire, tu le passes et tu conduis ce pour quoi tu as passé un examen."},{"question":"Si tu vivais à la Maison Blanche, tu y changerais quoi ?","answer":"Je repeindrais le tout en noir. Et je l’appellerai La Maison Noire ! (rires)"},{"question":"Il y a cette légende sur le livre secret passé de président en président. Si c’est réel, tu penses qu’il y a quoi, dedans ?","answer":"Des trucs sur les aliens (rires)"},{"question":"Et ce que tu aimerais y écrire ?","answer":"Que les aliens existent ! (rires)"}]}}

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports = {"globals":{"header":"1k Electeurs","sections":{"youth":"Early Years","pro_era":"School Days to Pro Era","badass":"1999 to B4.Da.$$","all_amerikkkan":"All amerikkkan badass","land_of_free":"Land of the free","racism":"Racism & Police Violence","engagement":"Artists Getting Involved"},"scroll":"Scroll to discover","listen":"Listen","mobile":"Check the story on your computer for a better experience."},"intro":{"bill_text":"« I'm out for dead presidents to represent me because I've never known a live one that represent me »"},"presentation":{"quote":"«Je suis pour que tout un tas de présidents morts* me représentent... parce que je n'ai jamais vu un président le faire de son vivant.»","asterix":"*dead presidents fait références aux billets de banque américains, sur lequel on retrouve les visages d'anciens présidents, aujourd'hui décédés."},"political":{"title":"Political MC","meeting":"SHOES UP met up with the guy who back in December 2012 as a fresh-faced 17-year-old, refused to sign a tantalizing contract with Jay-Z’s record label, the one and only Roc Nation. Since then, Jo-Vaughn Virginie Scott, aka Joey Bada$$, has had a flawless independent career, joining the ranks of the big boys of hip-hop. These days, Joey has drinks with Puff Daddy, smokes joints with uncle Snoop Dogg, shares the stage with A$AP Rocky and Wiz Khalifa, and has been playing sold-out shows the world over for yonks now.","today":"Now aged 22, he’s already brought out three mixtapes and two albums that many people already consider as cult classics. His latest project to date was All AmeriKKKan Bada$$ that came out April 2017. It’s a mature, socio-political album blowing a wind of rebellion against the American political landscape, pointing the finger more precisely at Donald Trump. So how did the American MC get to where he is today?","slider":{"slider_1":"These days,Joey <br />has drinks with Puff Daddy","slider_2":"smokes joints with uncle Snoop Dogg","slider_3":"share the stage with A$AP Rocky and Wiz Khalifa"}},"youth":{"title":"Early Years","text":"Born in East Flatbush in Brooklyn, New York to a Caribbean mother and Jamaican father, he grew up in the Bed Stuy neighborhood. He’s the second oldest of five, with three brothers and a sister, and the first to be born in America, as his parents previously lived in Saint Lucia.</br> When he was five, his parents separated. His family found it hard to get by financially, forcing his mother to juggle two jobs so she could provide for her children. This period of his life went on to inspire the track <a href=''>Devastated</a> which came out in 2016, and even <a href=''>Paper Trail$</<a> with its meaningful lyrics like","quote":"« I got a dollar and a dream, know what I mean? And I gotta get my mama off the scene »","translation":"« J’ai un dollar et un rêve, tu vois ? Et il faut que je sorte ma mère de là »"},"pro_era":{"title":"School Days to Pro Era","text_1":"As soon as he could hold a pen, Joey tried his hand at poetry, while being raises on a diet of Prince’s pop plus soul, reggae and hip-hop. In fact, at the age of two he knew the lyrics to <a href='https://www.youtube.com/watch?v=wk4ftn4PArg' target='blank'>Hypnotize</a> by the legendary Notorious B.I.G off by heart, spurring him to follow in Biggie’s footsteps, turning his poems into rap. From his freestyles dropped on YouTube as a 15-year-old to his homemade recording sessions (with the help of a Playstation 2 and a USB condenser mic), this helped him build his weapons and his phenomenal flow.","text_2":"His high school years at Edward R. Murrow (a public school famous for its music, theater and media programs) saw him forge friendships with other artists and aficionados, before going on to form the now famous Pro Era crew. The group of friends turned hip-hop collective originally founded by Joey Bada$$, CJ Fly, Powers Pleasant and Capital STEEZ, is today made up of 20 different musicians, producers, designers and photographers. During their rise in popularity, the crew went through a tough period of grief following the death of Capital STEEZ, who took his own life on December 24, 2012 aged just 19, and they would go on to pay homage to their friend in various ways"},"badass":{"title":"1999 to B4.Da.$$","about":"Joey’s first mixtape named 1999 came out in 2012, reaching double-platinum status. Even if his 90s influences aren’t hard to miss, the parallel rattles the rapper’s cage so much so that he no longer wants to be associated with a certain style or period, demanding to be known for his own work and not for someone else’s. In any case, his critically acclaimed work marked a turning point for a new generation of New York rappers.","between_albums":"More mixtapes soon followed, with Rejex the same year and Summer Knights in 2013. He started 2015 off by releasing his first album B4.Da.$$ (Before Da Money) on January 20 – his birthday. It featured big names like DJ Premier, Statik Selektah, Basquiat, Freddie Joachim and even The Roots and the J Dilla foundation, who offered him a never-before heard composition from the legend who left us in 2006.","badass_album_1":"The introspective album, which saw the artist unleash tracks like Christ Conscious, Paper Trail$ and Piece of Mind, is seen through the eyes of a 20-year-old black kid growing up in an America marked by white society’s riches and the difficulties often faced because of the color of one’s skin. Take the lyrics","quote_1":"“Put our backs on the fence, so we self defence, Followed by a series of unfortunate events, Looking like white America got a brother again”","traduction_1":"«Vous nous mettez le dos sur la clôture donc nous nous défendons. suivi par des séries de malheureux événements, regardez comment l’amérique blanche a retrouvé un frère»","badass_album_2":"from <a href='https://www.youtube.com/watch?v=kSob6t-amfA' target='blank'>Piece of Mind</a>, that carefully disguise his cause, while <a href='https://www.youtube.com/watch?v=MNZ8FPnnoAE' target='blank'>Black Beetles</a> has a reference to Martin Luther King and Marcus Garvey, the Jamaican activist who worked his whole life towards harmony and emancipation of the African diaspora in the United States.","quote_2":"“Who would've thought a marchin' Martin could spark a starvin' artist / Spit art, at heart young Marcus Garvey ”","author_2":"- BLACK BEETLES -","traduction_2":"«Qui aurait imaginé ce qu’un certain martin manifestant aurait suscité chez un artiste affamé / de l’art craché au jeune cœur de marcus garvey »","badass_album_3":"On February 11, 2015, Joey Bada$$ revealed the powerful video Like Me, which featured references to non-armed black Americans killed by the police, such as Michael Brown (Ferguson shooting) and Trayvon Martin, the 17-year-old killed in Florida in 2012. In fact, in the 5-minute video, we see the romantic tale turned tragedy between the rapper’s new girlfriend and her ex. The latter accidentally shoots his ex-girlfriend, who’s then killed by the cops. The unarmed Bada$$ flees, the police corner him, then shoot him – despite him having his hands in the air. While this opus has a political dimension, his political stance is made loud and clear in 2017 in his highly evocative album All AmeriKKKan Badass."},"amerikkkan":{"text":"For starters, the album title makes a reference to the Ku Klux Klan, just like Ice Cube did in April 1990 with his uber-political album AmeriKKKa’s Most Wanted. Not forgetting, five years earlier, the now deceased Pro Era crew member Capital STEEZ had already used this reference, with his first and only mixtape AmeriKKKan Korruption, aggressively attacking political and religious institutions."},"land_of_free":{"title":"Land of free","text_1":"January 20, 2017. It’s Joey’s 22nd birthday and it’s also the inauguration of the 45th president of the United States, aka Donald Trump. “The worst birthday gift ever!” he told us. That very same day, Joey Bada$$ revealed the track Land of the Free. Two months later, the unashamedly politically incorrect video dropped online and it sure hit the target hard, offering a heavy blow against the system. ","quote_1":"“The video was all my idea. We were trying to shoot something to capture the feeling and the direction of the album. It started as us just shooting for the album art and booklet, but the budget was so expensive that we decided that we needed to get a video out of it. So it was a happy mistake to be honest, but not a mistake at all, if you know what I mean,”","text_2":"he told us. As it happens, a sweet mistake from which such a poignant video was born. In the wise hands of Badmon himself and director Nathan R. Smith, we find Joey in the middle of the desert surrounded by black men in chains. Then, cut to a luscious green landscape, where he’s telling a bunch of kids with his finger raised: ","quote_2":"« Obama just wasn't enough, I just need some more closure And Donald Trump is not equipped to take this country over »","translate_2":"","text_3":"Joey claims the script to be violent and denunciatory. Police officers and men in suits coldly execute black men in chains, while another scene shows men dressed in Ku Klux Klan robes hanging a man during a morose ritual, who then remove their hoods to reveal their identities: police officers and politicians."},"racism":{"title":"Racism & Police Violence","text_1":"If the 60s were marked by racial segregation and particular barbaric extremist movements, Bada$$ doesn’t hesitate to point the finger at racism that’s still endemic today.","quote_1":"« What I can say is, of course it has gotten some what better as far as the physical violence aspect of it, but not one hundred percent better, because there are still cops and white people killing black people just because they feel like their lives are not valuable. But what I can say about today is that racism is so much more hidden. A lot of colored people’s frustration is that we experience things on a daily basis that are racist acts, but to show it to the world is the hardest thing because it’s so hidden. You know what I’m saying? You wouldn’t know unless you’re living in our shoes. Whereas before, it was something clear like “No blacks” written out, and now it’s just energy and different situations that we deal with. »","text_2":"And so, he puts himself in the position as the voice of black America frightened by not only white supremacists, but also by the lack of freedom and protection for the most vulnerable.","quote_2":"”I’m using my voice, firstly because I can, then because I’m passionate about everything I speak about and that I think is the right thing, and also because I can speak for people who can’t speak for themselves but I don’t want to be a politician, it’s not what I’m trying to be. I don’t like politics and I think politics is a pile of tricks. I don’t think the solution is in politics. Politics is control, it’s brainwashing. I think the solution is in the people because we’re under the perception that we need to be governed but really, all we need to do is govern ourselves. We have enough morals and understanding today in 2017 to do so.”","text_3":"All Amerikkkan Bada$$ not only has a multi-colored artistic dimension, with prestigious featured artists like J. Cole and Schoolboy Q, but it has an evidently clear activist, denunciatory yet pacifist undercurrent. Furthermore, this open letter to America spares nobody. Take the track <a href=''>Super Predator</a>, inspired by the controversial term used by Hilary Clinton during a speech in 1994 where she described kids who become gang members as closely linked to drug cartels and who had “no conscience, no empathy”. Even if such words were never explicitly aimed at the Afro-American community, what she said was gapingly ambiguous, and would go on to have negative consequences for her during the 2016 presidential election. Incidentally, Bernie Sanders openly considered her remarks as racist. Super Predator:","quote_group_1":[{"sentence":"She critical, exactly what made my niggas criminals","translation":"Elle critique exactement ce qui a rendu mes niggas criminels"},{"sentence":"Typical AmeriKKKa, damn sure ain’t no miracle [...] the Presidents, the Congressmen, the Senators","translation":"Typique amérikkke, putain c’est sûr qu’il n’y a pas de miracle [...] les présidents, les hommes du congrès, les sénateurs"},{"sentence":"Who got us slavin’ while they reapin’ all the benefits","translation":"Qui nous réduisent en esclavage tandis qu’ils tirent tous les bénéfices"},{"sentence":"Got the world thinkin’ that it’s true ‘bout what they said for us","translation":"PErsuadent le monde à penser que ce qu’ils nous ont dit était vrai"}],"quote_group_2":[{"sentence":"The government been tryna take away what’s ours","translation":"Le gouvernement a essayé de s’emparer de ce qui nous appartient"},{"sentence":"It’s really all about the money and the power","translation":"Tout est vraiment une question d’argent et de pouvoir"},{"sentence":"I just wanna see my people empowered","translation":"J’aimerais juste que mon peuple ne soit plus sous cette emprise"}],"text_4":"For that matter, Badmon doesn’t hold back on the track Temptation, putting into the spotlight the moving speech from Zianna Oliphant. The nine-year-old girl gave the testimony in congress following the death of Keith Lamont Scott, who was killed by a police officer in Charlotte, North Carolina."},"engagement":{"title":"Artists Getting Involved","text_1":"With this album, Joey Bada$$ “wants to make music that’ll make the future a better place”, with high hopes that things will change. As many socially engaged artists act in the fight against racism and the system, 22-year-old MC has got involved, playing his part. “I think it’s very important when you have the platform because you have the opportunity to speak for people who can’t speak for themselves.”","text_2":"In fact, in the opening track Good Morning Amerikkka, the rapper directly addresses the American public, telling them to ","quote_1":"« Wake Up, Wake Up, I said wake up »","translation_1":"« Réveillez vous, réveillez vous, j’ai dit réveillez vous »","quote_2":"« I’d like for people to wake up to the reality of what’s going on today. From brainwashing to propaganda, to the war on blacks, to the war on terrorists, to everything »","sentence":"he grieves.","text_3":"Just like Tupac, Public Enemy, Nas and even Eminem once did, today’s hip-hop stars are rising up: Kendrick Lamar is settling scores with America in his album DAMN; Beyoncé is standing up for the feminist struggle and Black Power in “Formation”; and Jay-Z is highlighting social and racial divides in “The Story of O.J” plus his parody of Friends featuring Afro-American actors.","text_4":"As recent events see the gap widen between American communities, All Amerikkkan Bada$$ suddenly takes on its full meaning. We’re living in a time when former Ku Klux Klan leader David Duke fully endorses Donald Trump. When far-right rallies turn into tragedy, when a 32-year-old anti-racist activist was killed as a white supremacist rammed their car into the crowd, injuring around 20 others. When hate groups are not only far from having disappeared but declare their intentions loud and clear, with no risk involved. Protected by the First Amendment of the Constitution, the Government turns a blind eye.  ","text_left_1":"In 2015, <span>Barack Obama’s daughter Malia</span> was snapped on Instagram wearing none other than a Pro Era crew T shirt!","text_left_2":"In 2016, Joey Bada$$ was lined up to play Barack Obama’s best friend in a biopic entitled “Barry”. However, he declined the role so he could play Coachella instead. ","text_left_3":"In 2017, Bada$$ shared his views on the mandate 44th American president via Genius. "},"program":{"title":"<span>Joey's</span> <span>program</span>","questions":[{"question":"If you were president, what would be one of the first things you would like to do?","answer":"Mmmm I dunno. I haven’t really thought about it. I’d probably run around the White House naked! (laughs)"},{"question":"Who would you choose as a vice president?","answer":"That’s an incredibly good question! (laughs) I’d probably choose Killer Mike from Run the Jewels as my VP, just because he’s up on shit like that and I think he’d make a great partner to go to and discuss ideas with. He’d know the right things for me to do."},{"question":"Who could be your eminence grise? (Ed. A political advisor who remains in the shadows)","answer":"Probably my guy Nasty because he’s just got a mad knowledge."},{"question":"What do you think about guns? Should they be allowed in America?","answer":"I don't think guns should be forbidden. I mean look at the countries where it's forbidden, there are still gunmen attacks that happen. I'm not against people owning guns. Me personally, I like guns. I like going to the gun range and shooting, I mean I don't like shooting people of course! I just like the sport aspect of it. I never hunted, I don’t like the idea of killing animals - I don't like the idea of killing anything - but you know, guns for self protection, to protect your property, your family, I do believe in these things. There should be gun laws in effect of course, saying what you can and cannot do, like everyone shouldn’t have access to any gun. Like, you shouldn’t be able to go and buy a rocket launcher. It should be like driving: you apply for a license and you have to qualify. "},{"question":"If you decided to live in the White house, what would you change?","answer":"I’d paint it black. We’d call it the black house! (laughs)"},{"question":"There’s a legend about a secret book that is passed on from president to president. If this book was real, what do you think you’d find inside?","answer":"Information on aliens! (laughs)"},{"question":"And what would you like to write in the book? ","answer":"Aliens are real! (laughs)"}]}}

/***/ })
],[185]);


// WEBPACK FOOTER //
// main.a3c37fd8804992df0b5e.js